// const S10 = "https://bawamasalacompany.com/assets/images/Spices/10b.png"
const S19 = "https://bawamasalacompany.com/assets/images/Spices/19b.png";
const S18 = "https://bawamasalacompany.com/assets/images/Spices/18b.png";
const S17 = "https://bawamasalacompany.com/assets/images/Spices/17b.png";
const S16 = "https://bawamasalacompany.com/assets/images/Spices/16b.png";
const S15 = "https://bawamasalacompany.com/assets/images/Spices/15b.png";
const S14 = "https://bawamasalacompany.com/assets/images/Spices/14b.png";
const S13 = "https://bawamasalacompany.com/assets/images/Spices/13b.png";
// const S12 = "https://bawamasalacompany.com/assets/images/Spices/12b.png"
const S11 = "https://bawamasalacompany.com/assets/images/Spices/11b.png";
const S20 = "https://bawamasalacompany.com/assets/images/Spices/20b.png";
const S29 = "https://bawamasalacompany.com/assets/images/Spices/29b.png";
const S28 = "https://bawamasalacompany.com/assets/images/Spices/28b.png";
const S27 = "https://bawamasalacompany.com/assets/images/Spices/27b.png";
const S26 = "https://bawamasalacompany.com/assets/images/Spices/26b.png";
const S25 = "https://bawamasalacompany.com/assets/images/Spices/25b.png";
const S24 = "https://bawamasalacompany.com/assets/images/Spices/24b.png";
const S23 = "https://bawamasalacompany.com/assets/images/Spices/23b.png";
const S22 = "https://bawamasalacompany.com/assets/images/Spices/22b.png";
// const S21 = "https://bawamasalacompany.com/assets/images/Spices/21b.png"
const S30 = "https://bawamasalacompany.com/assets/images/Spices/30b.png";
const S39 = "https://bawamasalacompany.com/assets/images/Spices/39b.png";
const S38 = "https://bawamasalacompany.com/assets/images/Spices/38b.png";
const S37 = "https://bawamasalacompany.com/assets/images/Spices/37b.png";
const S36 = "https://bawamasalacompany.com/assets/images/Spices/36b.png";
const S35 = "https://bawamasalacompany.com/assets/images/Spices/35b.png";
const S34 = "https://bawamasalacompany.com/assets/images/Spices/34b.png";
const S33 = "https://bawamasalacompany.com/assets/images/Spices/33b.png";
const S32 = "https://bawamasalacompany.com/assets/images/Spices/32b.png";
const S31 = "https://bawamasalacompany.com/assets/images/Spices/31b.png";
const S40 = "https://bawamasalacompany.com/assets/images/Spices/40b.png";
const S49 = "https://bawamasalacompany.com/assets/images/Spices/49.png";
const S48 = "https://bawamasalacompany.com/assets/images/Spices/48.png";
const S47 = "https://bawamasalacompany.com/assets/images/Spices/46b.png";
// const S46 = "https://bawamasalacompany.com/assets/images/Spices/46b.png"
const S45 = "https://bawamasalacompany.com/assets/images/Spices/44b.png";
// const S44 = "https://bawamasalacompany.com/assets/images/Spices/44b.png"
// const S43 = "https://bawamasalacompany.com/assets/images/Spices/43b.png"
const S42 = "https://bawamasalacompany.com/assets/images/Spices/42b.png";
// const S41 = "https://bawamasalacompany.com/assets/images/Spices/41b.png"
const S50 = "https://bawamasalacompany.com/assets/images/Spices/50b.png";
const S59 = "https://bawamasalacompany.com/assets/images/Spices/59b.png";
const S58 = "https://bawamasalacompany.com/assets/images/Spices/58b.png";
const S57 = "https://bawamasalacompany.com/assets/images/Spices/57b.png";
const S56 = "https://bawamasalacompany.com/assets/images/Spices/56b.png";
// const S55 = "https://bawamasalacompany.com/assets/images/Spices/55b.png"
const S54 = "https://bawamasalacompany.com/assets/images/Spices/54b.png";
// const S53 = "https://bawamasalacompany.com/assets/images/Spices/53b.png"
const S52 = "https://bawamasalacompany.com/assets/images/Spices/52b.png";
// const S51 = "https://bawamasalacompany.com/assets/images/Spices/51b.png"
const S60 = "https://bawamasalacompany.com/assets/images/Spices/60b.png";
const S69 = "https://bawamasalacompany.com/assets/images/Spices/69b.png";
const S68 = "https://bawamasalacompany.com/assets/images/Spices/68b.png";
const S67 = "https://bawamasalacompany.com/assets/images/Spices/67b.png";
const S66 = "https://bawamasalacompany.com/assets/images/Spices/66b.png";
const S65 = "https://bawamasalacompany.com/assets/images/Spices/65b.png";
const S64 = "https://bawamasalacompany.com/assets/images/Spices/64b.png";
const S63 = "https://bawamasalacompany.com/assets/images/Spices/63b.png";
const S62 = "https://bawamasalacompany.com/assets/images/Spices/62b.png";
const S61 = "https://bawamasalacompany.com/assets/images/Spices/61b.png";
const S70 = "https://bawamasalacompany.com/assets/images/Spices/70b.png";
const S72 = "https://bawamasalacompany.com/assets/images/Spices/72b.png";
// const S71 = "https://bawamasalacompany.com/assets/images/Spices/71b.png"
const S1 = "https://bawamasalacompany.com/assets/images/Spices/1b.png";
const S2 = "https://bawamasalacompany.com/assets/images/Spices/2b.png";
const S3 = "https://bawamasalacompany.com/assets/images/Spices/3b.png";
const S4 = "https://bawamasalacompany.com/assets/images/Spices/4b.png";
const S5 = "https://bawamasalacompany.com/assets/images/Spices/5b.png";
const S6 = "https://bawamasalacompany.com/assets/images/Spices/6b.png";
const S7 = "https://bawamasalacompany.com/assets/images/Spices/7b.png";
const S8 = "https://bawamasalacompany.com/assets/images/Spices/8b.png";
const S9 = "https://bawamasalacompany.com/assets/images/Spices/9b.png";
const S73 = "https://bawamasalacompany.com/assets/images/Spices/anardana-powder-50g-b-1.png";
const S74 = "https://bawamasalacompany.com/assets/images/Spices/anardana-powder-100g-b-1.png";
const S75 = "https://bawamasalacompany.com/assets/images/Spices/chana-masala-15g-b-1.png";
const S76 = "https://bawamasalacompany.com/assets/images/Spices/biryani-masala-15g-b-1.png";
const S77 = "https://bawamasalacompany.com/assets/images/Spices/biryani-masala-50g-b-1.png";
const S78 = "https://bawamasalacompany.com/assets/images/Spices/chana-masala-15g-b-1.png";
const S79 = "https://bawamasalacompany.com/assets/images/Spices/chana-masala-500g-b-1.png";
const S80 = "https://bawamasalacompany.com/assets/images/Spices/chat-masala-15g-b-1.png";
const S81 = "https://bawamasalacompany.com/assets/images/Spices/chat-masala-500g-b-1.png";
const S82 = "https://bawamasalacompany.com/assets/images/Spices/chick-mas-15g-b-1.png";
const S83 = "https://bawamasalacompany.com/assets/images/Spices/dal-makhni-100g-b-1.png";
const S84 = "https://bawamasalacompany.com/assets/images/Spices/garam-masala-15g-b-1.png";
const S85 = "https://bawamasalacompany.com/assets/images/Spices/garam-masala-25g-b-1.png";
const S86 = "https://bawamasalacompany.com/assets/images/Spices/garam-masala-500g-b-1.png";
// const S87 = "https://bawamasalacompany.com/assets/images/Spices/kasoori-methi-powder-25g-b-1.png"
const S88 = "https://bawamasalacompany.com/assets/images/Spices/kasoori-methi-powder-250g-b-1.png";
const S89 = "https://bawamasalacompany.com/assets/images/Spices/kitchen-king-15g-b-1.png";
// const S90 = "https://bawamasalacompany.com/assets/images/Spices/kitchen-king-100g-b-1.png"
const S91 = "https://bawamasalacompany.com/assets/images/Spices/kitchen-king-500g-b-1.png";
const S92 = "https://bawamasalacompany.com/assets/images/Spices/ksshmiri-mirch-15g-b-1.png";
// const S93 = "https://bawamasalacompany.com/assets/images/Spices/metmas-15g-b-1.png"
const S94 = "https://bawamasalacompany.com/assets/images/Spices/pani-puri-masala-100g-b-1.png";
const S95 = "https://bawamasalacompany.com/assets/images/Spices/pudina-patta-25g-b-1.png";
const S96 = "https://bawamasalacompany.com/assets/images/Spices/rogini-mirch-500g-b-1.png";
const S97 = "https://bawamasalacompany.com/assets/images/Spices/shahi-paneer-masala-15g-b-1.png";
const S98 = "https://bawamasalacompany.com/assets/images/Spices/sounf-badian-powder-500g-b-1.png";
const S99 = "https://bawamasalacompany.com/assets/images/Spices/soya-dish-100g-b-1.png";
const S100 = "https://bawamasalacompany.com/assets/images/Spices/soya-dish-200g-b-1.png";
const S101 = "https://bawamasalacompany.com/assets/images/Spices/special-meat-masala-15g-b-1.png";
const S102 = "https://bawamasalacompany.com/assets/images/Spices/special-meat-masala-25g-b-1.png";
const S103 = "https://bawamasalacompany.com/assets/images/Spices/special-meat-masala-200g-b-1.png";
const S104 = "https://bawamasalacompany.com/assets/images/Spices/special-meat-masala-500g-b-1.png";
// const S105 = "https://bawamasalacompany.com/assets/images/Spices/tast-n-tast-20g-b-1.png"
const S106 = "https://bawamasalacompany.com/assets/images/Spices/teamas-25g-b-1.png";
const S107 = "https://bawamasalacompany.com/assets/images/Spices/black-pepper-powder-8g-b-1.png";
// const S108 = "https://bawamasalacompany.com/assets/images/Spices/chana-masala-100g-b-1.png"
const S109 = "https://bawamasalacompany.com/assets/images/Spices/chat-masala-50g-b-1.png";
// const S110 = "https://bawamasalacompany.com/assets/images/Spices/chat-masala-100g-b-1.png"
const S111 = "https://bawamasalacompany.com/assets/images/Spices/chick-mas-25g-b-1.png";
const S112 = "https://bawamasalacompany.com/assets/images/Spices/chick-mas-50g-b-1.png";
// const S113 = "https://bawamasalacompany.com/assets/images/Spices/chick-mas-100g-b-1.png"
const S114 = "https://bawamasalacompany.com/assets/images/Spices/chowmwin-masala-50g-b-1.png";
const S115 = "https://bawamasalacompany.com/assets/images/Spices/dahi-vada-masala-50g-b-1.png";
const S116 = "https://bawamasalacompany.com/assets/images/Spices/dahi-vada-masala-100g-b-1.png";
// const S117 = "https://bawamasalacompany.com/assets/images/Spices/dalchini-powder-50g-b-1.png"
const S118 = "https://bawamasalacompany.com/assets/images/Spices/debby-mirch-100g-b-1.png";
const S119 = "https://bawamasalacompany.com/assets/images/Spices/dhania-powder-100g-b-1.png";
const S120 = "https://bawamasalacompany.com/assets/images/Spices/dry-mango-powder-amchoor-50g-b-1.png";
const S121 = "https://bawamasalacompany.com/assets/images/Spices/fish-masala-50g-b-1.png";
const S122 = "https://bawamasalacompany.com/assets/images/Spices/garam-masala-50g-b-1.png";
const S123 = "https://bawamasalacompany.com/assets/images/Spices/ginger-powder-50g-b-1.png";
const S124 = "https://bawamasalacompany.com/assets/images/Spices/ginger-powder-100g-b-1.png";
const S125 = "https://bawamasalacompany.com/assets/images/Spices/haldi-powder-50g-b-1.png";
const S126 = "https://bawamasalacompany.com/assets/images/Spices/jal-jeera-100g-b-1.png";
const S127 = "https://bawamasalacompany.com/assets/images/Spices/kitchen-king-50g-b-1.png";
const S128 = "https://bawamasalacompany.com/assets/images/Spices/ksshmiri-mirch-50g-b-1.png";
const S129 = "https://bawamasalacompany.com/assets/images/Spices/metmas-50g-b-1.png";
const S130 = "https://bawamasalacompany.com/assets/images/Spices/metmas-100g-b-1.png";
// const S131 = "https://bawamasalacompany.com/assets/images/Spices/mirch-powder-100g-b-1.png"
const S132 = "https://bawamasalacompany.com/assets/images/Spices/mohini-garam-masala-15g-b-1.png";
const S133 = "https://bawamasalacompany.com/assets/images/Spices/mohini-garam-masala-50g-b-1.png";
const S134 = "https://bawamasalacompany.com/assets/images/Spices/momo-masala-50g-b-1.png";
const S135 = "https://bawamasalacompany.com/assets/images/Spices/pani-puri-masala-100g-b-1.png";
const S136 = "https://bawamasalacompany.com/assets/images/Spices/pav-bhaji-masala-50g-b-1.png";
// const S137 = "https://bawamasalacompany.com/assets/images/Spices/rai-powder-100g-b-1.png"
const S138 = "https://bawamasalacompany.com/assets/images/Spices/sabzi-masala-15g-b-1.png";
const S139 = "https://bawamasalacompany.com/assets/images/Spices/sabzi-masala-50g-b-1.png";
const S140 = "https://bawamasalacompany.com/assets/images/Spices/samber-powder-50g-b-1.png";
const S141 = "https://bawamasalacompany.com/assets/images/Spices/shahi-paneer-masala-50g-b-1.png";
// const S142 = "https://bawamasalacompany.com/assets/images/Spices/shahi-paneer-masala-100g-b-1.png"
const S143 = "https://bawamasalacompany.com/assets/images/Spices/sounf-badian-powder-50g-b-1.png";
const S144 = "https://bawamasalacompany.com/assets/images/Spices/special-meat-masala-50g-b-1.png";
// const S145 = "https://bawamasalacompany.com/assets/images/Spices/special-meat-masala-100g-b-1.png"
// const S146 = "https://bawamasalacompany.com/assets/images/Spices/tandoori-chicken-masala-50g-b-1.png"
const S147 = "https://bawamasalacompany.com/assets/images/Spices/tandoori-chicken-masala-100g-b-1.png";
const S148 = "https://bawamasalacompany.com/assets/images/Spices/white-pepper-powder-50g-b-1.png";
const S149 = "https://bawamasalacompany.com/assets/images/Spices/zeera-powder-50g-b-1.png";
// const S150 = "https://bawamasalacompany.com/assets/images/Spices/biryani-pulao-masala-100g-b-1.png"
const S151 = "https://bawamasalacompany.com/assets/images/Spices/black-pepper-powder-50g-b-1.png";
// const S152 = "https://bawamasalacompany.com/assets/images/Spices/black-pepper-powder-100g-b-1.png"
const S153 = "https://bawamasalacompany.com/assets/images/Spices/chana-masala-50g-b-1.png";
// const S154 = "https://bawamasalacompany.com/assets/images/Spices/chutney-podina-powder-100g-b-1.png"
// const S155 = "https://bawamasalacompany.com/assets/images/Spices/curry-powder-50g-b-1.png"
const S156 = "https://bawamasalacompany.com/assets/images/Spices/curry-powder-100g-b-1.png";
// const S157 = "https://bawamasalacompany.com/assets/images/Spices/dry-mango-powder-amchoor-100g-b-1.png"
// const S158 = "https://bawamasalacompany.com/assets/images/Spices/fish-masala-100g-b-1.png"
// const S159 = "https://bawamasalacompany.com/assets/images/Spices/garam-masala-100g-b-1.png"
// const S160 = "https://bawamasalacompany.com/assets/images/Spices/haldi-powder-100g-b-1.png"
// const S161 = "https://bawamasalacompany.com/assets/images/Spices/hing-compound-10g-b-1.png"
// const S162 = "https://bawamasalacompany.com/assets/images/Spices/jal-jeera-50g-b-1.png"
// const S163 = "https://bawamasalacompany.com/assets/images/Spices/ksshmiri-mirch-100g-b-1.png"
// const S164 = "https://bawamasalacompany.com/assets/images/Spices/mohini-garam-masala-100g-b-1.png"
// const S165 = "https://bawamasalacompany.com/assets/images/Spices/momo-masala-100g-b-1.png"
// const S166 = "https://bawamasalacompany.com/assets/images/Spices/mutton-masala-100g-b-1.png"
// const S167 = "https://bawamasalacompany.com/assets/images/Spices/pav-bhaji-masala-100g-b-1.png"
// const S168 = "https://bawamasalacompany.com/assets/images/Spices/pulao-masala-100g-b-1.png"
// const S169 = "https://bawamasalacompany.com/assets/images/Spices/rayta-masala-100g-b-1.png"
const S170 = "https://bawamasalacompany.com/assets/images/Spices/rogini-mirch-50g-b-1.png";
// const S171 = "https://bawamasalacompany.com/assets/images/Spices/rogini-mirch-100g-b-1.png"
// const S172 = "https://bawamasalacompany.com/assets/images/Spices/sabzi-masala-100g-b-1.png"
// const S173 = "https://bawamasalacompany.com/assets/images/Spices/samber-masala-100g-b-1.png"
// const S174 = "https://bawamasalacompany.com/assets/images/Spices/samber-masala-100g-new-pack-b-1.png"
// const S175 = "https://bawamasalacompany.com/assets/images/Spices/sounf-badian-powder-100g-b-1.png"
// const S176 = "https://bawamasalacompany.com/assets/images/Spices/special-rajmah-masala-15g-b-1.png"
// const S177 = "https://bawamasalacompany.com/assets/images/Spices/special-rajmah-masala-50g-b-1.png"
// const S178 = "https://bawamasalacompany.com/assets/images/Spices/special-rajmah-masala-100g-b-1.png"
// const S179 = "https://bawamasalacompany.com/assets/images/Spices/white-pepper-powder-100g-b-1.png"
// const S180 = "https://bawamasalacompany.com/assets/images/Spices/zeera-powder-100g-b-1.png"
const S181 = "https://bawamasalacompany.com/assets/images/Spices/black-salt-100g-p-1.png";
const S182 = "https://bawamasalacompany.com/assets/images/Spices/black-salt-250g-p-1.png";
const S183 = "https://bawamasalacompany.com/assets/images/Spices/dhania-powder-1kg-p-1.png";
const S184 = "https://bawamasalacompany.com/assets/images/Spices/dhania-powder-5kg-p-1.png";
const S185 = "https://bawamasalacompany.com/assets/images/Spices/dhania-powder-20g-p-1.png";
const S186 = "https://bawamasalacompany.com/assets/images/Spices/dhania-powder-30g-p-1.png";
const S187 = "https://bawamasalacompany.com/assets/images/Spices/dhania-powder-200g-p-1.png";
const S188 = "https://bawamasalacompany.com/assets/images/Spices/dhania-powder-500g-p-1.png";
// const S189 = "https://bawamasalacompany.com/assets/images/Spices/garam-masala-8g-p-1.png.png"
const S190 = "https://bawamasalacompany.com/assets/images/Spices/haldi-powder-1kg-1.png";
const S191 = "https://bawamasalacompany.com/assets/images/Spices/haldi-powder-5kg-1.png";
const S192 = "https://bawamasalacompany.com/assets/images/Spices/haldi-powder-30g-p-1.png";
// const S193 = "https://bawamasalacompany.com/assets/images/Spices/haldi-powder-50g-p-1.png"
const S194 = "https://bawamasalacompany.com/assets/images/Spices/haldi-powder-200g-p-1.png";
const S195 = "https://bawamasalacompany.com/assets/images/Spices/haldi-powder-500g-p-1.png";
const S196 = "https://bawamasalacompany.com/assets/images/Spices/kuti-mirch-100g-p-1.png";
const S197 = "https://bawamasalacompany.com/assets/images/Spices/mirch-powder-1kg-p-1.png";
const S198 = "https://bawamasalacompany.com/assets/images/Spices/mirch-powder-5kg-p-1.png";
const S199 = "https://bawamasalacompany.com/assets/images/Spices/mirch-powder-30g-p-1.png";
const S200 = "https://bawamasalacompany.com/assets/images/Spices/mirch-powder-50g-p-1.png";
const S201 = "https://bawamasalacompany.com/assets/images/Spices/mirch-powder-200g-p-1.png";
const S202 = "https://bawamasalacompany.com/assets/images/Spices/mirch-powder-500g-p-1.png";
// const S203 = "https://bawamasalacompany.com/assets/images/Spices/rock-salt-250g-p-1.png"
// const S204 = "https://bawamasalacompany.com/assets/images/Spices/zeera-whole-100g-p-1.png"
const S205 = "https://bawamasalacompany.com/assets/images/Spices/haldi-powder-50g-p-1.png";
const S206 = "https://bawamasalacompany.com/assets/images/Spices/special-rajmah-masala-15g-b-1.png";
const S207 = "https://bawamasalacompany.com/assets/images/Spices/special-rajmah-masala-50g-b-1.png";
const S208 = "https://bawamasalacompany.com/assets/images/Spices/sabzi-masala-100g-b-1.png";
const S209 = "https://bawamasalacompany.com/assets/images/Spices/zeera-powder-100g-b-1.png";
const S210 = "https://bawamasalacompany.com/assets/images/Spices/ajowain-whole-100g-p-1.png";
const S211 = "https://bawamasalacompany.com/assets/images/Spices/kasoori-methi-powder-50g-p-1.png";
const S212 = "https://bawamasalacompany.com/assets/images/Spices/kasoori-methi-powder-100g-p-1.png";
const S213 = "https://bawamasalacompany.com/assets/images/Spices/kasoori-methi-powder-500g-b-1.png";
const S214 = "https://bawamasalacompany.com/assets/images/Spices/soya-dish-chura-200g-b-1.png";

// backFlip
// const SH10 = "https://bawamasalacompany.com/assets/images/Spices/10.png"
const SH19 = "https://bawamasalacompany.com/assets/images/Spices/19.png";
const SH18 = "https://bawamasalacompany.com/assets/images/Spices/18.png";
const SH17 = "https://bawamasalacompany.com/assets/images/Spices/17.png";
const SH16 = "https://bawamasalacompany.com/assets/images/Spices/16.png";
const SH15 = "https://bawamasalacompany.com/assets/images/Spices/15.png";
const SH14 = "https://bawamasalacompany.com/assets/images/Spices/14.png";
const SH13 = "https://bawamasalacompany.com/assets/images/Spices/13.png";
// const SH12 = "https://bawamasalacompany.com/assets/images/Spices/12.png"
const SH11 = "https://bawamasalacompany.com/assets/images/Spices/11.png";
const SH20 = "https://bawamasalacompany.com/assets/images/Spices/20.png";
const SH29 = "https://bawamasalacompany.com/assets/images/Spices/29.png";
const SH28 = "https://bawamasalacompany.com/assets/images/Spices/28.png";
const SH27 = "https://bawamasalacompany.com/assets/images/Spices/27.png";
const SH26 = "https://bawamasalacompany.com/assets/images/Spices/26.png";
const SH25 = "https://bawamasalacompany.com/assets/images/Spices/25.png";
const SH24 = "https://bawamasalacompany.com/assets/images/Spices/24.png";
const SH23 = "https://bawamasalacompany.com/assets/images/Spices/23.png";
const SH22 = "https://bawamasalacompany.com/assets/images/Spices/22.png";
// const SH21 = "https://bawamasalacompany.com/assets/images/Spices/21.png"
const SH30 = "https://bawamasalacompany.com/assets/images/Spices/30.png";
const SH39 = "https://bawamasalacompany.com/assets/images/Spices/39.png";
const SH38 = "https://bawamasalacompany.com/assets/images/Spices/38.png";
const SH37 = "https://bawamasalacompany.com/assets/images/Spices/37.png";
const SH36 = "https://bawamasalacompany.com/assets/images/Spices/36.png";
const SH35 = "https://bawamasalacompany.com/assets/images/Spices/35.png";
const SH34 = "https://bawamasalacompany.com/assets/images/Spices/34.png";
const SH33 = "https://bawamasalacompany.com/assets/images/Spices/33.png";
const SH32 = "https://bawamasalacompany.com/assets/images/Spices/32.png";
const SH31 = "https://bawamasalacompany.com/assets/images/Spices/31.png";
const SH40 = "https://bawamasalacompany.com/assets/images/Spices/40.png";
const SH49 = "https://bawamasalacompany.com/assets/images/Spices/49.png";
const SH48 = "https://bawamasalacompany.com/assets/images/Spices/48.png";
const SH47 = "https://bawamasalacompany.com/assets/images/Spices/46.png";
// const SH46 = "https://bawamasalacompany.com/assets/images/Spices/46.png"
const SH45 = "https://bawamasalacompany.com/assets/images/Spices/44.png";
// const SH44 = "https://bawamasalacompany.com/assets/images/Spices/44.png"
// const SH43 = "https://bawamasalacompany.com/assets/images/Spices/43.png"
const SH42 = "https://bawamasalacompany.com/assets/images/Spices/42.png";
// const SH41 = "https://bawamasalacompany.com/assets/images/Spices/41.png"
const SH50 = "https://bawamasalacompany.com/assets/images/Spices/50.png";
const SH59 = "https://bawamasalacompany.com/assets/images/Spices/59.png";
const SH58 = "https://bawamasalacompany.com/assets/images/Spices/58.png";
const SH57 = "https://bawamasalacompany.com/assets/images/Spices/57.png";
const SH56 = "https://bawamasalacompany.com/assets/images/Spices/56.png";
// const SH55 = "https://bawamasalacompany.com/assets/images/Spices/55.png"
const SH54 = "https://bawamasalacompany.com/assets/images/Spices/54.png";
// const SH53 = "https://bawamasalacompany.com/assets/images/Spices/53.png"
const SH52 = "https://bawamasalacompany.com/assets/images/Spices/52.png";
// const SH51 = "https://bawamasalacompany.com/assets/images/Spices/51.png"
const SH60 = "https://bawamasalacompany.com/assets/images/Spices/60.png";
const SH69 = "https://bawamasalacompany.com/assets/images/Spices/69.png";
const SH68 = "https://bawamasalacompany.com/assets/images/Spices/68.png";
const SH67 = "https://bawamasalacompany.com/assets/images/Spices/67.png";
const SH66 = "https://bawamasalacompany.com/assets/images/Spices/66.png";
const SH65 = "https://bawamasalacompany.com/assets/images/Spices/65.png";
const SH64 = "https://bawamasalacompany.com/assets/images/Spices/64.png";
const SH63 = "https://bawamasalacompany.com/assets/images/Spices/63.png";
const SH62 = "https://bawamasalacompany.com/assets/images/Spices/62.png";
const SH61 = "https://bawamasalacompany.com/assets/images/Spices/61.png";
const SH70 = "https://bawamasalacompany.com/assets/images/Spices/70.png";
const SH72 = "https://bawamasalacompany.com/assets/images/Spices/72.png";
// const SH71 = "https://bawamasalacompany.com/assets/images/Spices/71.png"
const SH1 = "https://bawamasalacompany.com/assets/images/Spices/1.png";
const SH2 = "https://bawamasalacompany.com/assets/images/Spices/2.png";
const SH3 = "https://bawamasalacompany.com/assets/images/Spices/3.png";
const SH4 = "https://bawamasalacompany.com/assets/images/Spices/4.png";
const SH5 = "https://bawamasalacompany.com/assets/images/Spices/5.png";
const SH6 = "https://bawamasalacompany.com/assets/images/Spices/6.png";
const SH7 = "https://bawamasalacompany.com/assets/images/Spices/7.png";
const SH8 = "https://bawamasalacompany.com/assets/images/Spices/8.png";
const SH9 = "https://bawamasalacompany.com/assets/images/Spices/9.png";
const SH73 = "https://bawamasalacompany.com/assets/images/Spices/anardana-powder-50g-b-2.png";
const SH74 = "https://bawamasalacompany.com/assets/images/Spices/anardana-powder-100g-b-2.png";
const SH75 = "https://bawamasalacompany.com/assets/images/Spices/chana-masala-15g-b-2.png";
// const SH76 = "https://bawamasalacompany.com/assets/images/Spices/biryani-masala-15g-b-2.png"
// const SH77 = "https://bawamasalacompany.com/assets/images/Spices/biryani-masala-50g-b-2.png"
// const SH78 = "https://bawamasalacompany.com/assets/images/Spices/chana-masala-15g-b-2.png"
const SH79 = "https://bawamasalacompany.com/assets/images/Spices/chana-masala-500g-b-2.png";
const SH80 = "https://bawamasalacompany.com/assets/images/Spices/chat-masala-15g-b-2.png";
const SH81 = "https://bawamasalacompany.com/assets/images/Spices/chat-masala-500g-b-2.png";
const SH82 = "https://bawamasalacompany.com/assets/images/Spices/chick-mas-15g-b-2.png";
const SH83 = "https://bawamasalacompany.com/assets/images/Spices/dal-makhni-100g-b-2.png";
const SH84 = "https://bawamasalacompany.com/assets/images/Spices/garam-masala-15g-b-2.png";
const SH85 = "https://bawamasalacompany.com/assets/images/Spices/garam-masala-25g-b-2.png";
const SH86 = "https://bawamasalacompany.com/assets/images/Spices/garam-masala-500g-b-2.png";
// const SH87 = "https://bawamasalacompany.com/assets/images/Spices/kasoori-methi-powder-25g-b-2.png"
const SH88 = "https://bawamasalacompany.com/assets/images/Spices/kasoori-methi-powder-250g-b-2.png";
const SH89 = "https://bawamasalacompany.com/assets/images/Spices/kitchen-king-15g-b-2.png";
// const SH90 = "https://bawamasalacompany.com/assets/images/Spices/kitchen-king-100g-b-2.png"
const SH91 = "https://bawamasalacompany.com/assets/images/Spices/kitchen-king-500g-b-2.png";
const SH92 = "https://bawamasalacompany.com/assets/images/Spices/ksshmiri-mirch-15g-b-2.png";
// const SH93 = "https://bawamasalacompany.com/assets/images/Spices/metmas-15g-b-2.png"
// const SH94 = "https://bawamasalacompany.com/assets/images/Spices/pani-puri-masala-100g-b-2.png"
const SH95 = "https://bawamasalacompany.com/assets/images/Spices/pudina-patta-25g-b-2.png";
const SH96 = "https://bawamasalacompany.com/assets/images/Spices/rogini-mirch-500g-b-2.png";
const SH97 = "https://bawamasalacompany.com/assets/images/Spices/shahi-paneer-masala-15g-b-2.png";
const SH98 = "https://bawamasalacompany.com/assets/images/Spices/sounf-badian-powder-500g-b-2.png";
const SH99 = "https://bawamasalacompany.com/assets/images/Spices/soya-dish-100g-b-2.png";
const SH100 = "https://bawamasalacompany.com/assets/images/Spices/soya-dish-200g-b-2.png";
const SH101 = "https://bawamasalacompany.com/assets/images/Spices/special-meat-masala-15g-b-2.png";
const SH102 = "https://bawamasalacompany.com/assets/images/Spices/special-meat-masala-25g-b-2.png";
const SH103 = "https://bawamasalacompany.com/assets/images/Spices/special-meat-masala-200g-b-2.png";
const SH104 = "https://bawamasalacompany.com/assets/images/Spices/special-meat-masala-500g-b-2.png";
// const SH105 = "https://bawamasalacompany.com/assets/images/Spices/tast-n-tast-20g-b-2.png"
const SH106 = "https://bawamasalacompany.com/assets/images/Spices/teamas-25g-b-2.png";
const SH107 = "https://bawamasalacompany.com/assets/images/Spices/black-pepper-powder-8g-b-2.png";
// const SH108 = "https://bawamasalacompany.com/assets/images/Spices/chana-masala-100g-b-2.png"
const SH109 = "https://bawamasalacompany.com/assets/images/Spices/chat-masala-50g-b-2.png";
// const SH110 = "https://bawamasalacompany.com/assets/images/Spices/chat-masala-100g-b-2.png"
const SH111 = "https://bawamasalacompany.com/assets/images/Spices/chick-mas-25g-b-2.png";
const SH112 = "https://bawamasalacompany.com/assets/images/Spices/chick-mas-50g-b-2.png";
// const SH113 = "https://bawamasalacompany.com/assets/images/Spices/chick-mas-100g-b-2.png"
const SH114 = "https://bawamasalacompany.com/assets/images/Spices/chowmwin-masala-50g-b-2.png";
const SH115 = "https://bawamasalacompany.com/assets/images/Spices/dahi-vada-masala-50g-b-2.png";
const SH116 = "https://bawamasalacompany.com/assets/images/Spices/dahi-vada-masala-100g-b-2.png";
// const SH117 = "https://bawamasalacompany.com/assets/images/Spices/dalchini-powder-50g-b-2.png"
const SH118 = "https://bawamasalacompany.com/assets/images/Spices/debby-mirch-100g-b-2.png";
const SH119 = "https://bawamasalacompany.com/assets/images/Spices/dhania-powder-100g-b-2.png";
const SH120 = "https://bawamasalacompany.com/assets/images/Spices/dry-mango-powder-amchoor-50g-b-2.png";
const SH121 = "https://bawamasalacompany.com/assets/images/Spices/fish-masala-50g-b-2.png";
const SH122 = "https://bawamasalacompany.com/assets/images/Spices/garam-masala-50g-b-2.png";
const SH123 = "https://bawamasalacompany.com/assets/images/Spices/ginger-powder-50g-b-2.png";
const SH124 = "https://bawamasalacompany.com/assets/images/Spices/ginger-powder-100g-b-2.png";
const SH125 = "https://bawamasalacompany.com/assets/images/Spices/haldi-powder-50g-b-2.png";
const SH126 = "https://bawamasalacompany.com/assets/images/Spices/jal-jeera-100g-b-2.png";
const SH127 = "https://bawamasalacompany.com/assets/images/Spices/kitchen-king-50g-b-2.png";
const SH128 = "https://bawamasalacompany.com/assets/images/Spices/ksshmiri-mirch-50g-b-2.png";
const SH129 = "https://bawamasalacompany.com/assets/images/Spices/metmas-50g-b-2.png";
const SH130 = "https://bawamasalacompany.com/assets/images/Spices/metmas-100g-b-2.png";
// const SH131 = "https://bawamasalacompany.com/assets/images/Spices/mirch-powder-100g-b-2.png"
const SH132 = "https://bawamasalacompany.com/assets/images/Spices/mohini-garam-masala-15g-b-2.png";
const SH133 = "https://bawamasalacompany.com/assets/images/Spices/mohini-garam-masala-50g-b-2.png";
const SH134 = "https://bawamasalacompany.com/assets/images/Spices/momo-masala-50g-b-2.png";
const SH135 = "https://bawamasalacompany.com/assets/images/Spices/pani-puri-masala-100g-b-2.png";
const SH136 = "https://bawamasalacompany.com/assets/images/Spices/pav-bhaji-masala-50g-b-2.png";
// const SH137 = "https://bawamasalacompany.com/assets/images/Spices/rai-powder-100g-b-2.png"
const SH138 = "https://bawamasalacompany.com/assets/images/Spices/sabzi-masala-15g-b-2.png";
const SH139 = "https://bawamasalacompany.com/assets/images/Spices/sabzi-masala-50g-b-2.png";
const SH140 = "https://bawamasalacompany.com/assets/images/Spices/samber-powder-50g-b-2.png";
const SH141 = "https://bawamasalacompany.com/assets/images/Spices/shahi-paneer-masala-50g-b-2.png";
// const SH142 = "https://bawamasalacompany.com/assets/images/Spices/shahi-paneer-masala-100g-b-2.png"
const SH143 = "https://bawamasalacompany.com/assets/images/Spices/sounf-badian-powder-50g-b-2.png";
const SH144 = "https://bawamasalacompany.com/assets/images/Spices/special-meat-masala-50g-b-2.png";
// const SH145 = "https://bawamasalacompany.com/assets/images/Spices/special-meat-masala-100g-b-2.png"
// const SH146 = "https://bawamasalacompany.com/assets/images/Spices/tandoori-chicken-masala-50g-b-2.png"
const SH147 = "https://bawamasalacompany.com/assets/images/Spices/tandoori-chicken-masala-100g-b-2.png";
const SH148 = "https://bawamasalacompany.com/assets/images/Spices/white-pepper-powder-50g-b-2.png";
const SH149 = "https://bawamasalacompany.com/assets/images/Spices/zeera-powder-50g-b-2.png";
// const SH150 = "https://bawamasalacompany.com/assets/images/Spices/biryani-pulao-masala-100g-b-2.png"
const SH151 = "https://bawamasalacompany.com/assets/images/Spices/black-pepper-powder-50g-b-2.png";
// const SH152 = "https://bawamasalacompany.com/assets/images/Spices/black-pepper-powder-100g-b-2.png"
const SH153 = "https://bawamasalacompany.com/assets/images/Spices/chana-masala-50g-b-2.png";
// const SH154 = "https://bawamasalacompany.com/assets/images/Spices/chutney-podina-powder-100g-b-2.png"
// const SH155 = "https://bawamasalacompany.com/assets/images/Spices/curry-powder-50g-b-2.png"
const SH156 = "https://bawamasalacompany.com/assets/images/Spices/curry-powder-100g-b-2.png";
// const SH157 = "https://bawamasalacompany.com/assets/images/Spices/dry-mango-powder-amchoor-100g-b-2.png"
// const SH158 = "https://bawamasalacompany.com/assets/images/Spices/fish-masala-100g-b-2.png"
// const SH159 = "https://bawamasalacompany.com/assets/images/Spices/garam-masala-100g-b-2.png"
// const SH160 = "https://bawamasalacompany.com/assets/images/Spices/haldi-powder-100g-b-2.png"
// const SH161 = "https://bawamasalacompany.com/assets/images/Spices/hing-compound-10g-b-2.png"
// const SH162 = "https://bawamasalacompany.com/assets/images/Spices/jal-jeera-50g-b-2.png"
// const SH163 = "https://bawamasalacompany.com/assets/images/Spices/ksshmiri-mirch-100g-b-2.png"
// const SH164 = "https://bawamasalacompany.com/assets/images/Spices/mohini-garam-masala-100g-b-2.png"
// const SH165 = "https://bawamasalacompany.com/assets/images/Spices/momo-masala-100g-b-2.png"
// const SH166 = "https://bawamasalacompany.com/assets/images/Spices/mutton-masala-100g-b-2.png"
// const SH167 = "https://bawamasalacompany.com/assets/images/Spices/pav-bhaji-masala-100g-b-2.png"
// const SH168 = "https://bawamasalacompany.com/assets/images/Spices/pulao-masala-100g-b-2.png"
// const SH169 = "https://bawamasalacompany.com/assets/images/Spices/rayta-masala-100g-b-2.png"
const SH170 = "https://bawamasalacompany.com/assets/images/Spices/rogini-mirch-50g-b-2.png";
// const SH171 = "https://bawamasalacompany.com/assets/images/Spices/rogini-mirch-100g-b-2.png"
// const SH172 = "https://bawamasalacompany.com/assets/images/Spices/sabzi-masala-100g-b-2.png"
// const SH173 = "https://bawamasalacompany.com/assets/images/Spices/samber-masala-100g-b-2.png"
// const SH174 = "https://bawamasalacompany.com/assets/images/Spices/samber-masala-100g-new-pack-b-2.png"
// const SH175 = "https://bawamasalacompany.com/assets/images/Spices/sounf-badian-powder-100g-b-2.png"
// const SH176 = "https://bawamasalacompany.com/assets/images/Spices/special-rajmah-masala-15g-b-2.png"
// const SH177 = "https://bawamasalacompany.com/assets/images/Spices/special-rajmah-masala-50g-b-2.png"
// const SH178 = "https://bawamasalacompany.com/assets/images/Spices/special-rajmah-masala-100g-b-2.png"
// const SH179 = "https://bawamasalacompany.com/assets/images/Spices/white-pepper-powder-100g-b-2.png"
// const SH180 = "https://bawamasalacompany.com/assets/images/Spices/zeera-powder-100g-b-2.png"
const SH181 = "https://bawamasalacompany.com/assets/images/Spices/black-salt-100g-p-2.png";
const SH182 = "https://bawamasalacompany.com/assets/images/Spices/black-salt-250g-p-2.png";
const SH183 = "https://bawamasalacompany.com/assets/images/Spices/dhania-powder-1kg-p-2.png";
const SH184 = "https://bawamasalacompany.com/assets/images/Spices/dhania-powder-5kg-p-2.png";
const SH185 = "https://bawamasalacompany.com/assets/images/Spices/dhania-powder-20g-p-2.png";
const SH186 = "https://bawamasalacompany.com/assets/images/Spices/dhania-powder-30g-p-2.png";
const SH187 = "https://bawamasalacompany.com/assets/images/Spices/dhania-powder-200g-p-2.png";
const SH188 = "https://bawamasalacompany.com/assets/images/Spices/dhania-powder-500g-p-2.png";
// const SH189 = "https://bawamasalacompany.com/assets/images/Spices/garam-masala-8g-p-2.png.png"
const SH190 = "https://bawamasalacompany.com/assets/images/Spices/haldi-powder-1kg-2.png";
const SH191 = "https://bawamasalacompany.com/assets/images/Spices/haldi-powder-5kg-2.png";
const SH192 = "https://bawamasalacompany.com/assets/images/Spices/haldi-powder-30g-p-2.png";
// const SH193 = "https://bawamasalacompany.com/assets/images/Spices/haldi-powder-50g-p-2.png"
const SH194 = "https://bawamasalacompany.com/assets/images/Spices/haldi-powder-200g-p-2.png";
const SH195 = "https://bawamasalacompany.com/assets/images/Spices/haldi-powder-500g-p-2.png";
const SH196 = "https://bawamasalacompany.com/assets/images/Spices/kuti-mirch-100g-p-2.png";
const SH197 = "https://bawamasalacompany.com/assets/images/Spices/mirch-powder-1kg-p-2.png";
const SH198 = "https://bawamasalacompany.com/assets/images/Spices/mirch-powder-5kg-p-2.png";
const SH199 = "https://bawamasalacompany.com/assets/images/Spices/mirch-powder-30g-p-2.png";
const SH200 = "https://bawamasalacompany.com/assets/images/Spices/mirch-powder-50g-p-2.png";
const SH201 = "https://bawamasalacompany.com/assets/images/Spices/mirch-powder-200g-p-2.png";
const SH202 = "https://bawamasalacompany.com/assets/images/Spices/mirch-powder-500g-p-2.png";
// const SH203 = "https://bawamasalacompany.com/assets/images/Spices/rock-salt-250g-p-2.png"
// const SH204 = "https://bawamasalacompany.com/assets/images/Spices/zeera-whole-100g-p-2.png"
const SH205 = "https://bawamasalacompany.com/assets/images/Spices/haldi-powder-50g-p-2.png";
const SH206 = "https://bawamasalacompany.com/assets/images/Spices/special-rajmah-masala-15g-b-2.png";
const SH207 = "https://bawamasalacompany.com/assets/images/Spices/special-rajmah-masala-50g-b-2.png";
const SH208 = "https://bawamasalacompany.com/assets/images/Spices/sabzi-masala-100g-b-2.png";
const SH209 = "https://bawamasalacompany.com/assets/images/Spices/zeera-powder-100g-b-2.png";
const SH210 = "https://bawamasalacompany.com/assets/images/Spices/ajowain-whole-100g-p-2.png";
const SH211 = "https://bawamasalacompany.com/assets/images/Spices/kasoori-methi-powder-50g-p-2.png";
const SH212 = "https://bawamasalacompany.com/assets/images/Spices/kasoori-methi-powder-100g-p-2.png";
const SH213 = "https://bawamasalacompany.com/assets/images/Spices/kasoori-methi-powder-500g-b-2.png";
const SH214 = "https://bawamasalacompany.com/assets/images/Spices/soya-dish-chura-200g-b-2.png";

const Dish1 = "https://bawamasalacompany.com/assets/images/Dishes/Chana-dal-tadka.png";
const Dish2 = "https://bawamasalacompany.com/assets/images/Dishes/Boiled-Egg.png";
const Dish3 = "https://bawamasalacompany.com/assets/images/Dishes/Butter-Chicken.png";
const Dish4 = "https://bawamasalacompany.com/assets/images/Dishes/tava-pulao.png";
const Dish5 = "https://bawamasalacompany.com/assets/images/Dishes/aloo-paneer.png";
const Dish6 = "https://bawamasalacompany.com/assets/images/Dishes/amla-sabzi.png";
const Dish7 = "https://bawamasalacompany.com/assets/images/Dishes/brinjal-curry.png";
const Dish8 = "https://bawamasalacompany.com/assets/images/Dishes/chana-masala.png";
const Dish9 = "https://bawamasalacompany.com/assets/images/Dishes/Chicken-Biryani.png";
const Dish10 = "https://bawamasalacompany.com/assets/images/Dishes/chicken-ghee-roast.png";
const Dish11 = "https://bawamasalacompany.com/assets/images/Dishes/chicken-nuggets.png";
const Dish12 = "https://bawamasalacompany.com/assets/images/Dishes/cinnamon-chocolate-chip-cookies.png";
const Dish13 = "https://bawamasalacompany.com/assets/images/Dishes/cinnamon-garlic-chicken.png";
const Dish14 = "https://bawamasalacompany.com/assets/images/Dishes/coconut-rice.png";
const Dish15 = "https://bawamasalacompany.com/assets/images/Dishes/crispy-nimki.png";
const Dish16 = "https://bawamasalacompany.com/assets/images/Dishes/curry-pakoda.png";
const Dish17 = "https://bawamasalacompany.com/assets/images/Dishes/gatte-ki-sabiji.png";
const Dish18 = "https://bawamasalacompany.com/assets/images/Dishes/hyderabadi-dum-mutton-biryani.png";
const Dish19 = "https://bawamasalacompany.com/assets/images/Dishes/kaushambi-nimki.png";
const Dish20 = "https://bawamasalacompany.com/assets/images/Dishes/keema-allo-mutter.png";
const Dish29 = "https://bawamasalacompany.com/assets/images/Dishes/kucho-nimki.png";
const Dish28 = "https://bawamasalacompany.com/assets/images/Dishes/masala-tea.png";
const Dish27 = "https://bawamasalacompany.com/assets/images/Dishes/okra-fry.png";
const Dish26 = "https://bawamasalacompany.com/assets/images/Dishes/pav-bhaji-sandwich.png";
const Dish25 = "https://bawamasalacompany.com/assets/images/Dishes/samosa.png";
const Dish24 = "https://bawamasalacompany.com/assets/images/Dishes/spicy-masala-peas.png";
const Dish23 = "https://bawamasalacompany.com/assets/images/Dishes/sprouted-moong.png";
const Dish22 = "https://bawamasalacompany.com/assets/images/Dishes/tandoori-gobi.png";
const Dish21 = "https://bawamasalacompany.com/assets/images/Dishes/tandoori-murgh.png";
const Dish30 = "https://bawamasalacompany.com/assets/images/Dishes/tandoori-tikka.png";
const Dish31 = "https://bawamasalacompany.com/assets/images/Dishes/Pav-bhaji.png";
const Dish32 = "https://bawamasalacompany.com/assets/images/Dishes/Khandvi_from_Gujarat.png";
const Dish33 = "https://bawamasalacompany.com/assets/images/Dishes/Dhokla.png";
const Dish34 = "https://bawamasalacompany.com/assets/images/Dishes/Turmeric_Lemon_Rice.png";
const Dish35 = "https://bawamasalacompany.com/assets/images/Dishes/aloo-prantha.png";
const Dish36 = "https://bawamasalacompany.com/assets/images/Dishes/macher-jhol.png";
const Dish37 = "https://bawamasalacompany.com/assets/images/Dishes/uttapam.png";
const Dish38 = "https://bawamasalacompany.com/assets/images/Dishes/murukku.png";
const Dish39 = "https://bawamasalacompany.com/assets/images/Dishes/vada-pav.png";
const Dish40 = "https://bawamasalacompany.com/assets/images/Dishes/Jadoh.png";
const Dish41 = "https://bawamasalacompany.com/assets/images/Dishes/Rejgira Puri.png";
const Dish42 = "https://bawamasalacompany.com/assets/images/Dishes/Dahi-ke-Angare.png";
const Dish43 = "https://bawamasalacompany.com/assets/images/Dishes/Pooran-Poli.png";
const Dish44 = "https://bawamasalacompany.com/assets/images/Dishes/BMC_edit1.jpg";
const Dish46 = "https://bawamasalacompany.com/assets/images/Dishes/BMC_edit2.jpg";
const Dish45 = "https://bawamasalacompany.com/assets/images/Dishes/BMC_edit3.jpg";

const RecipeDown1 = "https://bawamasalacompany.com/assets/Docs/recipesPDF/AlooParatha.pdf";
const RecipeDown2 = "https://bawamasalacompany.com/assets/Docs/recipesPDF/AndhraMurukku.pdf";
const RecipeDown3 = "https://bawamasalacompany.com/assets/Docs/recipesPDF/ButterChicken.pdf";
const RecipeDown4 = "https://bawamasalacompany.com/assets/Docs/recipesPDF/ChanaDalTadka.pdf";
const RecipeDown5 = "https://bawamasalacompany.com/assets/Docs/recipesPDF/DahiKeAngare.pdf";
const RecipeDown6 = "https://bawamasalacompany.com/assets/Docs/recipesPDF/Dhokla.pdf";
const RecipeDown7 = "https://bawamasalacompany.com/assets/Docs/recipesPDF/Jadoh.pdf";
const RecipeDown8 = "https://bawamasalacompany.com/assets/Docs/recipesPDF/Khandvi.pdf";
const RecipeDown9 = "https://bawamasalacompany.com/assets/Docs/recipesPDF/MacherJhol.pdf";
const RecipeDown10 = "https://bawamasalacompany.com/assets/Docs/recipesPDF/PavBhaji.pdf";
const RecipeDown11 = "https://bawamasalacompany.com/assets/Docs/recipesPDF/PooranPoli.pdf";
const RecipeDown12 = "https://bawamasalacompany.com/assets/Docs/recipesPDF/RajgiraPuri.pdf";
const RecipeDown13 = "https://bawamasalacompany.com/assets/Docs/recipesPDF/TandooriMurgh.pdf";
const RecipeDown14 = "https://bawamasalacompany.com/assets/Docs/recipesPDF/TavaPulao.pdf";
const RecipeDown15 = "https://bawamasalacompany.com/assets/Docs/recipesPDF/TurmericLemonRice.pdf";
const RecipeDown16 = "https://bawamasalacompany.com/assets/Docs/recipesPDF/UtthapamWithSamber.pdf";
const RecipeDown17 = "https://bawamasalacompany.com/assets/Docs/recipesPDF/VadaPav.pdf";

// Do not put same Ids in spice, pooja and misc
// Lead to drastical bugs
const ListContent = [
  {
    title: "Appetizer",
  },
  {
    title: "Main Course",
  },
  {
    title: "Dessert",
  },
  {
    title: "Snack",
  },
];
// Do not put same Ids in spice, pooja and misc
// Lead to drastical bugs
const SpiceDetails = [
  {
    id: 28,
    u_id: 1,
    hindiName: "स्पेशल मीट मसाला",
    metaDesc: "",
    detailName: "Special Meat Masala",
    sName: "Special Meat Masala स्पेशल मीट मसाला meat lal mas sabji laal",
    productName: "Special Meat Masala",
    urlName: "Special Meat Masala-100g-1",
    recipesId: [],
    url: "Special-Meat-Masala-100g-b",
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 97,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Garlic, Cassis",
      "Cardamom-Amomum",
      "Dry Ginger",
      "Black Pepper",
      "Cinnamon",
      "Cloves",
      "Saffron",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: "https://bawamasalacompany.com/assets/images/products/meat-masala.png",
    imgUrls: ["https://bawamasalacompany.com/assets/images/products/meat-masala.png", "https://bawamasalacompany.com/assets/images/products/meat-masala-h.png"],
    uses: null,
    desc:
      "It's the informed choice of those who don't like to waste precious time in the kitchen. Prepared from thoroughly cleaned and fresh ingredients, processed under hygienic conditions, this Special Meat Masala is indispensable for a non-veg. kitchen. Signature spice blend that makes for fragrant, rich, melt-in-the-mouth, traditional meat dishes.",
  },
  {
    id: 26,
    u_id: 2,
    hindiName: "चाट मसाला",
    metaDesc: "",
    detailName: "Chat Masala",
    sName: "Chat Masala चाट मसाला chaat pani puri sev aloo fruit salad shakarkand Spices",
    productName: "Chat Masala",
    urlName: "Chat Masala-100g-1",
    recipesId: [35],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 90,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["White Salt", "Black Salt", "Dry Mango", "Mint Leaves", "Cumin Seeds", "Bishop's Weed", "Yellow Chillies", "Dry Ginger"],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/chat-masala.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/chat-masala.png",
      "https://bawamasalacompany.com/assets/images/products/chat-masala-hindi.png",
    ],
    uses: null,
    desc: "Delicious masala for preparation of all Chaats (street food) and salads. Makes aloo chaat, pani puris, fruit salad and papri chaat lip-smacking!",
  },
  {
    id: 44,
    u_id: 3,
    hindiName: "चना मसाला",
    metaDesc: "",
    detailName: "Chana Masala",
    sName: "Chana Masala चना मसाला chana bathure masala dry chole chawal channa Spices",
    productName: "Chana Masala",
    urlName: "Chana Masala-100g-1",
    recipesId: [28],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 90,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Turmeric",
      "Cumin Seeds",
      "White Salt",
      "Dry Mango",
      "Bishop's Weed",
      "Pomegranate Seeds",
      "Dry Ginger",
      "Fenugreek",
      "Black Salt",
      "Cardamom- Amomum",
      "Cassia",
      "Cloves",
      "Black Pepper",
      "Embica",
    ],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/chana-masala-b.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/chana-masala-b.png",
      "https://bawamasalacompany.com/assets/images/products/chana-masala.png",
    ],
    uses: null,
    desc: "Takes the regular Chana dish to another level of taste and flavour, demanding another bathura or two to mop up that delicious gravy!",
  },
  {
    id: 36,
    u_id: 4,
    hindiName: "गरम मसाला",
    metaDesc: "",
    detailName: "Garam Masala",
    sName: "Garam Masala गरम मसाला Murgh Makhani Chicken Tikka Spices",
    productName: "Garam Masala",
    urlName: "Garam Masala-100g-1",
    recipesId: [4, 9, 35],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 109,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Coriander", "Cumin Seed", "Black Pepper", "Cardamom", "Fenugreek", "Dry Ginger", "Cloves", "Cinnamon"],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/garam-masala.png",
    miniPackWeight: 37,
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/garam-masala.png",
      "https://bawamasalacompany.com/assets/images/products/garam-masala-b.png",
    ],
    uses: null,
    desc:
      "This is the king combination of all masalas and is an essential addition to most Indian preparations. A mixture of many masalas, Garam Masala completes the dish. Be it a Biryani, Pulao, Pao-bhaji, any Vegetable dish or cereal preparation you just can't do without Garam Masala. Simply sprinkle a little BMC Garam Masala over the dishes cooked and relish the difference !",
  },
  {
    id: 32,
    u_id: 5,
    hindiName: "किचन किंग",
    metaDesc: "",
    detailName: "Kitchen King",
    sName: "Kitchen King किचन किंग sabji masala curry vegetable Spices",
    productName: "Kitchen King",
    urlName: "Kitchen King-100g-1",
    recipesId: [9],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 97,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fengreek",
      "Turmeric",
      "Garlic",
      "Cumin",
      "Cloves",
      "Black Pepper",
      "Cinnamon",
      "Dry Ginger",
      "Curry Leaves",
      "Cardamom- Amomum",
      "Saffron",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    imgSrc: S2,
    miniPackWeight: "https://bawamasalacompany.com/assets/images/products/kitchen-king.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/kitchen-king.png",
      "https://bawamasalacompany.com/assets/images/products/kitchen-king-2.png",
    ],
    uses: null,
    desc:
      "The right mix of a number of special Masalas to bring out unparalleled taste in all vegetarian dishes. This multi-use spice-mix is an essential commodity for a kitchen where treats are a routine. Tips: Follow your usual cooking method and add 20 gms. of BMC Kitchen KIng to 1kg. veg. (or in right proportion) mixing it thoroughly. No other spices required.",
  },
  {
    id: 42,
    u_id: 47,
    hindiName: "पैरट कसूरी मेथी",
    metaDesc: "",
    detailName: "Parrot Kasoori Methi",
    sName: "Parrot Kasoori Methi  Kasoori Methi कसूरी मेथी kasuri fenugreek leaf  Spices",
    productName: "Parrot Kasoori Methi",
    urlName: "Parrot Kasoori Methi-100g-2",
    recipesId: [5],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 108,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Dried fenugreek"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S212,
    imgUrls: [S212, SH212],
    uses: null,
    desc: "Sun-dried fenugreek leaves, powdered for use in a variety of Indian favourites such as Butter Chicken and Paneer Tikka.",
  },
  {
    id: 155,
    u_id: 47,
    hindiName: "पैरट कसूरी मेथी",
    metaDesc: "",
    detailName: "Parrot Kasoori Methi / Fenugreek Seeds Powder",
    sName: "Parrot Kasoori Methi Fenugreek Seeds Powder पैरट कसूरी मेथी kasuri fenugreek leaf Spices",
    productName: "Parrot Kasoori Methi",
    urlName: "Parrot Kasoori Methi-25g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: "Imparts an appetising flavour and taste to the dishes",
    spl: 1,
    mrp: 30,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "25g",
    ingredients: ["Dried fenugreek."],
    type: "Spices",
    imgSrc: S1,
    imgUrls: [S1, SH1],
    uses: null,
    desc:
      "For the original fenugreek flavour and taste try BMC Kasoori Methi. It retains all the vitamins as in fresh & works wonders to your favourite dish, be it veg. or non-veg.",
  },
  {
    id: 46,
    u_id: 7,
    hindiName: "मिटमास",
    metaDesc: "",
    detailName: "MetMas",
    sName: "MetMas मिटमास Meat masala Spices",
    productName: "MetMas",
    urlName: "MetMas-100g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: "Saffron Flavour",
    spl: 1,
    mrp: 97,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    miniPackWeight: 47,
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Garlic",
      "Cassia",
      "Cardamom-Ammomum",
      "Dry Ginger",
      "Black Pepper",
      "Cinnamon",
      "Cloves",
      "Saffron",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/metmas.png",
    imgUrls: ["https://bawamasalacompany.com/assets/images/products/metmas.png", "https://bawamasalacompany.com/assets/images/products/metmas-hindi.png"],
    uses: null,
    desc:
      "Surprise your family & friends with exotic non-veg delicacies such as Mutton, Korma (Shahi) or Keema etc. by adding a little Metmas. Give the cuisine the exclusive colour and flavour. Signature spice blend, with saffron.",
  },
  {
    id: 15,
    u_id: 8,
    hindiName: "कश्मीरी मिर्च",
    metaDesc: "",
    detailName: "Kashmiri Mirch",
    sName: "Kashmiri Mirch कश्मीरी मिर्च Red chilli lal laal Spices",
    productName: "Kashmiri Mirch",
    urlName: "Kashmiri Mirch-100g-1",
    recipesId: [2],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: "Chilli powder makes dishes delicious and colourful!",
    spl: 1,
    mrp: 110,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Freshly ground chilli powder from handpicked Indian red chillies", "Edible mustard oil added- not more than 2%."],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/kashmiri-mirch.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/kashmiri-mirch.png",
      "https://bawamasalacompany.com/assets/images/products/kashmiri-mirch-2.png",
    ],
    uses: null,
    desc: "Chilli powder makes dishes delicious and colourful!",
  },
  {
    id: 41,
    u_id: 9,
    hindiName: "चिकमास",
    metaDesc: "",
    detailName: "Chickmas",
    sName: "Chickmas chicken masala tikka butter makhani roast kebab Spices चिकमास",
    productName: "Chickmas",
    urlName: "Chickmas-100g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 97,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    miniPackWeight: 40,
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Cardamom-Amomum",
      "Garlic",
      "Black Pepper",
      "Cassia",
      "Dry Ginger",
      "Cinnamon",
      "Cloves",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/chickmas.png",
    imgUrls: ["https://bawamasalacompany.com/assets/images/products/chickmas.png"],
    uses: null,
    desc:
      "For all Chicken recipes this signature spice blend comes in handy. Handier than ever, now in a Mini Pouch! With BMC Chickmas, you would relish your favourite Chicken dishes more than ever. Tips: Add 20 gms. of Chickmas per kg. of Chicken, following your regular recipes and taste the difference.",
  },
  {
    id: 9,
    u_id: 10,
    hindiName: "फिश मसाला",
    metaDesc: "",
    detailName: "Fish Masala",
    sName: "Fish Masala फिश मसाला fish fry pakore curry machar jhol Spices",
    productName: "Fish Masala",
    urlName: "Fish Masala-100g-1",
    recipesId: [],
    packType: 1,
    title: "Fish-Masala",
    features: null,
    spl: 1,
    mrp: 85,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: [
      "Red Chillies",
      "Coriander",
      "Cumin Seeds",
      "Garlic",
      "Bishop's Weed",
      "Black Pepper",
      "Dry Mango",
      "Cinnamon",
      "Cloves",
      "Mace",
      "Ginger",
      "Turmeric",
    ],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/fish-masala.png",
    imgUrls: ["https://bawamasalacompany.com/assets/images/products/fish-masala.png", "https://bawamasalacompany.com/assets/images/products/fish-hindi.png"],
    miniPackWeight: 10,
    uses: null,
    desc: "High quality spice rub for those delicious pan-fried and oven-baked fish dishes. Essential for excellent, fragrant marinades too.",
  },
  {
    id: 11,
    u_id: 11,
    hindiName: "काली मिर्च पाउडर",
    metaDesc:
      "BMC Black Pepper Powder, the well-known name for supreme, pure quality, freshly ground Indian Black Pepper. Used for cooking as well as a condiment, and full of health benefits.",
    detailName: "Black Pepper Powder",
    sName: "Black Pepper Powder काली मिर्च पाउडर kali mirch black pepper powder Spices Sabut",
    productName: "Black Pepper Powder",
    urlName: "Black Pepper Powder-100g-1",
    recipesId: [34],
    packType: 1,
    title: "Black-Pepper-Powder",
    features:
      "BMC Pepper, the well known name of pure and supreme quality, prepared from Indian Pepper. Thoroughly cleaned and care has been taken to retain its natural taste and original fragrance. It adds flavour to make the dish tastier.",
    spl: 1,
    mrp: 200,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Fresh Indian black pepper, ground."],
    type: "Spices",
    imgSrc: S22,
    imgUrls: [S22, SH22],
    uses: null,
    desc:
      "BMC Pepper, the well known name of pure and supreme quality, prepared from Indian Pepper. Thoroughly cleaned and care has been taken to retain its natural taste and original fragrance. It adds flavour to make the dish tastier.",
  },
  {
    id: 34,
    u_id: 12,
    hindiName: "बिरयानी पुलाव मसाला",
    metaDesc: "",
    detailName: "Biryani Pulao Masala",
    sName: "Biryani Pulao Masala pulao masala biryani powder pulav pilau pilaf Spices बिरयानी पुलाव मसाला",
    productName: "Biryani Pulao Masala",
    urlName: "Biryani Pulao Masala-100g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 110,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Coriander", "Cumin Seed", "Cardamom-amomum", "Black Pepper", "Cinnamon", "Cassia", "Cloves", "Nutmeg", "Mace"],
    type: "Spices",
    imgSrc: S4,
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/biryani-pulao-masala.png",
      "https://bawamasalacompany.com/assets/images/products/biryani-pulao-masala-b.png",
    ],
    uses: null,
    desc: "This spice combination is ideal for both veg. and non-veg. variety of pulao. Its unique aroma and taste are bound to cast a spell on you.",
  },
  {
    id: 1,
    u_id: 13,
    hindiName: "पावभाजी मसाला",
    metaDesc:
      "BMC Pav Bhaji Masala adds restaurant-style taste to homemade Pav Bhaji, transporting you to the streets of Mumbai with the authentic and original taste. ",
    detailName: "Pav Bhaji Masala",
    sName: "Pav Bhaji Masala पावभाजी मसाला pao fast food Bhaji-pav Spices Pao",
    productName: "Pav Bhaji Masala",
    urlName: "Pav Bhaji Masala-100g-1",
    recipesId: [0, 2, 6],
    packType: 1,
    title: "Pav-Bhaji-Masala",
    features: "Flavour Forever",
    spl: 1,
    mrp: 85,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Dry Mango",
      "Cumin",
      "Black pepper",
      "Cinnamon",
      "Cardamom-Amomum",
      "Aniseed",
      "Cloves",
      "Dry Ginger",
      "Fenugreek",
      "Bishop's Wood",
      "Turmeric & White Salt",
    ],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/pav-bhaji-masala.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/pav-bhaji-masala.png",
      "https://bawamasalacompany.com/assets/images/products/pav-bhaji-masala-2.png",
    ],
    uses: null,
    desc: "Adds lip-smacking flavour to homemade Pav Bhaji, making buttery pavs and crunch veggies sing!",
  },
  {
    id: 2,
    u_id: 14,
    hindiName: "तंदूरी चिकन मसाला",
    metaDesc:
      "BMC Tandoori Chicken is a signature spice blend from a secret, traditional Punjabi recipe. Bring home for fragrant, flavourful, spicy and melt-in-the mouth Tandoori Chicken.",
    detailName: "Tandoori Chicken Masala",
    sName: "Tandoori Chicken Masala तंदूरी चिकन मसाला tikka tandoor",
    productName: "Tandoori Chicken Masala",
    urlName: "Tandoori Chicken Masala-100g-1",
    recipesId: [1, 9, 10, 12],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 97,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Coriander", "Chillies", "Fenugreek", "Black Pepper", "Turmeric", "Cardamom-amomum", "Musk Melon", "Ginger", "Cinnamon", "Mace", "Cloves"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: "https://bawamasalacompany.com/assets/images/products/tandoori-chicken-masala.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/tandoori-chicken-masala.png",
      "https://bawamasalacompany.com/assets/images/products/tandoori-chicken-masala-hindi.png",
    ],
    uses: null,
    desc: "Essential for a rich and spicy base to homemade Tandoori Chicken, the signature delicious Punjabi dish, traditionally made in clay ovens (tandoors)",
  },
  {
    id: 146,
    u_id: 14,
    hindiName: "तंदूरी चिकन मसाला",
    metaDesc:
      "BMC Tandoori Chicken is a signature spice blend from a secret, traditional Punjabi recipe. Bring home for fragrant, flavourful, spicy and melt-in-the mouth Tandoori Chicken.",
    detailName: "Tandoori Chicken Masala",
    sName: "Tandoori Chicken Masala तंदूरी चिकन मसाला tikka tandoor",
    productName: "Tandoori Chicken Masala",
    urlName: "Tandoori Chicken Masala-50g-1",
    recipesId: [1, 9, 10, 12],
    packType: 1,
    title: "Tandoori-Chicken-Masala",
    features: null,
    spl: 1,
    mrp: 62,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: ["Coriander", "Chillies", "Fenugreek", "Black Pepper", "Turmeric", "Cardamom-amomum", "Musk Melon", "Ginger", "Cinnamon", "Mace", "Cloves"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S25,
    imgUrls: [S25, SH25],
    uses: null,
    desc: "Essential for a rich and spicy base to homemade Tandoori Chicken, the signature delicious Punjabi dish, traditionally made in clay ovens (tandoors)",
  },
  {
    id: 3,
    u_id: 15,
    hindiName: "चटनी पुदिना पाउडर",
    metaDesc: "BMC Chutney Podina Powder, with freshly ground mint,  is refreshing addition to cooling raitas, tangy chutneys, dips, marinades.",
    detailName: "Chutney Podina Powder",
    sName: "Chutney Podina Powder चटनी पुदिना पाउडर green pudina chutney powder leaf pata chatni Mint Leaves Spices",
    productName: "Chutney Podina Powder",
    urlName: "Chutney Podina Powder-100g-1",
    recipesId: [],
    packType: 1,
    title: "Chutney-Podina-Powder",
    features: "Flavour Forever",
    spl: 0,
    mrp: 85,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: [
      "Mint Leaves",
      "Yellow Chillies",
      "Coriander",
      "Cummin Seeds",
      "Dry Mango",
      "Black Salt",
      "White Salt",
      "Naushadar",
      "Nutmeg",
      "Cardamom Seeds",
      "Kachri",
    ],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/chutney-podina-powder.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/chutney-podina-powder.png",
      "https://bawamasalacompany.com/assets/images/products/chutney-podina-powder-hindi.png",
    ],
    uses: null,
    desc:
      "Podina, or mint, brought from lush green kitchen gardens to your kitchen. Makes for delicious podina chutneys to accompany pakoras, and gives a new dimension to raita and sandwiches. A multi-purpose, well-loved and versatile seasoning for all cuisines.",
  },
  {
    id: 4,
    u_id: 16,
    hindiName: "दालचीनी पाउडर",
    metaDesc:
      "Freshly ground, premium cinnamon powder by Bawa Masala Company. Aromatic and flavourful, dalchini powder adds warmth and sweetness to masala chai, cookies, cakes etc.",
    detailName: "Dalchini Powder / Cinnamon Powder",
    sName: "Dalchini Powder Cinnamon Powder दालचीनी पाउडर Cinnamon Masala chai tea toast cookies cake Spices",
    productName: "Dalchini Powder",
    urlName: "Dalchini Powder-50g-1",
    recipesId: [3, 13, 14],
    packType: 1,
    title: "Dalchini-Powder",
    features: "Flavour Forever",
    spl: 0,
    mrp: 60,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: ["Finest Cinnamon"],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/dalchini.png",
    imgUrls: ["https://bawamasalacompany.com/assets/images/products/dalchini.png", "https://bawamasalacompany.com/assets/images/products/dalchini-hindi.png"],
    uses: "Tea, Garam Masala, veg. or non-veg dishes",
    desc: "Finest ground cinnamon; easy to add to tea, marinades and gravy dishes.",
  },
  {
    id: 5,
    u_id: 17,
    hindiName: "हल्दी पाउडर",
    metaDesc: "BMC's finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
    detailName: "Haldi Powder / Turmeric Powder",
    sName: "Haldi Powder  Turmeric Powder हल्दी पाउडर ",
    productName: "Haldi Powder",
    urlName: "Haldi Powder-100g-1",
    recipesId: [39, 36, 37, 4, 30, 32, 33, 34, 42],
    packType: 1,
    title: "Haldi-Powder",
    features: "Imparts an appetising flavour and taste to the dishes",
    spl: 0,
    mrp: 57,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Fine Indian Turmeric"],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/haldi-powder.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/haldi-powder.png",
      "https://bawamasalacompany.com/assets/images/products/haldi-powder-hindi.png",
    ],
    uses: null,
    desc: "Finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
  },
  {
    id: 6,
    u_id: 18,
    hindiName: "धनिया पाउडर",
    metaDesc: "BMC Dhania Powder is freshly ground, and a healthy, essential condiment for all Indian dishes. ",
    detailName: "Dhania Powder / Coriander Powder",
    sName: "Dhania Powder  Coriander Powder धनिया पाउडर coriander dhaniya green Spices",
    productName: "Dhania Powder",
    urlName: "Dhania Powder-100g-2",
    recipesId: [4, 5, 34, 36],
    packType: 2,
    title: "Dhania-Powder",
    features: "Coriander Powder",
    spl: 0,
    mrp: 37,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Fresh green coriander dried and ground"],
    type: "Spices",
    imgSrc: S56,
    imgUrls: [S56, SH56],
    miniPackWeight: 7,
    uses: null,
    desc: "Powdered coriander; an essential addition to most Indian daals and vegetable preparations.",
  },
  {
    id: 8,
    u_id: 19,
    hindiName: "मिर्च पाउडर",
    metaDesc:
      "BMC's freshly ground, premium red chilli powder give your dishes the perfect heat and spicy kick! Versatile and essential addition to your spice box. Adds natural red colour to dishes. ",
    detailName: "Mirch Powder / Chilli Powder",
    sName: "Mirch Powder Chilli Powder मिर्च पाउडर Lal mirchi Spices chilli Laal",
    productName: "Mirch Powder",
    urlName: "Mirch Powder-100g-1-box",
    recipesId: [0, 4, 5, 9, 35, 36, 38, 41],
    packType: 1,
    title: "Mirch-Powder",
    features: null,
    spl: 0,
    mrp: 52,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Freshly ground red chilli powder", "Edible mustard oil added- not more than 2%"],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/mirch-powder.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/mirch-powder.png",
      "https://bawamasalacompany.com/assets/images/products/mirch-powder-hindi.png",
    ],
    uses: null,
    desc: "Excellent quality spice to add a dimension of heat to all dishes. Essential in most Indian dishes, to add that spicy kick!",
  },
  {
    id: 12,
    u_id: 20,
    hindiName: "पुलाव मसाला",
    metaDesc: "",
    detailName: "Pulao Masala",
    sName: "Pulao Masala पुलाव मसाला pulav pilau pilaf Spices",
    productName: "Pulao Masala",
    urlName: "Pulao Masala-100g-1",
    recipesId: [2],
    packType: 1,
    title: "Pulao-Masala",
    features: null,
    spl: 0,
    mrp: 110,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Coriander", "Cumin Seeds", "Cardamom-amomum", "Black Pepper", "Cinnamon", "Cassia", "Cloves", "Nutmeg", "Mace"],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/pulao-masala.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/pulao-masala.png",
      "https://bawamasalacompany.com/assets/images/products/pulao-masala-hindi.png",
    ],
    uses: null,
    desc: "Spices that create fragrant, heart-warming rice dishes fit for a king, in your own kitchen. High quality mix that brings convenience to tradition.",
  },
  {
    id: 13,
    u_id: 21,
    hindiName: "रायता मसाला",
    metaDesc: "",
    detailName: "Rayta Masala / Raita",
    sName: "Rayta Masala Raita रायता मसाला raita boondi Spices rayta",
    productName: "Rayta Masala",
    urlName: "Rayta Masala-100g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 0,
    mrp: 80,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Coriander", "Black Pepper", "Cumin Seeds", "Bishop's Weed", "White Salt", "Black Salt", "Yellow Chilli", "Fenugreek Seeds"],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/rayta.png",
    imgUrls: ["https://bawamasalacompany.com/assets/images/products/rayta.png", "https://bawamasalacompany.com/assets/images/products/rayta-hindi.png"],
    uses: null,
    desc: "Spice up the regular, boring yogurt with the BMC Rayta Masala, and it will be an instant hit.",
  },
  {
    id: 14,
    u_id: 22,
    hindiName: "रोग़नी मिर्च",
    metaDesc: "",
    detailName: "Roghni Mirch",
    sName: "Roghni Mirch रोगनी मिर्च lal spices masale mirchi chilli laal रोग़नी मिर्च ",
    productName: "Roghni Mirch",
    urlName: "Roghni Mirch-100g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: "Chilli powder makes dishes delicious and colourful!",
    spl: 1,
    mrp: 110,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Freshly ground Indian red chillies", "Edible mustard oil added- not more than 2%"],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/roghni-mirch.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/roghni-mirch.png",
      "https://bawamasalacompany.com/assets/images/products/roghni-mirch-hindi.png",
    ],
    uses: null,
    desc:
      "Special variety of red chillies, dried and powdered for use in a variety of Indian dishes. Add spicy and tangy flavour and natural colour to dishes. Perfect addition to the Indian spice box.",
  },
  {
    id: 16,
    u_id: 23,
    hindiName: "हींग बन्धानी",
    metaDesc: "",
    detailName: "Hing Compounded / Hing Gatte",
    sName: "Hing gatte Hing Compounded Asafoetida Powder हींग बन्धानी Strong Asafoetida Heeng Spices",
    productName: "Hing Compounded",
    urlName: "Hing Compounded-10g-0",
    recipesId: [39, 32, 33, 37, 2],
    packType: 0,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 0,
    mrp: 35,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "10g",
    ingredients: ["Dried, aromatic hing powder"],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/hing-compounded.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/hing-compounded.png",
      "https://bawamasalacompany.com/assets/images/products/hing-compounded-b.png",
    ],
    uses: null,
    desc: "Asafoetida powder adds a spicy kick to the silky, smooth base of Indian daals, curries and street food, while supporting digestive health. ",
  },
  {
    id: 17,
    u_id: 24,
    hindiName: "मोहिनी गरम मसाला",
    metaDesc: "",
    detailName: "Mohini Garam Masala",
    sName: "Mohini Garam Masala मोहिनी गरम मसाला Murgh Makhani Chicken Tikka Spices",
    productName: "Mohini Garam Masala",
    urlName: "Mohini Garam Masala-100g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 109,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Coriander", "Cumin Seed", "Black Pepper", "Cardamom", "Fenugreek", "Dry Ginger", "Cloves", "Cinnamon"],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/mohini-garam-masala.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/mohini-garam-masala.png",
      "https://bawamasalacompany.com/assets/images/products/mohini-masala.png",
    ],
    uses: null,
    desc:
      "Discover the gourmands in you with the BMC Mohini Garam Masala. Made from fresh Indian Spices, it is the right mix of spices that enhances the taste of veg. & non-veg. dishes alike.",
  },
  {
    id: 18,
    u_id: 25,
    hindiName: "राई पाउडर",
    metaDesc: "",
    detailName: "Rai Powder / Mustard Seed Powder",
    sName: "Rai Powder Mustard Seed Powder राई पाउडर Tandoori chicken mustard Spices",
    productName: "Rai Powder",
    urlName: "Rai Powder-100g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 0,
    mrp: 100,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Finest ground powder of brown and white mustard seeds."],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/rai.png",
    imgUrls: ["https://bawamasalacompany.com/assets/images/products/rai.png", "https://bawamasalacompany.com/assets/images/products/rai-hindi.png"],
    uses: null,
    desc: "Powdered mustard seeds, that add warmth and distinct flavour to dishes.",
  },
  {
    id: 19,
    u_id: 26,
    hindiName: "साम्बर मसाला",
    metaDesc: "",
    detailName: "Samber Masala",
    sName: "Samber Masala साम्बर मसाला spices lentil-vegetable curry",
    productName: "Samber Masala",
    urlName: "Samber Masala-100g-1",
    recipesId: [39],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 0,
    mrp: 84,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Mustard",
      "Black Pepper",
      "Cardamom-Amomum",
      "Cloves",
      "Dry Ginger",
      "Curry Leaves",
      "Asafoetida",
    ],
    type: "Spices",
    imgSrc: S34,
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/samber-masala.png",
      "https://bawamasalacompany.com/assets/images/products/samber-masala-hindi.png",
    ],
    uses: null,
    desc: "For the original South Indian preparation, delicious taste and restaurant quality in your own kitchen. ",
  },
  {
    id: 20,
    u_id: 27,
    hindiName: "सफेद मिर्च पाऊडर",
    metaDesc: "",
    detailName: "White Pepper Powder",
    sName: "White Pepper Powder सफेद मिर्च पाऊडर Organic Sabut Safed Mirchi",
    productName: "White Pepper Powder",
    urlName: "White Pepper Powder-100g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 0,
    mrp: 250,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Freshly ground Indian white pepper"],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/white-pepper-powder.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/white-pepper-powder.png",
      "https://bawamasalacompany.com/assets/images/products/white-pepper-powder-hindi.png",
    ],
    uses: null,
    desc: "White pepper is made from fully ripe pepper berries, adding a sharp bite to silky soups and Chinese gravies. ",
  },
  {
    id: 22,
    u_id: 28,
    hindiName: "मटन मसाला",
    metaDesc: "",
    detailName: "Mutton Masala",
    sName: "Mutton Masala मटन मसाला meat lal mas laal",
    productName: "Mutton Masala",
    urlName: "Mutton Masala-100g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: "This Masala can be used in 4 Kg of Meat.",
    spl: 0,
    mrp: 97,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Garlic",
      "Cassia",
      "Cardamom-Amomum",
      "Dry Ginger",
      "Black Pepper",
      "Cinnamon",
      "Cloves",
      "Saffron",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/mutton-masala.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/mutton-masala.png",
      "https://bawamasalacompany.com/assets/images/products/mutton-masala-hindi.png",
    ],
    uses: null,
    desc: "Beautiful spices that make for melt-in-the-mouth mutton dishes. This Masala can be used in 4 Kg of Meat.",
  },
  {
    id: 23,
    u_id: 29,
    hindiName: "करी पाउडर",
    metaDesc: "",
    detailName: "Curry Powder",
    sName: "Curry Powder करी पाउडर gravy Butter Chicken Spices",
    productName: "Curry Powder",
    urlName: "Curry Powder-100g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 0,
    mrp: 80,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: [
      "Coriander",
      "Fenugreek",
      "Chilli",
      "Black Pepper",
      "Turmeric",
      "Cardamom-Amomum",
      "Cinnamom",
      "Dry Ginger",
      "Cloves",
      "Nutmeg",
      "Mace",
      "Salt not more than 5%",
    ],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/curry.png",
    imgUrls: ["https://bawamasalacompany.com/assets/images/products/curry.png", "https://bawamasalacompany.com/assets/images/products/curry-hindi.png"],
    uses: null,
    desc: "All purpose spice blend used commonly to flavor soups, stews, sauces, marinades, meat, and vegetables.",
  },
  {
    id: 24,
    u_id: 30,
    hindiName: "सेंधा नमक",
    metaDesc: "",
    detailName: "Grinded Rock Salt",
    sName: "Grinded Rock Salt Himalayan pink rock salt",
    productName: "Grinded Rock Salt",
    urlName: "Grinded Rock Salt-250g-2",
    recipesId: [40],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: "(Sendha Namak in Hindi)",
    spl: 0,
    mrp: 35,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "250g",
    ingredients: ["Naturally occuring rock crystals, powdered."],
    type: "Spices",
    imgSrc: S54,
    imgUrls: [S54, SH54],
    uses: null,
    desc:
      "Known as Sendha Namak in Hindi, this is coarse, large grained salt ground for easy consumption. Rock Salt has many health benefits, and is a a kitchen staple, especially for use during religious oberservances and fasts, as it is unrefined and non-iodised.",
  },
  {
    id: 27,
    u_id: 32,
    hindiName: "सौंफ पाउडर",
    metaDesc: "",
    detailName: "Badian Powder / Powdered Fennel Seeds",
    sName: "Badian Powder Fennel Seeds Powder Saunf Powder सौंफ पाउडर Saunf Powder sauf Powdered Fennel Seeds",
    productName: "Badian Powder",
    urlName: "Badian Powder-100g-1",
    recipesId: [42],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 0,
    mrp: 52,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["High quality freshly ground fennel"],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/badian-powder.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/badian-powder.png",
      "https://bawamasalacompany.com/assets/images/products/badian-powder-b.png",
    ],
    uses: null,
    desc:
      "Powdered fennel seeds, used to add a sweet flavour and fresh aroma to dishes. Widely used in Ayurvedic medicine, for digestive, antioxidant and anti-inflammatory benefits. Known to have a cooling effect on the body. Great for tadka or tempering for a variety of dishes.",
  },
  {
    id: 30,
    u_id: 17,
    hindiName: "हल्दी पाउडर",
    metaDesc: "BMC's finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
    detailName: "Haldi Powder / Turmeric Powder",
    sName: "Haldi Powder Turmeric Powder हल्दी पाउडर",
    productName: "Haldi Powder",
    urlName: "Haldi Powder-100g-2",
    recipesId: [39, 36, 37, 4, 30, 32, 33, 34, 42],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 0,
    mrp: 55,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Fine Indian Turmeric"],
    type: "Spices",
    miniPackWeight: 31,
    imgSrc: S57,
    imgUrls: [S57, SH57],
    uses: null,
    desc: "Finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
  },
  {
    id: 35,
    u_id: 33,
    hindiName: "अमचूर पाउडर",
    metaDesc: "",
    detailName: "Amchoor / Dry Mango Powder",
    sName: "Amchoor Dry Mango Powder अमचूर पाउडर Amchoor aamchur Green Aam churan Spices",
    productName: "Dry Mango Powder",
    urlName: "Dry Mango Powder-100g-1",
    recipesId: [35, 41],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 0,
    mrp: 90,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Dried and powdered unripe mangoes."],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/dry-mango-powder.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/dry-mango-powder.png",
      "https://bawamasalacompany.com/assets/images/products/dry-mango-b.png",
    ],
    uses: null,
    desc:
      "Amchoor Masala or dried, powdered mango is a pantry staple across Indian households, for daily preparations of all lip-smacking street foods, and adding that zing to achaars (pickles).",
  },
  {
    id: 38,
    u_id: 34,
    hindiName: "स्पेशल राजमा मसाला",
    metaDesc: "",
    detailName: "Special Rajmah Masala",
    sName: "Special Rajmah Masala स्पेशल राजमा मसाला rajma kidney beans red",
    productName: "Special Rajmah Masala",
    urlName: "Special Rajmah Masala-100g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 0,
    mrp: 90,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: [
      "Coriander",
      "Fenugreek",
      "Black Pepper",
      "Salt",
      "Nutmeg",
      "Promegranate Seeds",
      "Chillies",
      "Dry Ginger",
      "Musk Melon",
      "Cardamom Seeds",
      "Dry Mango",
      "Caraway",
      "Cassia",
      "Mace",
      "Cloves",
      "Mustard",
      "Cinnamon",
    ],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/special-rajmah-masala.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/special-rajmah-masala.png",
      "https://bawamasalacompany.com/assets/images/products/special-rajmah-masala-hindi.png",
    ],
    uses: null,
    desc: "Spice blend from the traditional recipe, that makes for the tastiest Rajma, reminiscent of home cooking and food made by moms and gradmothers.",
  },
  {
    id: 45,
    u_id: 35,
    hindiName: "जल जीरा पाउडर",
    metaDesc: "",
    detailName: "Jal Jeera Powder",
    sName: "Jal Jeera Powder जल जीरा Jaljeera jaljira cumin seed Spices",
    productName: "Jal Jeera Powder",
    urlName: "Jal Jeera Powder-100g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 0,
    mrp: 76,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: [
      "White Salt",
      "Dry Mango",
      "Black Salt",
      "Mint Leaves",
      "Cumin Seeds",
      "Citric Acid",
      "Dry Ginger",
      "Bishop's Weed",
      "Asafoetida",
      "Seedless Tamarind",
      "Black Pepper",
      "Sat-ammoniac",
      "Yellow Chilli",
    ],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/jal-jeera.png",
    imgUrls: ["https://bawamasalacompany.com/assets/images/products/jal-jeera.png", "https://bawamasalacompany.com/assets/images/products/jal-jeera-b.png"],
    uses: null,
    desc:
      "Traditional recipe for refreshing, cold glasses of Jal Jeera. Jal Jeera is a drink that may be called the Indian version of the lemonade. And just like the lemonade it makes for a great cold drink in summer. And what better way to prepare it, than to just take a glass of water and add a spoonful of BMC Jal Jeera Powder. And the cooling effect is because of special herbs that go into the preparation of the BMC Jal Jeera Powder. Also a delicious addition to any cold drinks!",
  },
  {
    id: 48,
    u_id: 19,
    hindiName: "मिर्च पाउडर",
    metaDesc:
      "BMC's freshly ground, premium red chilli powder give your dishes the perfect heat and spicy kick! Versatile and essential addition to your spice box. Adds natural red colour to dishes. ",
    detailName: "Mirch Powder / Chilli Powder",
    sName: "Mirch Powder Chilli Powder मिर्च पाउडर Lal mirchi Spices chilli Laal",
    productName: "Mirch Powder",
    urlName: "Mirch Powder-100g-2",
    recipesId: [0, 4, 5, 9, 35, 36, 38, 41],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 0,
    mrp: 50,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Freshly ground red chilli powder", "Edible mustard oil added- not more than 2%"],
    type: "Spices",
    imgSrc: S58,
    imgUrls: [S58, SH58],
    uses: null,
    desc: "Excellent quality spice to add a dimension of heat to all dishes. Essential in most Indian dishes, to add that spicy kick!",
  },
  {
    id: 50,
    u_id: 36,
    hindiName: "जीरा पाउडर",
    metaDesc: "",
    detailName: "Zeera Powder / Cumin Powder",
    sName: "Zeera Powder Cumin Powder जीरा पाउडर jeera cumin",
    productName: "Zeera Powder",
    urlName: "Zeera Powder-100g-2",
    recipesId: [4, 36],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: "Cumin Powder",
    spl: 0,
    mrp: 85,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Finest Indian cumin, powdered."],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/zerra-powder.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/zerra-powder.png",
      "https://bawamasalacompany.com/assets/images/products/zerra-powder-back.png",
    ],
    uses: null,
    desc: "Powdered cumin adds an earthy, warming and aromatic character to food. For staple use in cuisines of numerous cultures.",
  },
  {
    id: 51,
    u_id: 37,
    hindiName: "जीरा होल",
    metaDesc: "",
    detailName: "Zeera Whole / Whole Cumin ",
    sName: "Zeera Whole Cumin Seeds जीरा होल jeera cumin seed",
    productName: "Zeera Whole",
    urlName: "Zeera Whole-100g-2",
    recipesId: [],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 0,
    mrp: 80,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Fresh and whole, high quality Indian cumin."],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/zerra-whole.png",
    imgUrls: ["https://bawamasalacompany.com/assets/images/products/zerra-whole.png", SH62],
    uses: null,
    desc: "Whole cumin that adds an earthy, warming and aromatic character to food. For staple use in cuisines of numerous cultures.",
  },
  {
    id: 53,
    u_id: 38,
    hindiName: "स्पेशल मःमः मसाला",
    metaDesc: "",
    detailName: "Special MoMo Masala",
    sName: "Special MoMo Masala स्पेशल मःमः मसाला momos chutney Spices",
    productName: "Special MoMo Masala",
    urlName: "Special MoMo Masala-100g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: "Enhances Flavour, Delicious in Taste",
    spl: 0,
    mrp: 97,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Cardamom-Amomum",
      "Fenugreek",
      "Cassia",
      "Turmeric",
      "Cloves",
      "Cumin-Seed",
      "Dry Ginger",
      "Cinnamon",
      "Mace",
      "Garlic",
      "Black Pepper",
    ],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/momos.png",
    imgUrls: ["https://bawamasalacompany.com/assets/images/products/momos.png", "https://bawamasalacompany.com/assets/images/products/momos-h.png"],
    uses: null,
    desc: "Makes delicious lip-smacking and authentic momos, with all the zingy flavour from the street-side stalls!",
  },
  {
    id: 54,
    u_id: 51,
    hindiName: "शाही पनीर मसाला",
    metaDesc: "",
    detailName: "Shahi Paneer Masala",
    sName: "Shahi Paneer Masala शाही पनीर मसाला makhani curry tofu",
    productName: "Shahi Paneer Masala",
    urlName: "Shahi Paneer Masala-100g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 0,
    mrp: 105,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Garlic",
      "Cassia",
      "Cardamom-Amomum",
      "Dry Ginger",
      "Black Pepper",
      "Cinnamon",
      "Cloves",
      "Saffron",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/shahi-paneer-masala-2.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/shahi-paneer-masala-2.png",
      "https://bawamasalacompany.com/assets/images/products/shahi-paneer-masala.png",
    ],
    uses: null,
    desc: "Masala that makes for a royal, rich and fragrant traditional Paneer dish.",
  },
  {
    id: 29,
    u_id: 1,
    hindiName: "स्पेशल मीट मसाला",
    metaDesc: "",
    detailName: "Special Meat Masala Mini Pouch",
    sName: "Special Meat Masala Mini Pouch स्पेशल मीट मसाला meat lal mas sabji laal",
    productName: "Special Meat Masala",
    urlName: "Special Meat Masala Mini Pouch-8g-0",
    recipesId: [],
    packType: 0,
    title: "Parrot-Kasoori-Methi",
    features: "Mini Pack",
    spl: 1,
    mrp: 5,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "8g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Garlic, Cassis",
      "Cardamom-Amomum",
      "Dry Ginger",
      "Black Pepper",
      "Cinnamon",
      "Cloves",
      "Saffron",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    imgSrc: S69,
    imgUrls: [S69, SH69],
    uses: null,
    desc: "Signature spice blend that makes for fragrant, rich, melt-in-the-mouth, traditional meat dishes. Now in a Mini Pouch!",
  },
  {
    id: 37,
    u_id: 4,
    hindiName: "गरम मसाला",
    metaDesc: "",
    detailName: "Garam Masala Mini Pouch",
    sName: "Garam Masala Mini Pouch गरम मसाला Murgh Makhani Chicken Tikka Spices",
    productName: "Garam Masala Mini Pouch",
    urlName: "Garam Masala Mini Pouch-8g-0",
    recipesId: [27],
    packType: 0,
    title: "Parrot-Kasoori-Methi",
    features: "Mini Pack",
    spl: 1,
    mrp: 5,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "8g",
    ingredients: ["Coriander", "Cumin Seed", "Black Pepper", "Cardamom", "Fenugreek", "Dry Ginger", "Cloves", "Cinnamo"],
    type: "Spices",
    imgSrc: S68,
    imgUrls: [S68, SH68],
    uses: null,
    desc:
      "This is the king combination of all masalas and is an essential addition to most Indian preparations. A mixture of many masalas, Garam Masala completes the dish. Be it a Biryani, Pulao, Pao-bhaji, any Vegetable dish or cereal preparation you just can't do without Garam Masala. Simply sprinkle a little BMC Garam Masala over the dishes cooked and relish the difference !",
  },
  {
    id: 33,
    u_id: 5,
    hindiName: "किचन किंग",
    metaDesc: "",
    detailName: "Kitchen King Mini Pouch",
    sName: "Kitchen King Mini Pouch किचन किंग sabji masala curry vegetable Spices",
    productName: "Kitchen King Mini Pouch",
    urlName: "Kitchen King Mini Pouch-8g-0",
    recipesId: [],
    packType: 0,
    title: "Parrot-Kasoori-Methi",
    features: "Mini Pack",
    spl: 1,
    mrp: 5,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "8g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fengreek",
      "Turmeric",
      "Garlic",
      "Cumin",
      "Cloves",
      "Black Pepper",
      "Cinnamon",
      "Dry Ginger",
      "Curry Leaves",
      "Cardamom- Amomum",
      "Saffron",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    imgSrc: S70,
    imgUrls: [S70, SH70],
    uses: null,
    desc:
      "The right mix of a number of special Masalas to bring out unparalleled taste in all vegetarian dishes. This multi-use spice-mix is an essential commodity for a kitchen where treats are a routine. Tips: Follow your usual cooking method and add 20 gms. of BMC Kitchen KIng to 1kg. veg. (or in right proportion) mixing it thoroughly. No other spices required.",
  },
  {
    id: 47,
    u_id: 7,
    hindiName: "मिटमास",
    metaDesc: "",
    detailName: "MetMas Mini Pouch",
    sName: "MetMas Mini Pouch मिटमास Meat masala Spices",
    productName: "MetMas Mini Pouch",
    urlName: "MetMas Mini Pouch-8g-0",
    recipesId: [],
    packType: 0,
    title: "Parrot-Kasoori-Methi",
    features: "Mini Pack",
    spl: 1,
    mrp: 5,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "8g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Garlic",
      "Cassia",
      "Cardamom-Ammomum",
      "Dry Ginger",
      "Black Pepper",
      "Cinnamon",
      "Cloves",
      "Saffron",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    imgSrc: S67,
    imgUrls: [S67, SH67],
    uses: null,
    desc:
      "Surprise your family & friends with exotic non-veg delicacies such as Mutton, Korma (Shahi) or Keema etc. by adding a little Metmas. Give the cuisine the exclusive colour and flavour. Signature spice blend, with saffron.",
  },
  {
    id: 40,
    u_id: 9,
    hindiName: "चिकमास",
    metaDesc: "",
    detailName: "Chickmas Mini Pouch",
    sName: "Chickmas Mini Pouch चिकमास chicken masala tikka butter makhani roast kebab Spices",
    productName: "Chickmas Mini Pouch",
    urlName: "Chickmas Mini Pouch-8g-0",
    recipesId: [],
    packType: 0,
    title: "Parrot-Kasoori-Methi",
    features: "Mini Pack",
    spl: 1,
    mrp: 5,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "8g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Cardamom-Amomum",
      "Garlic",
      "Black Pepper",
      "Cassia",
      "Dry Ginger",
      "Cinnamon",
      "Cloves",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    imgSrc: S63,
    imgUrls: [S63, SH63],
    uses: null,
    desc:
      "For all Chicken recipes this signature spice blend comes in handy. Handier than ever, now in a Mini Pouch! With BMC Chickmas, you would relish your favourite Chicken dishes more than ever. Tips: Add 20 gms. of Chickmas per kg. of Chicken, following your regular recipes and taste the difference.",
  },
  {
    id: 10,
    u_id: 10,
    hindiName: "फिश मसाला",
    metaDesc:
      "Fish Masala by Bawa Masala Company is a premium spice rub for those delicious pan-fried and oven-baked fish dishes. Great for flavourful gravies, marinades too.",
    detailName: "Fish Masala Mini Pouch",
    sName: "Fish Masala Mini Pouch फिश मसाला fish fry pakore curry machar jhol Spices",
    productName: "Fish Masala Mini Pouch",
    urlName: "Fish Masala Mini Pouch-8g-0",
    recipesId: [],
    packType: 0,
    title: "Fish Masala-mini",
    features: "Mini Pack",
    spl: 1,
    mrp: 5,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "8g",
    ingredients: [
      "Red Chillies",
      "Coriander",
      "Cumin Seeds",
      "Garlic",
      "Bishop's Weed",
      "Black Pepper",
      "Dry Mango",
      "Cinnamon",
      "Cloves",
      "Mace",
      "Ginger",
      "Turmeric",
    ],
    type: "Spices",
    imgSrc: S59,
    imgUrls: [S59, SH59],
    uses: null,
    desc: "High quality spice rub for those delicious pan-fried and oven-baked fish dishes. Essential for excellent, fragrant marinades too.",
  },
  {
    id: 7,
    u_id: 18,
    hindiName: "धनिया पाउडर",
    metaDesc: "",
    detailName: "Dhania Powder Mini Pouch / Coriander Powder",
    sName: "Dhania Powder Mini Pouch Coriander Powder धनिया पाउडर coriander dhaniya green Spices",
    productName: "Dhania Powder Mini Pouch",
    urlName: "Dhania Powder Mini Pouch-10g-0",
    recipesId: [5, 17, 18],
    packType: 0,
    title: "Dhania Powder",
    features: "Mini Pack",
    spl: 0,
    mrp: 5,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "10g",
    ingredients: ["Fresh green coriander dried and ground"],
    type: "Spices",
    imgSrc: S61,
    imgUrls: [S61, SH61],
    uses: null,
    desc: "Powdered coriander; an essential addition to most Indian daals and vegetable preparations.",
  },
  {
    id: 31,
    u_id: 17,
    hindiName: "हल्दी पाउडर",
    metaDesc: "BMC's finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
    detailName: "Haldi Powder Mini Pouch / Turmeric Powder",
    sName: "Haldi Powder Mini Pouch Turmeric Powder हल्दी पाउडर",
    productName: "Haldi Powder Mini Pouch",
    urlName: "Haldi Powder Mini Pouch-10g-0",
    recipesId: [26, 4, 15, 8],
    packType: 0,
    title: "Parrot-Kasoori-Methi",
    features: "Mini Pack",
    spl: 0,
    mrp: 5,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "10g",
    ingredients: ["Fine Indian Turmeric"],
    type: "Spices",
    imgSrc: S64,
    imgUrls: [S64, SH64],
    uses: null,
    desc: "Mini Pouch of finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
  },
  {
    id: 49,
    u_id: 19,
    hindiName: "मिर्च पाउडर",
    metaDesc: "",
    detailName: "Mirch Powder Mini Pouch / Chilli Powder",
    sName: "Mirch Powder Mini Pouch Chilli Powder मिर्च पाउडर Lal mirchi Spices chilli Laal",
    productName: "Mirch Powder Mini Pouch",
    urlName: "Mirch Powder Mini Pouch-10g-0",
    recipesId: [29, 30],
    packType: 0,
    title: "Parrot-Kasoori-Methi",
    features: "Mini Pack",
    spl: 0,
    mrp: 5,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "10g",
    ingredients: ["Freshly ground red chilli powder. Edible mustard oil added- not more than 2%."],
    type: "Spices",
    imgSrc: S65,
    imgUrls: [S65, SH65],
    uses: null,
    desc: "Excellent quality spice to add a dimension of heat to all dishes. Essential in most Indian dishes, to add that spicy kick!",
  },
  {
    id: 55,
    u_id: 39,
    hindiName: "सब्जी मसाला",
    metaDesc: "",
    detailName: "Sabzi Masala Mini Pouch",
    sName: "Sabzi Masala Mini Pouch सब्जी मसाला sabji vegetables spices",
    productName: "Sabzi Masala Mini Pouch",
    urlName: "Sabzi Masala Mini Pouch-6g-0",
    recipesId: [],
    packType: 0,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 0,
    mrp: 5,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "6g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Garlic",
      "Amomum",
      "Dry Ginger",
      "Black Pepper",
      "Cinnamon",
      "Cloves",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    imgSrc: S72,
    imgUrls: [S72, SH72],
    uses: null,
    desc: "Spices up all vegetable preparations and makes everyday Indian home food extraordinary.",
  },
  {
    id: 52,
    u_id: 40,
    hindiName: "लौंग",
    metaDesc: "",
    detailName: "Cloves Mini Pouch",
    sName: "Cloves Mini Pouch लौंग Laung",
    productName: "Cloves Mini Pouch",
    urlName: "Cloves Mini Pouch-1.85g-0",
    recipesId: [],
    packType: 0,
    title: "Parrot-Kasoori-Methi",
    features: "Mini Pack",
    spl: 0,
    mrp: 5,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "1.85g",
    ingredients: ["Indian Cloves"],
    type: "Spices",
    imgSrc: "https://bawamasalacompany.com/assets/images/products/cloves.png",
    imgUrls: ["https://bawamasalacompany.com/assets/images/products/cloves.png", "https://bawamasalacompany.com/assets/images/products/cloves-b.png"],
    uses: null,
    desc: "Whole cloves, now in a Mini Pouch!",
  },
  {
    id: 57,
    u_id: 41,
    hindiName: "अनारदाना पाउडर",
    metaDesc: "",
    detailName: "Anardana Powder / Pomegranate Seed Powder",
    sName: "Anardana Powder Pomegranate Seed Powder अनारदाना पाउडर pomegranate seed powder anardana spice anardana churan Spices",
    productName: "Anardana Powder",
    urlName: "Anardana Powder-100g-1",
    recipesId: [35],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 110,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Dried and powdered pomegranate seeds."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: "https://bawamasalacompany.com/assets/images/products/anardana-powder.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/anardana-powder.png",
      "https://bawamasalacompany.com/assets/images/products/anardana-powder-b.png",
    ],
    uses: null,
    desc: "Powdered pomegranate seeds, for preparing colourful and delicious dishes, with a tangy kick. Also used as an after-meal snack to ease heartburn!",
  },
  {
    id: 58,
    u_id: 41,
    hindiName: "अनारदाना पाउडर",
    metaDesc: "",
    detailName: "Anardana Powder / Pomegranate Seed Powder",
    sName: "Anardana Powder Pomegranate Seed Powder अनारदाना पाउडर pomegranate seed powder anardana spice anardana churan Spices",
    productName: "Anardana Powder",
    urlName: "Anardana Powder-50g-1",
    recipesId: [35],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 65,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: ["Dried and powdered pomegranate seeds."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S73,
    imgUrls: [S73, SH73],
    uses: null,
    desc: "Powdered pomegranate seeds, for preparing colourful and delicious dishes, with a tangy kick. Also used as an after-meal snack to ease heartburn!",
  },
  {
    id: 59,
    u_id: 11,
    hindiName: "काली मिर्च पाउडर",
    metaDesc:
      "BMC Black Pepper Powder, the well-known name for supreme, pure quality, freshly ground Indian Black Pepper. Used for cooking as well as a condiment, and full of health benefits.",
    detailName: "Black Pepper Powder",
    sName: "Black Pepper Powder काली मिर्च पाउडर kali mirch black pepper powder Spices Sabut",
    productName: "Black Pepper Powder",
    urlName: "Black Pepper Powder-8g-1",
    recipesId: [34],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 10,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "6g",
    ingredients: ["Fresh Indian black pepper, ground."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S107,
    imgUrls: [S107, SH107],
    uses: null,
    desc:
      "BMC Pepper, the well known name of pure and supreme quality, prepared from Indian Pepper. Thoroughly cleaned and care has been taken to retain its natural taste and original fragrance. It adds flavour to make the dish tastier.",
  },
  {
    id: 60,
    u_id: 11,
    hindiName: "काली मिर्च पाउडर",
    metaDesc:
      "BMC Black Pepper Powder, the well-known name for supreme, pure quality, freshly ground Indian Black Pepper. Used for cooking as well as a condiment, and full of health benefits.",
    detailName: "Black Pepper Powder",
    sName: "Black Pepper Powder काली मिर्च पाउडर kali mirch black pepper powder Spices Sabut",
    productName: "Black Pepper Powder",
    urlName: "Black Pepper Powder-50g-1",
    recipesId: [34],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 110,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: ["Fresh Indian black pepper", "ground."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: "https://bawamasalacompany.com/assets/images/products/black-pepper-powder.png",
    imgUrls: ["https://bawamasalacompany.com/assets/images/products/black-pepper-powder.png", SH151],
    uses: null,
    desc:
      "BMC Pepper, the well known name of pure and supreme quality, prepared from Indian Pepper. Thoroughly cleaned and care has been taken to retain its natural taste and original fragrance. It adds flavour to make the dish tastier.",
  },
  {
    id: 61,
    u_id: 3,
    hindiName: "चना मसाला",
    metaDesc: "",
    detailName: "Chana Masala",
    sName: "Chana Masala चना मसाला chana bathure masala dry chole chawal channa Spices",
    productName: "Chana Masala",
    urlName: "Chana Masala-15g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 10,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "15g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Turmeric",
      "Cumin Seeds",
      "White Salt",
      "Dry Mango",
      "Bishop's Weed",
      "Pomegranate Seeds",
      "Dry Ginger",
      "Fenugreek",
      "Black Salt",
      "Cardamom- Amomum",
      "Cassia",
      "Cloves",
      "Black Pepper",
      "Embica",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S75,
    imgUrls: [S75, SH75],
    uses: null,
    desc: "Takes the regular Chana dish to another level of taste and flavour, demanding another bathura or two to mop up that delicious gravy!",
  },
  {
    id: 62,
    u_id: 3,
    hindiName: "चना मसाला",
    metaDesc: "",
    detailName: "Chana Masala",
    sName: "Chana Masala चना मसाला chana bathure masala dry chole chawal channa Spices",
    productName: "Chana Masala",
    urlName: "Chana Masala-50g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 58,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Turmeric",
      "Cumin Seeds",
      "White Salt",
      "Dry Mango",
      "Bishop's Weed",
      "Pomegranate Seeds",
      "Dry Ginger",
      "Fenugreek",
      "Black Salt",
      "Cardamom- Amomum",
      "Cassia",
      "Cloves",
      "Black Pepper",
      "Embica",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S153,
    imgUrls: [S153, SH153],
    uses: null,
    desc: "Takes the regular Chana dish to another level of taste and flavour, demanding another bathura or two to mop up that delicious gravy!",
  },
  {
    id: 63,
    u_id: 3,
    hindiName: "चना मसाला",
    metaDesc: "",
    detailName: "Chana Masala",
    sName: "Chana Masala चना मसाला chana bathure masala dry chole chawal channa Spices",
    productName: "Chana Masala",
    urlName: "Chana Masala-500g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 443,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "500g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Turmeric",
      "Cumin Seeds",
      "White Salt",
      "Dry Mango",
      "Bishop's Weed",
      "Pomegranate Seeds",
      "Dry Ginger",
      "Fenugreek",
      "Black Salt",
      "Cardamom- Amomum",
      "Cassia",
      "Cloves",
      "Black Pepper",
      "Embica",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S79,
    imgUrls: [S79, SH79],
    uses: null,
    desc: "Takes the regular Chana dish to another level of taste and flavour, demanding another bathura or two to mop up that delicious gravy!",
  },
  {
    id: 64,
    u_id: 2,
    hindiName: "चाट मसाला",
    metaDesc: "",
    detailName: "Chat Masala",
    sName: "Chat Masala चाट मसाला chaat pani puri sev aloo fruit salad shakarkand Spices",
    productName: "Chat Masala",
    urlName: "Chat Masala-15g-1",
    recipesId: [35],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 10,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "15g",
    ingredients: ["White Salt", "Black Salt", "Dry Mango", "Mint Leaves", "Cumin Seeds", "Bishop's Weed", "Yellow Chillies", "Dry Ginger."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S80,
    imgUrls: [S80, SH80],
    uses: null,
    desc: "Delicious masala for preparation of all Chaats (street food) and salads. Makes aloo chaat, pani puris, fruit salad and papri chaat lip-smacking! ",
  },
  {
    id: 65,
    u_id: 2,
    hindiName: "चाट मसाला",
    metaDesc: "",
    detailName: "Chat Masala",
    sName: "Chat Masala  चाट मसाला chaat pani puri sev aloo fruit salad shakarkand Spices",
    productName: "Chat Masala",
    urlName: "Chat Masala-50g-1",
    recipesId: [35],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 58,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: ["White Salt", "Black Salt", "Dry Mango", "Mint Leaves", "Cumin Seeds", "Bishop's Weed", "Yellow Chillies", "Dry Ginger."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S109,
    imgUrls: [S109, SH109],
    uses: null,
    desc: "Delicious masala for preparation of all Chaats (street food) and salads. Makes aloo chaat, pani puris, fruit salad and papri chaat lip-smacking! ",
  },
  {
    id: 66,
    u_id: 2,
    hindiName: "चाट मसाला",
    metaDesc: "",
    detailName: "Chat Masala",
    sName: "Chat Masala  चाट मसाला chaat pani puri sev aloo fruit salad shakarkand Spices",
    productName: "Chat Masala",
    urlName: "Chat Masala-500g-1",
    recipesId: [35],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 443,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "500g",
    ingredients: ["White Salt", "Black Salt", "Dry Mango", "Mint Leaves", "Cumin Seeds", "Bishop's Weed", "Yellow Chillies", "Dry Ginger."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S81,
    imgUrls: [S81, SH81],
    uses: null,
    desc: "Delicious masala for preparation of all Chaats (street food) and salads. Makes aloo chaat, pani puris, fruit salad and papri chaat lip-smacking! ",
  },
  {
    id: 67,
    u_id: 9,
    hindiName: "चिकमास",
    metaDesc: "",
    detailName: "Chickmas",
    sName: "Chickmas Chick Mas चिकमास chicken masala tikka butter makhani roast kebab Spices",
    productName: "Chickmas",
    urlName: "Chick Mas-15g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 10,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "15g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Cardamom-Amomum",
      "Garlic",
      "Black Pepper",
      "Cassia",
      "Dry Ginger",
      "Cinnamon",
      "Cloves",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S82,
    imgUrls: [S82, SH82],
    uses: null,
    desc:
      "For all Chicken recipes this signature spice blend comes in handy. Handier than ever, now in a Mini Pack! With BMC Chickmas, you would relish your favourite Chicken dishes more than ever. Tips: Add 20 gms. of Chickmas per kg. of Chicken, following your regular recipes and taste the difference.",
  },
  {
    id: 68,
    u_id: 9,
    hindiName: "चिकमास",
    metaDesc: "",
    detailName: "Chickmas",
    sName: "Chickmas Chick Mas चिकमास chicken masala tikka butter makhani roast kebab Spices",
    productName: "Chickmas",
    urlName: "Chick Mas-25g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 45,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "25g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Cardamom-Amomum",
      "Garlic",
      "Black Pepper",
      "Cassia",
      "Dry Ginger",
      "Cinnamon",
      "Cloves",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S111,
    imgUrls: [S111, SH111],
    uses: null,
    desc:
      "For all Chicken recipes this signature spice blend comes in handy. Handier than ever, now in a Mini Pack! With BMC Chickmas, you would relish your favourite Chicken dishes more than ever. Tips: Add 20 gms. of Chickmas per kg. of Chicken, following your regular recipes and taste the difference.",
  },
  {
    id: 69,
    u_id: 9,
    hindiName: "चिकमास",
    metaDesc: "",
    detailName: "Chickmas",
    sName: "Chickmas Chick Mas चिकमास chicken masala tikka butter makhani roast kebab Spices",
    productName: "Chickmas",
    urlName: "Chick Mas-50g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 62,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Cardamom-Amomum",
      "Garlic",
      "Black Pepper",
      "Cassia",
      "Dry Ginger",
      "Cinnamon",
      "Cloves",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: "https://bawamasalacompany.com/assets/images/products/chickmas.png",
    imgUrls: ["https://bawamasalacompany.com/assets/images/products/chickmas.png"],
    uses: null,
    desc:
      "For all Chicken recipes this signature spice blend comes in handy. Handier than ever, now in a Mini Pack! With BMC Chickmas, you would relish your favourite Chicken dishes more than ever. Tips: Add 20 gms. of Chickmas per kg. of Chicken, following your regular recipes and taste the difference.",
  },
  {
    id: 70,
    u_id: 42,
    hindiName: "चाऊमिन मसाला",
    metaDesc: "",
    detailName: "Chowmein Masala",
    sName: "Chowmein Masala चाऊमिन मसाला hakka noodles chowmein masala chow mein Spices",
    productName: "Chowmein Masala",
    urlName: "Chowmein Masala-50g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 62,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Turmeric",
      "Cumin-Seed",
      "Cardmom- Amomum",
      "Black Pepper",
      "Cloves",
      "Dry Ginger",
      "Cinnamon",
      "Mace",
      "Fenugreek",
      "Cassia",
      "Garlic",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: "https://bawamasalacompany.com/assets/images/products/special-chowmein-masala-f.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/special-chowmein-masala-f.png",
      "https://bawamasalacompany.com/assets/images/products/special-chowmein-masala.png",
    ],
    uses: null,
    desc: "Secret blend of Chinese spices that are perfect for tossing up a wok full of spicy street-style chowmein.",
  },
  {
    id: 71,
    u_id: 29,
    hindiName: "करी पाउडर",
    metaDesc: "",
    detailName: "Curry Powder",
    sName: "Curry Powder करी पाउडर gravy Butter Chicken Spices",
    productName: "Curry Powder",
    urlName: "Curry Powder-100g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 52,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: [
      "Coriander",
      "Fenugreek",
      "Chilli",
      "Black Pepper",
      "Turmeric",
      "Cardamom-Amomum",
      "Cinnamom",
      "Dry Ginger",
      "Cloves",
      "Nutmeg",
      "Mace",
      "Salt not more than 5%",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S156,
    imgUrls: [S156, SH156],
    uses: null,
    desc: "All purpose spice blend used commonly to flavor soups, stews, sauces, marinades, meat, and vegetables.",
  },
  {
    id: 72,
    u_id: 18,
    hindiName: "धनिया पाउडर",
    metaDesc: "BMC Dhania Powder is freshly ground, and a healthy, essential condiment for all Indian dishes. ",
    detailName: "Dhania Powder / Coriander Powder",
    sName: "Dhania Powder Coriander Powder धनिया पाउडर coriander dhaniya green Spices",
    productName: "Dhania Powder",
    urlName: "Dhania Powder-20g-2",
    recipesId: [4, 5, 34, 36],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 10,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "20g",
    ingredients: ["Fresh green coriander dried and ground"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S185,
    imgUrls: [S185, SH185],
    uses: null,
    desc: "Powdered coriander; an essential addition to most Indian daals and vegetable preparations.",
  },
  {
    id: 73,
    u_id: 18,
    hindiName: "धनिया पाउडर",
    metaDesc: "BMC Dhania Powder is freshly ground, and a healthy, essential condiment for all Indian dishes. ",
    detailName: "Dhania Powder / Coriander Powder",
    sName: "Dhania Powder Coriander Powder धनिया पाउडर coriander dhaniya green Spices",
    productName: "Dhania Powder",
    urlName: "Dhania Powder-50g-2",
    recipesId: [4, 5, 34, 36],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 19,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: ["Fresh green coriander dried and ground"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S186,
    imgUrls: [S186, SH186],
    uses: null,
    desc: "Powdered coriander; an essential addition to most Indian daals and vegetable preparations.",
  },
  {
    id: 74,
    u_id: 18,
    hindiName: "धनिया पाउडर",
    metaDesc: "BMC Dhania Powder is freshly ground, and a healthy, essential condiment for all Indian dishes. ",
    detailName: "Dhania Powder / Coriander Powder",
    sName: "Dhania Powder Coriander Powder धनिया पाउडर coriander dhaniya green Spices",
    productName: "Dhania Powder",
    urlName: "Dhania Powder-100g-1",
    recipesId: [4, 5, 34, 36],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 39,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Fresh green coriander dried and ground"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: "https://bawamasalacompany.com/assets/images/products/dhania-powder.png",
    imgUrls: ["https://bawamasalacompany.com/assets/images/products/dhania-powder.png", SH119],
    uses: null,
    desc: "Powdered coriander; an essential addition to most Indian daals and vegetable preparations.",
  },
  {
    id: 75,
    u_id: 18,
    hindiName: "धनिया पाउडर",
    metaDesc: "BMC Dhania Powder is freshly ground, and a healthy, essential condiment for all Indian dishes. ",
    detailName: "Dhania Powder / Coriander Powder",
    sName: "Dhania Powder Coriander Powder धनिया पाउडर coriander dhaniya green Spices",
    productName: "Dhania Powder",
    urlName: "Dhania Powder-200g-2",
    recipesId: [4, 5, 34, 36],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 73,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "200g",
    ingredients: ["Fresh green coriander dried and ground"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S187,
    imgUrls: [S187, SH187],
    uses: null,
    desc: "Powdered coriander; an essential addition to most Indian daals and vegetable preparations.",
  },
  {
    id: 76,
    u_id: 18,
    hindiName: "धनिया पाउडर",
    metaDesc: "BMC Dhania Powder is freshly ground, and a healthy, essential condiment for all Indian dishes. ",
    detailName: "Dhania Powder / Coriander Powder",
    sName: "Dhania Powder Coriander Powder धनिया पाउडर coriander dhaniya green Spices",
    productName: "Dhania Powder",
    urlName: "Dhania Powder-500g-2",
    recipesId: [4, 5, 34, 36],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 183,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "500g",
    ingredients: ["Fresh green coriander dried and ground"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S188,
    imgUrls: [S188, SH188],
    uses: null,
    desc: "Powdered coriander; an essential addition to most Indian daals and vegetable preparations.",
  },
  {
    id: 77,
    u_id: 18,
    hindiName: "धनिया पाउडर",
    metaDesc: "BMC Dhania Powder is freshly ground, and a healthy, essential condiment for all Indian dishes. ",
    detailName: "Dhania Powder / Coriander Powder",
    sName: "Dhania Powder Coriander Powder धनिया पाउडर coriander dhaniya green Spices",
    productName: "Dhania Powder",
    urlName: "Dhania Powder-1 Kg-2",
    recipesId: [4, 5, 34, 36],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 363,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "1 Kg",
    ingredients: ["Fresh green coriander dried and ground"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S183,
    imgUrls: [S183, SH183],
    uses: null,
    desc: "Powdered coriander; an essential addition to most Indian daals and vegetable preparations.",
  },
  {
    id: 78,
    u_id: 18,
    hindiName: "धनिया पाउडर",
    metaDesc: "BMC Dhania Powder is freshly ground, and a healthy, essential condiment for all Indian dishes. ",
    detailName: "Dhania Powder / Coriander Powder",
    sName: "Dhania Powder Coriander Powder धनिया पाउडर coriander dhaniya green Spices",
    productName: "Dhania Powder",
    urlName: "Dhania Powder-5 Kg-2",
    recipesId: [4, 5, 34, 36],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 1778,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "5 Kg",
    ingredients: ["Fresh green coriander dried and ground"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S184,
    imgUrls: [S184, SH184],
    uses: null,
    desc: "Powdered coriander; an essential addition to most Indian daals and vegetable preparations.",
  },
  {
    id: 79,
    u_id: 43,
    hindiName: "डेब्बी मिर्च",
    metaDesc: "",
    detailName: "Debbi Mirch",
    sName: "Debbi Mirch डेब्बी मिर्च",
    productName: "Debbi Mirch",
    urlName: "Debbi Mirch-100g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 110,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Red Chillies"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: "https://bawamasalacompany.com/assets/images/products/debbi-mirch.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/debbi-mirch.png",
      // SH118,
    ],
    uses: null,
    desc: "Chilli powder makes dishes delicious and colourful!",
  },
  {
    id: 80,
    u_id: 33,
    hindiName: "अमचूर पाउडर",
    metaDesc: "",
    detailName: "Amchoor / Dry Mango Powder",
    sName: "Amchoor Dry Mango Powder अमचूर पाउडर Amchoor aamchur Green Aam churan Spices",
    productName: "Dry Mango Powder",
    urlName: "Dry Mango Powder -50g-1",
    recipesId: [35, 41],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 54,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: ["Dried and powdered unripe mangoes."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S120,
    imgUrls: [S120, SH120],
    uses: null,
    desc:
      "Amchoor Masala or dried, powdered mango is a pantry staple across Indian households, for daily preparations of all lip-smacking street foods, and adding that zing to achaars (pickles).",
  },
  {
    id: 81,
    u_id: 10,
    hindiName: "फिश मसाला",
    metaDesc: "",
    detailName: "Fish Masala",
    sName: "Fish Masala फिश मसाला fish fry pakore curry machar jhol Spices",
    productName: "Fish Masala",
    urlName: "Fish Masala-50g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 53,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: [
      "Red Chillies",
      "Coriander",
      "Cumin Seeds",
      "Garlic",
      "Bishop's Weed",
      "Black Pepper",
      "Dry Mango",
      "Cinnamon",
      "Cloves",
      "Mace",
      "Ginger",
      "Turmeric",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S121,
    imgUrls: [S121, SH121],
    uses: null,
    desc: "High quality spice rub for those delicious pan-fried and oven-baked fish dishes. Essential for excellent, fragrant marinades too.",
  },
  {
    id: 82,
    u_id: 4,
    hindiName: "गरम मसाला",
    metaDesc: "",
    detailName: "Garam Masala",
    sName: "Garam Masala गरम मसाला Murgh Makhani Chicken Tikka Spices",
    productName: "Garam Masala",
    urlName: "Garam Masala-15g-1",
    recipesId: [4, 9, 35],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 10,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "15g",
    ingredients: ["Coriander", "Cumin Seed", "Black Pepper", "Cardamom", "Fenugreek", "Dry Ginger", "Cloves", "Cinnamon"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S84,
    imgUrls: [S84, SH84],
    uses: null,
    desc:
      "This is the king combination of all masalas and is an essential addition to most Indian preparations. Now in a Mini Pack! A mixture of many masalas, Garam Masala completes the dish. Be it a Biryani, Pulao, Pao-bhaji, any Vegetable dish or cereal preparation you just can't do without Garam Masala. Simply sprinkle a little BMC Garam Masala over the dishes cooked and relish the difference !",
  },
  {
    id: 83,
    u_id: 4,
    hindiName: "गरम मसाला",
    metaDesc: "",
    detailName: "Garam Masala",
    sName: "Garam Masala गरम मसाला Murgh Makhani Chicken Tikka Spices",
    productName: "Garam Masala",
    urlName: "Garam Masala-25g-1",
    recipesId: [4, 9, 35],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 32,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "25g",
    ingredients: ["Coriander", "Cumin Seed", "Black Pepper", "Cardamom", "Fenugreek", "Dry Ginger", "Cloves", "Cinnamon"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S85,
    imgUrls: [S85, SH85],
    uses: null,
    desc:
      "This is the king combination of all masalas and is an essential addition to most Indian preparations. Now in a Mini Pack! A mixture of many masalas, Garam Masala completes the dish. Be it a Biryani, Pulao, Pao-bhaji, any Vegetable dish or cereal preparation you just can't do without Garam Masala. Simply sprinkle a little BMC Garam Masala over the dishes cooked and relish the difference !",
  },
  {
    id: 84,
    u_id: 4,
    hindiName: "गरम मसाला",
    metaDesc: "",
    detailName: "Garam Masala",
    sName: "Garam Masala गरम मसाला Murgh Makhani Chicken Tikka Spices",
    productName: "Garam Masala",
    urlName: "Garam Masala-50g-1",
    recipesId: [4, 9, 35],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 64,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: ["Coriander", "Cumin Seed", "Black Pepper", "Cardamom", "Fenugreek", "Dry Ginger", "Cloves", "Cinnamon"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S122,
    imgUrls: [S122, SH122],
    uses: null,
    desc:
      "This is the king combination of all masalas and is an essential addition to most Indian preparations. Now in a Mini Pack! A mixture of many masalas, Garam Masala completes the dish. Be it a Biryani, Pulao, Pao-bhaji, any Vegetable dish or cereal preparation you just can't do without Garam Masala. Simply sprinkle a little BMC Garam Masala over the dishes cooked and relish the difference !",
  },
  {
    id: 85,
    u_id: 4,
    hindiName: "गरम मसाला",
    metaDesc: "",
    detailName: "Garam Masala",
    sName: "Garam Masala गरम मसाला Murgh Makhani Chicken Tikka Spices",
    productName: "Garam Masala",
    urlName: "Garam Masala-500g-1",
    recipesId: [4, 9, 35],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 538,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "500g",
    ingredients: ["Coriander", "Cumin Seed", "Black Pepper", "Cardamom", "Fenugreek", "Dry Ginger", "Cloves", "Cinnamon"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S86,
    imgUrls: [S86, SH86],
    uses: null,
    desc:
      "This is the king combination of all masalas and is an essential addition to most Indian preparations. Now in a Mini Pack! A mixture of many masalas, Garam Masala completes the dish. Be it a Biryani, Pulao, Pao-bhaji, any Vegetable dish or cereal preparation you just can't do without Garam Masala. Simply sprinkle a little BMC Garam Masala over the dishes cooked and relish the difference !",
  },
  {
    id: 86,
    u_id: 45,
    hindiName: "सौंठ पाउडर",
    metaDesc: "",
    detailName: "Ginger Powder",
    sName: "Ginger Powder सौंठ पाउडर Dry Organic Saunth Spices",
    productName: "Ginger Powder",
    urlName: "Ginger Powder-100g-1",
    recipesId: [42],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 100,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Indian Ginger"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: "https://bawamasalacompany.com/assets/images/products/ginger.png",
    imgUrls: ["https://bawamasalacompany.com/assets/images/products/ginger.png", "https://bawamasalacompany.com/assets/images/products/ginger-b.png"],
    uses: null,
    desc: "Freshly ground ginger powder, aromatic and flavourful. Full of health benefits, and great for Indian and Chinese recipes.",
  },
  {
    id: 87,
    u_id: 45,
    hindiName: "सौंठ पाउडर",
    metaDesc: "",
    detailName: "Ginger Powder",
    sName: "Ginger Powder सौंठ पाउडर Dry Organic Saunth Spices",
    productName: "Ginger Powder",
    urlName: "Ginger Powder-50g-1",
    recipesId: [42],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 60,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: ["Indian Ginger"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S123,
    imgUrls: [S123, SH123],
    uses: null,
    desc: "Freshly ground ginger powder, aromatic and flavourful. Full of health benefits, and great for Indian and Chinese recipes.",
  },
  {
    id: 88,
    u_id: 17,
    hindiName: "हल्दी पाउडर",
    metaDesc: "BMC's finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
    detailName: "Haldi Powder / Turmeric Powder",
    sName: "Haldi Powder Turmeric Powder हल्दी पाउडर",
    productName: "Haldi Powder",
    urlName: "Haldi Powder-30g-2",
    recipesId: [39, 36, 37, 4, 30, 32, 33, 34, 42],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 10,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "30g",
    ingredients: ["Fine Indian Turmeric"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S192,
    imgUrls: [S192, SH192],
    uses: null,
    desc: "Finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
  },
  {
    id: 89,
    u_id: 17,
    hindiName: "हल्दी पाउडर",
    metaDesc: "BMC's finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
    detailName: "Haldi Powder / Turmeric Powder",
    sName: "Haldi Powder Turmeric Powder हल्दी पाउडर",
    productName: "Haldi Powder",
    urlName: "Haldi Powder-50g-1",
    recipesId: [39, 36, 37, 4, 30, 32, 33, 34, 42],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 30,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: ["Fine Indian Turmeric"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S125,
    imgUrls: [S125, SH125],
    uses: null,
    desc: "Finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
  },
  {
    id: 91,
    u_id: 17,
    hindiName: "हल्दी पाउडर",
    metaDesc: "BMC's finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
    detailName: "Haldi Powder / Turmeric Powder",
    sName: "Haldi Powder Turmeric Powder हल्दी पाउडर ",
    productName: "Haldi Powder",
    urlName: "Haldi Powder-200g-2",
    recipesId: [39, 36, 37, 4, 30, 32, 33, 34, 42],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 109,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "200g",
    ingredients: ["Fine Indian Turmeric"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S194,
    imgUrls: [S194, SH194],
    uses: null,
    desc: "Finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
  },
  {
    id: 92,
    u_id: 17,
    hindiName: "हल्दी पाउडर",
    metaDesc: "BMC's finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
    detailName: "Haldi Powder / Turmeric Powder",
    sName: "Haldi Powder Turmeric Powder हल्दी पाउडर ",
    productName: "Haldi Powder",
    urlName: "Haldi Powder-500g-2",
    recipesId: [39, 36, 37, 4, 30, 32, 33, 34, 42],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 273,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "500g",
    ingredients: ["Fine Indian Turmeric"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S195,
    imgUrls: [S195, SH195],
    uses: null,
    desc: "Finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
  },
  {
    id: 93,
    u_id: 17,
    hindiName: "हल्दी पाउडर",
    metaDesc: "BMC's finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
    detailName: "Haldi Powder / Turmeric Powder",
    sName: "Haldi Powder Turmeric Powder हल्दी पाउडर ",
    productName: "Haldi Powder",
    urlName: "Haldi Powder-1 Kg-2",
    recipesId: [39, 36, 37, 4, 30, 32, 33, 34, 42],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 543,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "1 Kg",
    ingredients: ["Fine Indian Turmeric"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S190,
    imgUrls: [S190, SH190],
    uses: null,
    desc: "Finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
  },
  {
    id: 94,
    u_id: 17,
    hindiName: "हल्दी पाउडर",
    metaDesc: "BMC's finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
    detailName: "Haldi Powder / Turmeric Powder",
    sName: "Haldi Powder Turmeric Powder हल्दी पाउडर ",
    productName: "Haldi Powder",
    urlName: "Haldi Powder-5 Kg-2",
    recipesId: [39, 36, 37, 4, 30, 32, 33, 34, 42],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 2678,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "5 Kg",
    ingredients: ["Fine Indian Turmeric"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S191,
    imgUrls: [S191, SH191],
    uses: null,
    desc: "Finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
  },
  {
    id: 95,
    u_id: 35,
    hindiName: "जल जीरा पाउडर",
    metaDesc: "",
    detailName: "Jal Jeera Powder",
    sName: "Jal Jeera जल जीरा Jaljeera jaljira cumin seed Spices Cumin Powder Jal Jeera Powder",
    productName: "Jal Jeera Powder",
    urlName: "Jal Jeera-100g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 47,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: [
      "White Salt",
      "Dry Mango",
      "Black Salt",
      "Mint Leaves",
      "Cumin Seeds",
      "Citric Acid",
      "Dry Ginger",
      "Bishop's Weed",
      "Asafoetida",
      "Seedless Tamarind",
      "Black Pepper",
      "Sat-ammoniac",
      "Yellow Chilli",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S126,
    imgUrls: [S126, SH126],
    uses: null,
    desc:
      "Traditional recipe for refreshing, cold glasses of Jal Jeera. Jal Jeera is a drink that may be called the Indian version of the lemonade. And just like the lemonade it makes for a great cold drink in summer. And what better way to prepare it, than to just take a glass of water and add a spoonful of BMC Jal Jeera Powder. And the cooling effect is because of special herbs that go into the preparation of the BMC Jal Jeera Powder. Also a delicious addition to any cold drinks!",
  },
  {
    id: 96,
    u_id: 8,
    hindiName: "कश्मीरी मिर्च",
    metaDesc: "",
    detailName: "Kashmiri Mirch",
    sName: "Kashmiri Mirch कश्मीरी मिर्च Red chilli lal laal Spices",
    productName: "Kashmiri Mirch",
    urlName: "Kashmiri Mirch-15g-1",
    recipesId: [2],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 10,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "15g",
    ingredients: ["Freshly ground chilli powder from handpicked Indian red chillies. Edible mustard oil added- not more than 2%."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S92,
    imgUrls: [S92, SH92],
    uses: null,
    desc: "Chilli powder makes dishes delicious and colourful!",
  },
  {
    id: 97,
    u_id: 8,
    hindiName: "कश्मीरी मिर्च",
    metaDesc: "",
    detailName: "Kashmiri Mirch",
    sName: "Kashmiri Mirch कश्मीरी मिर्च Red chilli lal laal Spices",
    productName: "Kashmiri Mirch",
    urlName: "Kashmiri Mirch-50g-1",
    recipesId: [2],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 70,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: ["Freshly ground chilli powder from handpicked Indian red chillies. Edible mustard oil added- not more than 2%."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S128,
    imgUrls: [S128, SH128],
    uses: null,
    desc: "Chilli powder makes dishes delicious and colourful!",
  },
  /*   {
    id: 98,
    u_id: 47,
    hindiName: "पैरट कसूरी मेथी",
    metaDesc: "",
    detailName: "Parrot Kasoori Methi ",
    sName: "Parrot Kasoori Methi  Kasoori Methi कसूरी मेथी kasuri fenugreek leaf  Spices",
    productName: "Parrot Kasoori Methi ",
    urlName: "Parrot Kasoori Methi-250g-1",
    recipesId: [5],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 164,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "250g",
    ingredients: ["Dried fenugreek."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: "https://bawamasalacompany.com/assets/images/products/kasoori-methi.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/kasoori-methi.png",
      "https://bawamasalacompany.com/assets/images/products/kasoori-methi-b.png",
    ],
    uses: null,
    desc: "Sun-dried fenugreek leaves, powdered for use in a variety of Indian favourites such as Butter Chicken and Paneer Tikka.",
  }, */
  {
    id: 99,
    u_id: 5,
    hindiName: "किचन किंग",
    metaDesc: "",
    detailName: "Kitchen King",
    sName: "Kitchen King किचन किंग sabji masala curry vegetable Spices",
    productName: "Kitchen King",
    urlName: "Kitchen King-15g-1",
    recipesId: [9],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 10,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "15g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fengreek",
      "Turmeric",
      "Garlic",
      "Cumin",
      "Cloves",
      "Black Pepper",
      "Cinnamon",
      "Dry Ginger",
      "Curry Leaves",
      "Cardamom- Amomum",
      "Saffron",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S89,
    imgUrls: [S89, SH89],
    uses: null,
    desc:
      "The right mix of a number of special Masalas to bring out unparalleled taste in all vegetarian dishes. This multi-use spice-mix is an essential commodity for a kitchen where treats are a routine. Tips: Follow your usual cooking method and add 20 gms. of BMC Kitchen KIng to 1kg. veg. (or in right proportion) mixing it thoroughly. No other spices required.",
  },
  {
    id: 100,
    u_id: 5,
    hindiName: "किचन किंग",
    metaDesc: "",
    detailName: "Kitchen King",
    sName: "Kitchen King किचन किंग sabji masala curry vegetable Spices",
    productName: "Kitchen King",
    urlName: "Kitchen King-50g-1",
    recipesId: [9],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 62,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fengreek",
      "Turmeric",
      "Garlic",
      "Cumin",
      "Cloves",
      "Black Pepper",
      "Cinnamon",
      "Dry Ginger",
      "Curry Leaves",
      "Cardamom- Amomum",
      "Saffron",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S127,
    imgUrls: [S127, SH127],
    uses: null,
    desc:
      "The right mix of a number of special Masalas to bring out unparalleled taste in all vegetarian dishes. This multi-use spice-mix is an essential commodity for a kitchen where treats are a routine. Tips: Follow your usual cooking method and add 20 gms. of BMC Kitchen KIng to 1kg. veg. (or in right proportion) mixing it thoroughly. No other spices required.",
  },
  {
    id: 101,
    u_id: 5,
    hindiName: "किचन किंग",
    metaDesc: "",
    detailName: "Kitchen King",
    sName: "Kitchen King किचन किंग sabji masala curry vegetable Spices",
    productName: "Kitchen King",
    urlName: "Kitchen King-500g-1",
    recipesId: [9],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 478,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "500g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fengreek",
      "Turmeric",
      "Garlic",
      "Cumin",
      "Cloves",
      "Black Pepper",
      "Cinnamon",
      "Dry Ginger",
      "Curry Leaves",
      "Cardamom- Amomum",
      "Saffron",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S91,
    imgUrls: [S91, SH91],
    uses: null,
    desc:
      "The right mix of a number of special Masalas to bring out unparalleled taste in all vegetarian dishes. This multi-use spice-mix is an essential commodity for a kitchen where treats are a routine. Tips: Follow your usual cooking method and add 20 gms. of BMC Kitchen KIng to 1kg. veg. (or in right proportion) mixing it thoroughly. No other spices required.",
  },
  {
    id: 102,
    u_id: 7,
    hindiName: "मिटमास",
    metaDesc: "",
    detailName: "Metmas",
    sName: "Metmas मिटमास Meat masala Spices Metmas Saffron Base",
    productName: "Metmas",
    urlName: "Metmas-15g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 10,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "15g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Garlic",
      "Cassia",
      "Cardamom-Ammomum",
      "Dry Ginger",
      "Black Pepper",
      "Cinnamon",
      "Cloves",
      "Saffron",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S129,
    imgUrls: [S129, SH129],
    uses: null,
    desc:
      "Surprise your family & friends with exotic non-veg delicacies such as Mutton, Korma (Shahi) or Keema etc. by adding a little Metmas. Give the cuisine the exclusive colour and flavour. Signature spice blend, with saffron.",
  },
  {
    id: 103,
    u_id: 7,
    hindiName: "मिटमास",
    metaDesc: "",
    detailName: "Metmas",
    sName: "Metmas मिटमास Meat masala Spices",
    productName: "Metmas",
    urlName: "Metmas-50g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 62,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Garlic",
      "Cassia",
      "Cardamom-Ammomum",
      "Dry Ginger",
      "Black Pepper",
      "Cinnamon",
      "Cloves",
      "Saffron",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S130,
    imgUrls: [S130, SH130],
    uses: null,
    desc:
      "Surprise your family & friends with exotic non-veg delicacies such as Mutton, Korma (Shahi) or Keema etc. by adding a little Metmas. Give the cuisine the exclusive colour and flavour. Signature spice blend, with saffron.",
  },
  {
    id: 104,
    u_id: 48,
    hindiName: "मिर्च कुट्टी",
    metaDesc: "",
    detailName: "Mirch Kutti / Red Chillies Kutti",
    sName: "Mirch Kutti Red Chillies Kutti मिर्च कुट्टी Lal mirchi Spices chilli laal",
    productName: "Mirch Kutti",
    urlName: "Mirch Kutti-100g-1",
    recipesId: [],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 80,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Speciality Red Chillies"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: "https://bawamasalacompany.com/assets/images/products/mirch-kutti.png",
    imgUrls: ["https://bawamasalacompany.com/assets/images/products/mirch-kutti.png", "https://bawamasalacompany.com/assets/images/products/mirch-kutti-2.png"],
    uses: null,
    desc: "Ground red chillies that add colour and heat to curries, vegetable preparations and meat alike. Perfect for any cuisine.",
  },
  {
    id: 105,
    u_id: 19,
    hindiName: "मिर्च पाउडर",
    metaDesc:
      "BMC's freshly ground, premium red chilli powder give your dishes the perfect heat and spicy kick! Versatile and essential addition to your spice box. Adds natural red colour to dishes. ",
    detailName: "Mirch Powder / Chilli Powder",
    sName: "Mirch Powder Chilli Powder मिर्च पाउडर Lal mirchi Spices chilli Laal",
    productName: "Mirch Powder",
    urlName: "Mirch Powder-30g-2",
    recipesId: [0, 4, 5, 9, 35, 36, 38, 41],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 10,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "30g",
    ingredients: ["Freshly ground red chilli powder. Edible mustard oil added- not more than 2%."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S199,
    imgUrls: [S199, SH199],
    uses: null,
    desc: "Excellent quality spice to add a dimension of heat to all dishes. Essential in most Indian dishes, to add that spicy kick!",
  },
  {
    id: 106,
    u_id: 19,
    hindiName: "मिर्च पाउडर",
    metaDesc:
      "BMC's freshly ground, premium red chilli powder give your dishes the perfect heat and spicy kick! Versatile and essential addition to your spice box. Adds natural red colour to dishes. ",
    detailName: "Mirch Powder / Chilli Powder",
    sName: "Mirch Powder Chilli Powder मिर्च पाउडर Lal mirchi Spices chilli Laal",
    productName: "Mirch Powder",
    urlName: "Mirch Powder-50g-2",
    recipesId: [0, 4, 5, 9, 35, 36, 38, 41],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 26,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: ["Freshly ground red chilli powder. Edible mustard oil added- not more than 2%."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S200,
    imgUrls: [S200, SH200],
    uses: null,
    desc: "Excellent quality spice to add a dimension of heat to all dishes. Essential in most Indian dishes, to add that spicy kick!",
  },
  {
    id: 107,
    u_id: 19,
    hindiName: "मिर्च पाउडर",
    metaDesc:
      "BMC's freshly ground, premium red chilli powder give your dishes the perfect heat and spicy kick! Versatile and essential addition to your spice box. Adds natural red colour to dishes. ",
    detailName: "Mirch Powder / Chilli Powder",
    sName: "Mirch Powder Chilli Powder मिर्च पाउडर Lal mirchi Spices chilli Laal",
    productName: "Mirch Powder",
    urlName: "Mirch Powder-200g-2",
    recipesId: [0, 4, 5, 9, 35, 36, 38, 41],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 99,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "200g",
    ingredients: ["Freshly ground red chilli powder. Edible mustard oil added- not more than 2%."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S201,
    imgUrls: [S201, SH201],
    uses: null,
    desc: "Excellent quality spice to add a dimension of heat to all dishes. Essential in most Indian dishes, to add that spicy kick!",
  },
  {
    id: 108,
    u_id: 19,
    hindiName: "मिर्च पाउडर",
    metaDesc:
      "BMC's freshly ground, premium red chilli powder give your dishes the perfect heat and spicy kick! Versatile and essential addition to your spice box. Adds natural red colour to dishes. ",
    detailName: "Mirch Powder / Chilli Powder",
    sName: "Mirch Powder Chilli Powder मिर्च पाउडर Lal mirchi Spices chilli Laal",
    productName: "Mirch Powder",
    urlName: "Mirch Powder-500g-2",
    recipesId: [0, 4, 5, 9, 35, 36, 38, 41],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 248,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "500g",
    ingredients: ["Freshly ground red chilli powder. Edible mustard oil added- not more than 2%."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S202,
    imgUrls: [S202, SH202],
    uses: null,
    desc: "Excellent quality spice to add a dimension of heat to all dishes. Essential in most Indian dishes, to add that spicy kick!",
  },
  {
    id: 109,
    u_id: 19,
    hindiName: "मिर्च पाउडर",
    metaDesc:
      "BMC's freshly ground, premium red chilli powder give your dishes the perfect heat and spicy kick! Versatile and essential addition to your spice box. Adds natural red colour to dishes. ",
    detailName: "Mirch Powder / Chilli Powder",
    sName: "Mirch Powder Chilli Powder मिर्च पाउडर Lal mirchi Spices chilli Laal",
    productName: "Mirch Powder",
    urlName: "Mirch Powder-1 Kg-2",
    recipesId: [0, 4, 5, 9, 35, 36, 38, 41],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 493,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "1 Kg",
    ingredients: ["Freshly ground red chilli powder. Edible mustard oil added- not more than 2%."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S197,
    imgUrls: [S197, SH197],
    uses: null,
    desc: "Excellent quality spice to add a dimension of heat to all dishes. Essential in most Indian dishes, to add that spicy kick!",
  },
  {
    id: 110,
    u_id: 19,
    hindiName: "मिर्च पाउडर",
    metaDesc:
      "BMC's freshly ground, premium red chilli powder give your dishes the perfect heat and spicy kick! Versatile and essential addition to your spice box. Adds natural red colour to dishes. ",
    detailName: "Mirch Powder / Chilli Powder",
    sName: "Mirch Powder Chilli Powder मिर्च पाउडर Lal mirchi Spices chilli Laal",
    productName: "Mirch Powder",
    urlName: "Mirch Powder-5 Kg-2",
    recipesId: [0, 4, 5, 9, 35, 36, 38, 41],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 2430,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "5 Kg",
    ingredients: ["Freshly ground red chilli powder. Edible mustard oil added- not more than 2%."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S198,
    imgUrls: [S198, SH198],
    uses: null,
    desc: "Excellent quality spice to add a dimension of heat to all dishes. Essential in most Indian dishes, to add that spicy kick!",
  },
  {
    id: 111,
    u_id: 24,
    hindiName: "मोहिनी गरम मसाला",
    metaDesc: "",
    detailName: "Mohini Garam Masala",
    sName: "Mohini Garam Masala मोहिनी गरम मसाला Murgh Makhani Chicken Tikka Spices",
    productName: "Mohini Garam Masala",
    urlName: "Mohini Garam Masala-15g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 10,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "15g",
    ingredients: ["Coriander", "Cumin Seed", "Black Pepper", "Cardamom", "Fenugreek", "Dry Ginger", "Cloves", "Cinnamon"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S132,
    imgUrls: [S132, SH132],
    uses: null,
    desc:
      "Discover the gourmands in you with the BMC Mohini Garam Masala. Made from fresh Indian Spices, it is the right mix of spices that enhances the taste of veg. & non-veg. dishes alike.",
  },
  {
    id: 112,
    u_id: 24,
    hindiName: "मोहिनी गरम मसाला",
    metaDesc: "",
    detailName: "Mohini Garam Masala",
    sName: "Mohini Garam Masala मोहिनी गरम मसाला Murgh Makhani Chicken Tikka Spices",
    productName: "Mohini Garam Masala",
    urlName: "Mohini Garam Masala-50g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 64,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: ["Coriander", "Cumin Seed", "Black Pepper", "Cardamom", "Fenugreek", "Dry Ginger", "Cloves", "Cinnamon"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S133,
    imgUrls: [S133, SH133],
    uses: null,
    desc:
      "Discover the gourmands in you with the BMC Mohini Garam Masala. Made from fresh Indian Spices, it is the right mix of spices that enhances the taste of veg. & non-veg. dishes alike.",
  },
  {
    id: 113,
    u_id: 38,
    hindiName: "स्पेशल मःमः मसाला",
    metaDesc: "",
    detailName: "Special MoMo Masala",
    sName: "Special MoMo Masala मःमः मसाला momos chutney Spices",
    productName: "Special MoMo Masala",
    urlName: "Special MoMo Masala-50g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 62,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Cardamom-Amomum",
      "Fenugreek",
      "Cassia",
      "Turmeric",
      "Cloves",
      "Cumin-Seed",
      "Dry Ginger",
      "Cinnamon",
      "Mace",
      "Garlic ",
      "Pepper",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S134,
    imgUrls: [S134, SH134],
    uses: null,
    desc: "Makes delicious lip-smacking and authentic momos, with all the zingy flavour from the street-side stalls!",
  },
  {
    id: 114,
    u_id: 13,
    hindiName: "पावभाजी मसाला",
    metaDesc:
      "BMC Pav Bhaji Masala adds restaurant-style taste to homemade Pav Bhaji, transporting you to the streets of Mumbai with the authentic and original taste. ",
    detailName: "Pav Bhaji Masala",
    sName: "Pav Bhaji Masala पावभाजी मसाला pao fast food Bhaji-pav Spices Pao",
    productName: "Pav Bhaji Masala",
    urlName: "Pav Bhaji Masala-50g-1",
    recipesId: [0, 2, 6],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 53,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Dry Mango",
      "Cumin",
      "Black pepper",
      "Cinnamon",
      "Cardamom-Amomum",
      "Aniseed",
      "Cloves",
      "Dry Ginger",
      "Fenugreek",
      "Bishop's Wood",
      "Turmeric & White Salt",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S136,
    imgUrls: [S136, SH136],
    uses: null,
    desc: "Adds lip-smacking flavour to homemade Pav Bhaji, making buttery pavs and crunch veggies sing!",
  },
  {
    id: 115,
    u_id: 49,
    hindiName: "पुदीना पत्ता",
    metaDesc: "",
    detailName: "Pudina Patta / Pudina Leaves",
    sName: "Pudina Patta Pudina Leaves पुदीना पत्ता podina Dried Mint Leaves Spices",
    productName: "Pudina Patta",
    urlName: "Pudina Patta-25g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 35,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "25g",

    type: "Spices",
    miniPackWeight: 29,
    imgSrc: "https://bawamasalacompany.com/assets/images/products/pudina.png",
    imgUrls: ["https://bawamasalacompany.com/assets/images/products/pudina.png", "https://bawamasalacompany.com/assets/images/products/pudina-h.png"],
    ingredients: ["Dried mint leaves"],
    uses: null,
    desc:
      "Dried mint leaves, full of flavour and aroma. Known to boost digestion and immunity. Perfect not only for chutneys, but also for mocktails and cocktails!",
  },
  {
    id: 116,
    u_id: 50,
    hindiName: "पानी पूरी मसाला",
    metaDesc: "",
    detailName: "Pani Puri Masala",
    sName: "Pani Puri Masala पानी पूरी मसाला Golgappa Spices",
    productName: "Pani Puri Masala",
    urlName: "Pani Puri Masala-100g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 76,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: [
      "White Salt",
      "Dry Mango",
      "Black Salt",
      "Mint Leaves",
      "Cumin Seeds",
      "Citric Acid",
      "Dry Ginger",
      "Bishop's weed",
      "Asafoetida",
      "Seedless Tamarind",
      "Black Pepper",
      "Sal-ammonicac",
      "Yellow Chilli",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: "https://bawamasalacompany.com/assets/images/products/pani-puri-f.png",
    imgUrls: ["https://bawamasalacompany.com/assets/images/products/pani-puri-f.png", SH135],
    uses: null,
    desc: "Secret spice blend for the perfect street-style golgappas.",
  },
  {
    id: 117,
    u_id: 50,
    hindiName: "पानी पूरी मसाला",
    metaDesc: "",
    detailName: "Pani Puri Masala",
    sName: "Pani Puri Masala पानी पूरी मसाला Golgappa Spices",
    productName: "Pani Puri Masala",
    urlName: "Pani Puri Masala-50g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 47,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: [
      "White Salt",
      "Dry Mango",
      "Black Salt",
      "Mint Leaves",
      "Cumin Seeds",
      "Citric Acid",
      "Dry Ginger",
      "Bishop's weed",
      "Asafoetida",
      "Seedless Tamarind",
      "Black Pepper",
      "Sal-ammonicac",
      "Yellow Chilli",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: "https://bawamasalacompany.com/assets/images/products/pani-puri-f.png",
    imgUrls: ["https://bawamasalacompany.com/assets/images/products/pani-puri-f.png"],
    uses: null,
    desc: "Secret spice blend for the perfect street-style golgappas.",
  },
  {
    id: 118,
    u_id: 22,
    hindiName: "रोग़नी मिर्च",
    metaDesc: "",
    detailName: "Roghni Mirch",
    sName: "Roghni Mirch रोगनी मिर्च lal spices masale mirchi chilli laal रोग़नी मिर्च ",
    productName: "Roghni Mirch",
    urlName: "Roghni Mirch-50g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 70,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: ["Freshly ground Indian red chillies", "Edible mustard oil added- not more than 2%."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S170,
    imgUrls: [S170, SH170],
    uses: null,
    desc: "Chilli powder makes dishes delicious and colourful!",
  },
  {
    id: 119,
    u_id: 22,
    hindiName: "रोग़नी मिर्च",
    metaDesc: "",
    detailName: "Roghni Mirch",
    sName: "Roghni Mirch रोगनी मिर्च lal spices masale mirchi chilli laal रोग़नी मिर्च ",
    productName: "Roghni Mirch",
    urlName: "Roghni Mirch-500g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 543,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "500g",
    ingredients: ["Freshly ground Indian red chillies ", "Edible mustard oil added- not more than 2%"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S96,
    imgUrls: [S96, SH96],
    uses: null,
    desc: "Chilli powder makes dishes delicious and colourful!",
  },
  {
    id: 120,
    u_id: 26,
    hindiName: "साम्बर मसाला",
    metaDesc: "",
    detailName: "Samber Masala",
    sName: "Samber Masala साम्बर मसाला spices lentil-vegetable curry",
    productName: "Samber Masala",
    urlName: "Samber Masala-50g-1",
    recipesId: [39],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 53,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Mustard",
      "Black Pepper",
      "Cardamom-Amomum",
      "Cloves",
      "Dry Ginger",
      "Curry Leaves",
      "Asafoetida",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S140,
    imgUrls: [S140, SH140],
    uses: null,
    desc: "For the original South Indian preparation, delicious taste and restaurant quality in your own kitchen.",
  },
  {
    id: 121,
    u_id: 32,
    hindiName: "सौंफ पाउडर",
    metaDesc: "",
    detailName: "Badian Powder / Powdered Fennel Seeds",
    sName: "Badian Powder Fennel Seeds Powder सौंफ पाउडर Saunf Powder sauf Powdered Fennel Seeds",
    productName: "Badian Powder",
    urlName: "Badian Powder-50g-1",
    recipesId: [42],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 27,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: ["High quality freshly ground fennel."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S143,
    imgUrls: [S143, SH143],
    uses: null,
    desc:
      "Powdered fennel seeds, used to add a sweet flavour and fresh aroma to dishes. Widely used in Ayurvedic medicine, for digestive, antioxidant and anti-inflammatory benefits. Known to have a cooling effect on the body. Great for tadka or tempering for a variety of dishes. ",
  },
  {
    id: 122,
    u_id: 32,
    hindiName: "सौंफ पाउडर",
    metaDesc: "",
    detailName: "Badian Powder / Powdered Fennel Seeds",
    sName: "Badian Powder Fennel Seeds Powder सौंफ पाउडर Saunf Powder sauf Powdered Fennel Seeds",
    productName: "Badian Powder",
    urlName: "Badian Powder-500g-1",
    recipesId: [42],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 253,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "500g",
    ingredients: ["High quality freshly ground fennel"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S98,
    imgUrls: [S98, SH98],
    uses: null,
    desc:
      "Powdered fennel seeds, used to add a sweet flavour and fresh aroma to dishes. Widely used in Ayurvedic medicine, for digestive, antioxidant and anti-inflammatory benefits. Known to have a cooling effect on the body. Great for tadka or tempering for a variety of dishes. ",
  },
  {
    id: 123,
    u_id: 1,
    hindiName: "स्पेशल मीट मसाला",
    metaDesc: "",
    detailName: "Special Meat Masala",
    sName: "Special Meat Masala स्पेशल मीट मसाला meat lal mas sabji laal",
    productName: "Special Meat Masala",
    urlName: "Special Meat Masala-15g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 10,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "15g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Garlic, Cassis",
      "Cardamom-Amomum",
      "Dry Ginger",
      "Black Pepper",
      "Cinnamon",
      "Cloves",
      "Saffron",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S101,
    imgUrls: [S101, SH101],
    uses: null,
    desc:
      "It's the informed choice of those who don't like to waste precious time in the kitchen. Prepared from thoroughly cleaned and fresh ingredients, processed under hygienic conditions, this Special Meat Masala is indispensable for a non-veg. kitchen. Signature spice blend that makes for fragrant, rich, melt-in-the-mouth, traditional meat dishes.",
  },
  {
    id: 124,
    u_id: 1,
    hindiName: "स्पेशल मीट मसाला",
    metaDesc: "",
    detailName: "Special Meat Masala",
    sName: "Special Meat Masala स्पेशल मीट मसाला meat lal mas sabji laal",
    productName: "Special Meat Masala",
    urlName: "Special Meat Masala-25g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 45,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "25g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Garlic, Cassis",
      "Cardamom-Amomum",
      "Dry Ginger",
      "Black Pepper",
      "Cinnamon",
      "Cloves",
      "Saffron",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S102,
    imgUrls: [S102, SH102],
    uses: null,
    desc:
      "It's the informed choice of those who don't like to waste precious time in the kitchen. Prepared from thoroughly cleaned and fresh ingredients, processed under hygienic conditions, this Special Meat Masala is indispensable for a non-veg. kitchen. Signature spice blend that makes for fragrant, rich, melt-in-the-mouth, traditional meat dishes.",
  },
  {
    id: 125,
    u_id: 1,
    hindiName: "स्पेशल मीट मसाला",
    metaDesc: "",
    detailName: "Special Meat Masala",
    sName: "Special Meat Masala स्पेशल मीट मसाला meat lal mas sabji laal",
    productName: "Special Meat Masala",
    urlName: "Special Meat Masala-50g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 62,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Garlic, Cassis",
      "Cardamom-Amomum",
      "Dry Ginger",
      "Black Pepper",
      "Cinnamon",
      "Cloves",
      "Saffron",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S144,
    imgUrls: [S144, SH144],
    uses: null,
    desc:
      "It's the informed choice of those who don't like to waste precious time in the kitchen. Prepared from thoroughly cleaned and fresh ingredients, processed under hygienic conditions, this Special Meat Masala is indispensable for a non-veg. kitchen. Signature spice blend that makes for fragrant, rich, melt-in-the-mouth, traditional meat dishes.",
  },
  {
    id: 126,
    u_id: 1,
    hindiName: "स्पेशल मीट मसाला",
    metaDesc: "",
    detailName: "Special Meat Masala",
    sName: "Special Meat Masala स्पेशल मीट मसाला meat lal mas sabji laal",
    productName: "Special Meat Masala",
    urlName: "Special Meat Masala-200g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 193,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "200g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Garlic, Cassis",
      "Cardamom-Amomum",
      "Dry Ginger",
      "Black Pepper",
      "Cinnamon",
      "Cloves",
      "Saffron",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S103,
    imgUrls: [S103, SH103],
    uses: null,
    desc:
      "It's the informed choice of those who don't like to waste precious time in the kitchen. Prepared from thoroughly cleaned and fresh ingredients, processed under hygienic conditions, this Special Meat Masala is indispensable for a non-veg. kitchen. Signature spice blend that makes for fragrant, rich, melt-in-the-mouth, traditional meat dishes.",
  },
  {
    id: 127,
    u_id: 1,
    hindiName: "स्पेशल मीट मसाला",
    metaDesc: "",
    detailName: "Special Meat Masala",
    sName: "Special Meat Masala स्पेशल मीट मसाला meat lal mas sabji laal",
    productName: "Special Meat Masala",
    urlName: "Special Meat Masala-500g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 478,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "500g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Garlic, Cassis",
      "Cardamom-Amomum",
      "Dry Ginger",
      "Black Pepper",
      "Cinnamon",
      "Cloves",
      "Saffron",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S104,
    imgUrls: [S104, SH104],
    uses: null,
    desc:
      "It's the informed choice of those who don't like to waste precious time in the kitchen. Prepared from thoroughly cleaned and fresh ingredients, processed under hygienic conditions, this Special Meat Masala is indispensable for a non-veg. kitchen. Signature spice blend that makes for fragrant, rich, melt-in-the-mouth, traditional meat dishes.",
  },
  {
    id: 128,
    u_id: 39,
    hindiName: "सब्जी मसाला",
    metaDesc: "",
    detailName: "Sabzi Masala",
    sName: "Sabzi Masala सब्जी मसाला sabji vegetables spices mdh everest badshah",
    productName: "Sabzi Masala",
    urlName: "Sabzi Masala-15g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 10,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "15g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Garlic",
      "Amomum",
      "Dry Ginger",
      "Black Pepper",
      "Cinnamon",
      "Cloves",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S138,
    imgUrls: [S138, SH138],
    uses: null,
    desc: "Spices up all vegetable preparations and makes everyday Indian home food extraordinary.",
  },
  {
    id: 129,
    u_id: 39,
    hindiName: "सब्जी मसाला",
    metaDesc: "",
    detailName: "Sabzi Masala",
    sName: "Sabzi Masala सब्जी मसाला sabji vegetables spices",
    productName: "Sabzi Masala",
    urlName: "Sabzi Masala-50g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 52,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Garlic",
      "Amomum",
      "Dry Ginger",
      "Black Pepper",
      "Cinnamon",
      "Cloves",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S139,
    imgUrls: [S139, SH139],
    uses: null,
    desc: "Spices up all vegetable preparations and makes everyday Indian home food extraordinary.",
  },
  {
    id: 130,
    u_id: 51,
    hindiName: "शाही पनीर मसाला",
    metaDesc: "",
    detailName: "Shahi Paneer Masala",
    sName: "Shahi Paneer Masala शाही पनीर मसाला makhani curry tofu",
    productName: "Shahi Paneer Masala",
    urlName: "Shahi Paneer Masala-15g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 10,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "15g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Garlic",
      "Cassia",
      "Cardamom-Amomum",
      "Dry Ginger",
      "Black Pepper",
      "Cinnamon",
      "Cloves",
      "Saffron",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S97,
    imgUrls: [S97, SH97],
    uses: null,
    desc: "Masala that makes for a royal, rich and fragrant traditional Paneer dish.",
  },
  {
    id: 131,
    u_id: 51,
    hindiName: "शाही पनीर मसाला",
    metaDesc: "",
    detailName: "Shahi Paneer Masala",
    sName: "Shahi Paneer Masala शाही पनीर मसाला makhani curry tofu",
    productName: "Shahi Paneer Masala",
    urlName: "Shahi Paneer Masala-50g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 63,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Garlic",
      "Cassia",
      "Cardamom-Amomum",
      "Dry Ginger",
      "Black Pepper",
      "Cinnamon",
      "Cloves",
      "Saffron",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S141,
    imgUrls: [S141, SH141],
    uses: null,
    desc: "Masala that makes for a royal, rich and fragrant traditional Paneer dish.",
  },
  {
    id: 133,
    u_id: 52,
    hindiName: "टीमस",
    metaDesc: "",
    detailName: "Teamas / Chai Masala",
    sName: "Teamas Chai Masala टीमस Tea spice masala chai",
    productName: "Teamas",
    urlName: "Teamas-25g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 60,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "25g",
    ingredients: ["Cardamom-amomum", "Star-ani-seed", "Cinnamon", "Mace", "Cadamom", "Pepper Longum roots", "Cloves", "Ginger", "Black Pepper", "Nutmeg"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: "https://bawamasalacompany.com/assets/images/products/teamas.png",
    imgUrls: ["https://bawamasalacompany.com/assets/images/products/teamas.png", "https://bawamasalacompany.com/assets/images/products/teamas.png"],
    uses: null,
    desc:
      "Signature blend of spices with special Ayurvedic properties, for the perfect Masala Chai. Full of antioxidants for various health benefits. Best added to milky tea. ",
  },
  {
    id: 134,
    u_id: 27,
    hindiName: "सफेद मिर्च पाऊडर",
    metaDesc: "",
    detailName: "White Pepper Powder",
    sName: "White Pepper Powder सफेद मिर्च पाऊडर Organic Sabut Safed Mirchi",
    productName: "White Pepper Powder",
    urlName: "White Pepper Powder-50g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 135,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: ["Freshly ground Indian white pepper"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S148,
    imgUrls: [S148, SH148],
    uses: null,
    desc: "White pepper is made from fully ripe pepper berries, adding a sharp bite to silky soups and Chinese gravies.",
  },
  {
    id: 135,
    u_id: 36,
    hindiName: "जीरा पाउडर",
    metaDesc: "",
    detailName: "Zeera Powder / Cumin Powder",
    sName: "Zeera Powder Cumin Powder जीरा पाउडर jeera cumin Cumin Powder",
    productName: "Zeera Powder",
    urlName: "Zeera Powder-50g-1",
    recipesId: [4, 36],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 54,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: ["Finest Indian cumin", "powdered"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S149,
    imgUrls: [S149, SH149],
    uses: null,
    desc: "Powdered cumin adds an earthy, warming and aromatic character to food. For staple use in cuisines of numerous cultures.",
  },
  {
    id: 136,
    u_id: 53,
    hindiName: "काला नमक",
    metaDesc: "",
    detailName: "Grounded Black Salt",
    sName: "Black Salt काला नमक kala namak fruit chats Sprinkles",
    productName: "Grounded Black Salt",
    urlName: "Grounded Black Salt-100g-2",
    recipesId: [],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 23,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Himalayan Black Salt"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S181,
    imgUrls: [S181, SH181],
    uses: null,
    desc: "Dried and powdered premium black salt, naturally infused with minerals. Great with boiled eggs, salads, lemonade and chips.",
  },
  {
    id: 137,
    u_id: 53,
    hindiName: "काला नमक",
    metaDesc: "",
    detailName: "Grounded Black Salt",
    sName: "Grounded Black Salt काला नमक kala namak fruit chats Sprinkles",
    productName: "Grounded Black Salt",
    urlName: "Grounded Black Salt-250g-2",
    recipesId: [],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 40,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "250g",
    ingredients: ["Himalayan Black Salt"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S182,
    imgUrls: [S182, SH182],
    uses: null,
    desc: "Dried and powdered premium black salt, naturally infused with minerals. Great with boiled eggs, salads, lemonade and chips.",
  },
  {
    id: 138,
    u_id: 54,
    hindiName: "दही वड़ा मसाला",
    metaDesc: "",
    detailName: "Dahi Vada Masala",
    sName: "Dahi Vada Masala दही वड़ा मसाला dahivada raita vara",
    productName: "Dahi Vada Masala",
    urlName: "Dahi Vada Masala-100g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 60,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Coriander", "Black Pepper", "Cumin Seeds", "Bishopseed", "White Salt", "Black Salt", "Yellow Chilli", "Fenugreek Seeds"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: "https://bawamasalacompany.com/assets/images/products/dahivada-masala.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/dahivada-masala.png",
      "https://bawamasalacompany.com/assets/images/products/dahivada-masala-h.png",
    ],
    uses: null,
    desc:
      "Special blend of fragrant and pungent spices that make for the perfect Dahi Vada (lentil dumplings soaked in thick yogurt). Best served with tamarind chutney.",
  },
  {
    id: 139,
    u_id: 54,
    hindiName: "दही वड़ा मसाला",
    metaDesc: "",
    detailName: "Dahi Vada Masala",
    sName: "Dahi Vada Masala दही वड़ा मसाला dahivada raita vara",
    productName: "Dahi Vada Masala",
    urlName: "Dahi Vada Masala-50g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 39,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: ["Coriander", "Black Pepper", "Cumin Seeds", "Bishopseed", "White Salt", "Black Salt", "Yellow Chilli", "Fenugreek Seeds"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S115,
    imgUrls: [S115, SH115],
    uses: null,
    desc:
      "Special blend of fragrant and pungent spices that make for the perfect Dahi Vada (lentil dumplings soaked in thick yogurt). Best served with tamarind chutney.",
  },
  {
    id: 140,
    u_id: 55,
    hindiName: "दाल मक्खनी मसाला",
    metaDesc: "",
    detailName: "Dal Makhni",
    sName: "Dal Makhni दाल मक्खनी मसाला dalmakhani makhni",
    productName: "Dal Makhni",
    urlName: "Dal Makhni-100g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 94,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: [
      "Coriander Seeds",
      "Red Chillies",
      "Unripe Dry Mango",
      "Iodised Salt",
      "Dried Ginger",
      "Garlic",
      "Black Pepper",
      "Cassia Cloves",
      "Nutmeg",
      "Star Anise",
      "Mace",
      "Asafoetida",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: "https://bawamasalacompany.com/assets/images/products/dal-makhni.png",
    imgUrls: ["https://bawamasalacompany.com/assets/images/products/dal-makhni.png", "https://bawamasalacompany.com/assets/images/products/dal-makhni-h.png"],
    uses: null,
    desc: "Signature blend of aromatic and flavourful premium Indian spices for the rich, creamy, heavenly flavour of authentic Dal Makhni.",
  },
  {
    id: 147,
    u_id: 17,
    hindiName: "हल्दी पाउडर",
    metaDesc: "BMC's finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
    detailName: "Haldi Powder / Turmeric Powder",
    sName: "Haldi Powder Turmeric Powder हल्दी पाउडर",
    productName: "Haldi Powder",
    urlName: "Haldi Powder-50g-2",
    recipesId: [39, 36, 37, 4, 30, 32, 33, 34, 42],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 29,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: ["Fine Indian Turmeric"],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S205,
    imgUrls: [S205, SH205],
    uses: null,
    desc: "Finest turmeric, ground for convenience, adds colour and life to all dishes, and is an essential addition to most Indian dishes.",
  },
  {
    id: 148,
    u_id: 34,
    hindiName: "स्पेशल राजमा मसाला",
    metaDesc: "",
    detailName: "special rajmah masala",
    sName: "special rajmah masala स्पेशल राजमा मसाला rajma kidney beans red",
    productName: "special rajmah masala",
    urlName: "special rajmah masala-15g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 10,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "15g",
    ingredients: [
      "Coriander",
      "Fenugreek",
      "Black Pepper",
      "Salt",
      "Nutmeg",
      "Promegranate Seeds",
      "Chillies",
      "Dry Ginger",
      "Musk Melon",
      "Cardamom Seeds",
      "Dry Mango",
      "Caraway",
      "Cassia",
      "Mace",
      "Cloves",
      "Mustard",
      "Cinnamon",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S206,
    imgUrls: [S206, SH206],
    uses: null,
    desc: "Spice blend from the traditional recipe, that makes for the tastiest Rajma, reminiscent of home cooking and food made by moms and gradmothers.",
  },
  {
    id: 149,
    u_id: 34,
    hindiName: "स्पेशल राजमा मसाला",
    metaDesc: "",
    detailName: "special rajmah masala",
    sName: "special rajmah masala स्पेशल राजमा मसाला rajma kidney beans red",
    productName: "special rajmah masala",
    urlName: "special rajmah masala-15g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 54,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: [
      "Coriander",
      "Fenugreek",
      "Black Pepper",
      "Salt",
      "Nutmeg",
      "Promegranate Seeds",
      "Chillies",
      "Dry Ginger",
      "Musk Melon",
      "Cardamom Seeds",
      "Dry Mango",
      "Caraway",
      "Cassia",
      "Mace",
      "Cloves",
      "Mustard",
      "Cinnamon",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S207,
    imgUrls: [S207, SH207],
    uses: null,
    desc: "Spice blend from the traditional recipe, that makes for the tastiest Rajma, reminiscent of home cooking and food made by moms and gradmothers.",
  },
  {
    id: 154,
    u_id: 39,
    hindiName: "सब्जी मसाला",
    metaDesc: "",
    detailName: "Sabzi Masala",
    sName: "Sabzi Masala सब्जी मसाला sabji vegetables spices",
    productName: "Sabzi Masala",
    urlName: "Sabzi Masala-100g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 80,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: [
      "Coriander",
      "Chillies",
      "Fenugreek",
      "Turmeric",
      "Cumin Seeds",
      "Garlic",
      "Amomum",
      "Dry Ginger",
      "Black Pepper",
      "Cinnamon",
      "Cloves",
      "Nutmeg",
      "Mace",
    ],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: "https://bawamasalacompany.com/assets/images/products/sabjij-masala-f.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/sabjij-masala-f.png",
      "https://bawamasalacompany.com/assets/images/products/sabjij-masala.png",
    ],
    uses: null,
    desc: "Spices up all vegetable preparations and makes everyday Indian home food extraordinary.",
  },
  {
    id: 150,
    u_id: 36,
    hindiName: "जीरा पाउडर",
    metaDesc: "",
    detailName: "Zeera powder / Cumin Powder",
    sName: "Zeera powder Cumin Powder जीरा पाउडर jeera cumin",
    productName: "Zeera powder",
    urlName: "Zeera powder-100g-1",
    recipesId: [4, 36],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 85,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Finest Indian cumin, powdered."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: "https://bawamasalacompany.com/assets/images/products/zeera-powder.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/zeera-powder.png",
      "https://bawamasalacompany.com/assets/images/products/zeera-powder-h.png",
    ],
    uses: null,
    desc: "Powdered cumin adds an earthy, warming and aromatic character to food. For staple use in cuisines of numerous cultures.",
  },
  {
    id: 151,
    u_id: 59,
    hindiName: "अजवायन होल",
    metaDesc: "",
    detailName: "Ajowain Whole / Bishop's Weed",
    sName: "Ajowain Whole Bishop's Weed अजवायन होल bishop seed weed whole ajowain Ajwain ajowan ammi carom Spices",
    productName: "Ajowain Whole",
    urlName: "Ajowain Whole-100g-2",
    recipesId: [35],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 60,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Finest Indian Caraway or Carom seeds."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: "https://bawamasalacompany.com/assets/images/products/ajowain-whole.png",
    imgUrls: [
      "https://bawamasalacompany.com/assets/images/products/ajowain-whole.png",
      "https://bawamasalacompany.com/assets/images/products/ajowain-whole-b.png",
    ],
    uses: null,
    desc:
      "Traditional Indian households ‘Ajowan’, or ‘Ajwain’ forms an essential part of health preserving measures, as mush as for a rare taste and flavour in special delicacies. Ajowan is popularly believed to be useful to combat stomach and general ailments and is helpful for digestion.",
  },
  {
    id: 152,
    u_id: 47,
    hindiName: "पैरट कसूरी मेथी",
    metaDesc: "",
    detailName: "Parrot Kasoori Methi",
    sName: "Parrot Kasoori Methi  Kasoori Methi कसूरी मेथी kasuri fenugreek leaf  Spices",
    productName: "Parrot Kasoori Methi",
    urlName: "Parrot Kasoori Methi-50g-2",
    recipesId: [5],
    packType: 2,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 53,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "50g",
    ingredients: ["Dried fenugreek."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S211,
    imgUrls: [S211, SH211],
    uses: null,
    desc: "Sun-dried fenugreek leaves, powdered for use in a variety of Indian favourites such as Butter Chicken and Paneer Tikka.",
  },
  {
    id: 153,
    u_id: 47,
    hindiName: "पैरट कसूरी मेथी",
    metaDesc: "",
    detailName: "Parrot Kasoori Methi ",
    sName: " Parrot Kasoori Methi  Kasoori Methi कसूरी मेथी kasuri fenugreek leaf  Spices",
    productName: " Parrot Kasoori Methi",
    urlName: "Parrot Kasoori Methi-500g-1",
    recipesId: [5],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 400,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "500g",
    ingredients: ["Dried fenugreek."],
    type: "Spices",
    miniPackWeight: 29,
    imgSrc: S213,
    imgUrls: [S213, SH213],
    uses: null,
    desc: "Sun-dried fenugreek leaves, powdered for use in a variety of Indian favourites such as Butter Chicken and Paneer Tikka.",
  },
];
// last id 156 is product id
// Do not put same Ids in spice, DhoopDetails and misc
// Lead to drastical bugs
const DhoopDetails = [
  {
    id: 1061,
    u_id: 61,
    hindiName: "",
    metaDesc: "",
    detailName: "Mala Incense",
    sName: "Mala Incense",
    productName: "Mala Incense",
    urlName: "Mala Incense-35 sticks-1",
    recipesId: [],
    packType: 4,
    title: "Parrot-Kasoori-Methi",
    features: "Seven in one.",
    spl: 0,
    mrp: 15,
    TM: "Bawa Industries",
    Brand: null,
    netWeight: "35 sticks",
    ingredients: ["No Ingredients"],
    type: "Dhoop",
    imgSrc: S40,
    imgUrls: [S40, SH40],
    uses: null,
    desc: "Serene yet long lasting fragrance that linger on long after being used! Seven in one. ",
  },
  {
    id: 1062,
    u_id: 62,
    hindiName: "",
    metaDesc: "",
    detailName: "Special Havan Samagri(M)",
    sName: "Special Havan Samagri(M)",
    productName: "Special Havan Samagri(M)",
    urlName: "Special Havan Samagri(M)-200g-1",
    recipesId: [],
    packType: 4,
    title: "Parrot-Kasoori-Methi - Mini",
    features: "Special ingredients to purify purify air and bring happiness. Must have for all sacred occasions",
    spl: 0,
    mrp: 28,
    TM: "Bawa Industries",
    Brand: null,
    netWeight: "200g",
    ingredients: ["No Ingredients"],
    type: "Dhoop",
    imgSrc: S38,
    imgUrls: [S38, SH38],
    uses: null,
    desc:
      "Bawa Havan Samagri and special fragrances in various forms add the ambience to any religious ceremony or godly persuit. Special ingredients to purify purify air and bring happiness. Must have for all sacred occasions",
  },
  {
    id: 1063,
    u_id: 62,
    hindiName: "",
    metaDesc: "",
    detailName: "Special Havan Samagri(L)",
    sName: "Special Havan Samagri(L)",
    productName: "Special Havan Samagri(L)",
    urlName: "Special Havan Samagri(L)-500g-1",
    recipesId: [],
    packType: 4,
    title: "Parrot-Kasoori-Methi",
    features: "Special ingredients to purify purify air and bring happiness. Must have for all sacred occasions",
    spl: 0,
    mrp: 38,
    TM: "Bawa Industries",
    Brand: null,
    netWeight: "500g",
    ingredients: ["No Ingredients"],
    type: "Dhoop",
    imgSrc: S38,
    imgUrls: [S38, SH38],
    uses: null,
    desc:
      "Bawa Havan Samagri and special fragrances in various forms add the ambience to any religious ceremony or godly persuit. Special ingredients to purify purify air and bring happiness. Must have for all sacred occasions",
  },
  {
    id: 1064,
    u_id: 64,
    hindiName: "",
    metaDesc: "",
    detailName: "Puja Dhoop - Golden Pack.",
    sName: "Puja Dhoop - Golden Pack.",
    productName: "Puja Dhoop - Golden Pack.",
    urlName: "Puja Dhoop - Golden Pack.-30g-1",
    recipesId: [],
    packType: 4,
    title: "Parrot-Kasoori-Methi",
    features: "Golden Pack. ",
    spl: 0,
    mrp: 10,
    TM: "Bawa Industries",
    Brand: null,
    netWeight: "30g",
    ingredients: ["No Ingredients"],
    type: "Dhoop",
    imgSrc: S50,
    imgUrls: [S50, SH50],
    uses: null,
    desc: "Golden Pack.",
  },
  {
    id: 1065,
    u_id: 64,
    hindiName: "",
    metaDesc: "",
    detailName: "Puja Dhoop",
    sName: "Puja Dhoop",
    productName: "Puja Dhoop",
    urlName: "Puja Dhoop-30g-1",
    recipesId: [],
    packType: 4,
    title: "Parrot-Kasoori-Methi",
    features: "Mini Pack",
    spl: 0,
    mrp: 9,
    TM: "Bawa Industries",
    Brand: null,
    netWeight: "30g",
    ingredients: ["No Ingredients"],
    type: "Dhoop",
    imgSrc: S52,
    imgUrls: [S52, SH52],
    uses: null,
    desc: "Normal Pack",
  },
  {
    id: 1066,
    u_id: 65,
    hindiName: "",
    metaDesc: "",
    detailName: "Gulpham Gulab Incense Sticks",
    sName: "Gulpham Gulab Incense Sticks",
    productName: "Gulpham Gulab Incense Sticks",
    urlName: "Gulpham Gulab Incense Sticks-20 sticks-1",
    recipesId: [],
    packType: 4,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 0,
    mrp: 13,
    TM: "Bawa Industries",
    Brand: null,
    netWeight: "20 sticks",
    ingredients: ["No Ingredients"],
    type: "Dhoop",
    imgSrc: SH48,
    imgUrls: [S48, SH48],
    uses: null,
    desc: "Serene yet long lasting fragrance that linger on long after being used! 20 sticks",
  },
  {
    id: 1067,
    u_id: 61,
    hindiName: "",
    metaDesc: "",
    detailName: "Mala Incense -  Three in One",
    sName: "Mala Incense -  Three in One",
    productName: "Mala Incense -  Three in One",
    urlName: "Mala Incense -  Three in One-25 sticks-1",
    recipesId: [],
    packType: 4,
    title: "Parrot-Kasoori-Methi",
    features: "A Distinguished Incense. Three in One. ",
    spl: 0,
    mrp: 10,
    TM: "Bawa Industries",
    Brand: null,
    netWeight: "25 sticks",
    ingredients: ["No Ingredients"],
    type: "Dhoop",
    imgSrc: S45,
    imgUrls: [S45, SH45],
    uses: null,
    desc: "A Distinguished Incense. Three in One. 15 Sticks",
  },
  {
    id: 1068,
    u_id: 61,
    hindiName: "",
    metaDesc: "",
    detailName: "Mala Incense - Five In one",
    sName: "Mala Incense - Five In one",
    productName: "Mala Incense - Five In one",
    urlName: "Mala Incense - Five In one-7 Sticks-1",
    recipesId: [],
    packType: 4,
    title: "Parrot-Kasoori-Methi",
    features: "A Distinguished Incense. Five in One. ",
    spl: 0,
    mrp: 12,
    TM: "Bawa Industries",
    Brand: null,
    netWeight: "7 Sticks",
    ingredients: ["No Ingredients"],
    type: "Dhoop",
    imgSrc: S47,
    imgUrls: [S47, SH47],
    uses: null,
    desc: "A Distinguished Incense. Five in One. ",
  },
  {
    id: 1069,
    u_id: 62,
    hindiName: "",
    metaDesc: "",
    detailName: "Special Havan Samagri(S)",
    sName: "Special Havan Samagri(S)",
    productName: "Special Havan Samagri(S)",
    urlName: "Special Havan Samagri(S)-100g-0",
    recipesId: [],
    packType: 0,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 0,
    mrp: 15,
    TM: "Bawa Industries",
    Brand: null,
    netWeight: "100g",
    ingredients: ["No Ingredients"],
    type: "Dhoop",
    imgSrc: S38,
    imgUrls: [S38, SH38],
    uses: null,
    desc:
      "Bawa Havan Samagri and special fragrances in various forms add the ambience to any religious ceremony or godly persuit. Special ingredients to purify purify air and bring happiness. Must have for all sacred occasions",
  },
  {
    id: 1070,
    u_id: 67,
    hindiName: "",
    metaDesc: "",
    detailName: "Mist Incense Sticks",
    sName: "Mist Incense Sticks",
    productName: "Mist Incense Sticks",
    urlName: "Mist Incense Sticks-20 Sticks-1",
    recipesId: [],
    packType: 4,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 0,
    mrp: 15,
    TM: "Bawa Industries",
    Brand: null,
    netWeight: "20 Sticks",
    ingredients: ["No Ingredients"],
    type: "Dhoop",
    imgSrc: SH49,
    imgUrls: [S49, SH49],
    uses: null,
    desc: "Serene yet long lasting fragrance that linger on long after being used! Seven in one.",
  },
  {
    id: 1071,
    u_id: 61,
    hindiName: "",
    metaDesc: "",
    detailName: "Mala",
    sName: "Mala",
    productName: "Mala",
    urlName: "Mala-15 Sticks-1",
    recipesId: [],
    packType: 4,
    title: "Parrot-Kasoori-Methi",
    features: "A Distinguished Incense. Three in One. 15 Sticks",
    spl: 0,
    mrp: 10,
    TM: "Bawa Industries",
    Brand: null,
    netWeight: "15 Sticks",
    ingredients: ["No Ingredients"],
    type: "Dhoop",
    imgSrc: S40,
    imgUrls: [S40, SH40],
    uses: null,
    desc: "A Distinguished Incense. Three in One. 15 Sticks",
  },
  {
    id: 1072,
    u_id: 69,
    hindiName: "",
    metaDesc: "",
    detailName: "Four-in-one Dhoop",
    sName: "Four-in-one Dhoop",
    productName: "Four-in-one Dhoop",
    urlName: "Four-in-one Dhoop-16 sticks-1",
    recipesId: [],
    packType: 4,
    title: "Parrot-Kasoori-Methi",
    features: "Unique Quality. Natural Ingredients",
    spl: 0,
    mrp: 17,
    TM: "Bawa Industries",
    Brand: null,
    netWeight: "16 sticks",
    ingredients: ["No Ingredients"],
    type: "Dhoop",
    imgSrc: S39,
    imgUrls: [S39, SH39],
    uses: null,
    desc: "A Distinguished Incense. Three in One. 15 Sticks",
  },
];

const Misc = [
  {
    id: 1073,
    u_id: 58,
    hindiName: "टेस्ट एंड टेस्ट",
    metaDesc: "",
    detailName: "Taste-N-Taste / Monosodium Glutamate",
    sName: "Taste-N-Taste Monosodium Glutamate टेस्ट एंड टेस्ट ajinomoto Monosodium Glutamate",
    productName: "Taste-N-Taste",
    urlName: "Taste-N-Taste-20g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: "99% pure Monosodium Glutamate",
    spl: 0,
    mrp: 40,
    TM: null,
    Brand: null,
    netWeight: "20g",
    ingredients: ["Monosodium Glutamate"],
    type: "Misc",
    imgSrc: S27,
    imgUrls: [S27, SH27],
    uses: null,
    desc:
      "99% pure Monosodium Glutamate, to add that zing to authentic Chinese dishes, and Indo-Chinese delicacies like Gobhi Manchurian and Honey Chilli Potato.",
  },
  {
    id: 1074,
    u_id: 57,
    hindiName: "सोया डिश (बड़ियां)",
    metaDesc: "",
    detailName: "Soya Dish / Badiyan",
    sName: "Soya Dish Badiyan सोया डिश Badiyan Chunks",
    productName: "Soya Dish Badiyan",
    urlName: "Soya Dish-100g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 39,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "100g",
    ingredients: ["Defatted Soya Flour"],
    type: "Misc",
    miniPackWeight: 29,
    imgSrc: S99,
    imgUrls: [S99, SH99],
    uses: null,
    desc: "Melt-in-the mouth soya chunks that add the much-needed proteins to Indian curries.",
  },
  {
    id: 1075,
    u_id: 57,
    hindiName: "सोया डिश (बड़ियां)",
    metaDesc: "",
    detailName: "Soya Dish / Badiyan",
    sName: "Soya Dish Badiyan सोया डिश Chunks",
    productName: "Soya Dish Badiyan",
    urlName: "Soya Dish-200g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 60,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "200g",
    ingredients: ["Defatted Soya Flour"],
    type: "Misc",
    miniPackWeight: 29,
    imgSrc: S100,
    imgUrls: [S100, SH100],
    uses: null,
    desc: "Melt-in-the mouth soya chunks that add the much-needed proteins to Indian curries.",
  },
  {
    id: 1076,
    u_id: 60,
    hindiName: "सोया डिश (चूरा)",
    metaDesc: "",
    detailName: "Soya Dish Granules",
    sName: "Soya dish chura granules सोया डिश Granules Chunks Soya Dish Granules",
    productName: "Soya Dish Granules",
    urlName: "Soya dish granules-200g-1",
    recipesId: [],
    packType: 1,
    title: "Parrot-Kasoori-Methi",
    features: null,
    spl: 1,
    mrp: 46,
    TM: "BMC ke Masale",
    Brand: null,
    netWeight: "200g",
    ingredients: ["Defatted Soya Flour "],
    type: "Misc",
    miniPackWeight: 29,
    imgSrc: S214,
    imgUrls: [S214, SH214],
    uses: null,
    desc: "Melt-in-the mouth soya granules that add the much-needed proteins to Indian curries.",
  },
];

const recipes = {
  0: {
    id: 0,
    r_types: ["Appetizer", "Snack"],
    title: "Pav Bhaji",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 1,
    logoUrl: Dish31,
    duration: "13-15 min",
    isVeg: 1,
    uid: "recipe1",
    recipeDown: RecipeDown10,
    ingredients: [
      {
        quantity: "1 tsp",
        description: "Oil",
      },
      {
        quantity: "4 cubes",
        description: "Large Butter, finely chopped",
      },
      {
        quantity: "1 cup",
        description: "Onion, chopped",
      },
      {
        quantity: "1 tsp",
        description: "Ginger-Garlic paste",
      },
      {
        quantity: "1/2 cup",
        description: "Lauki, chopped",
      },
      {
        quantity: "1/2 cup",
        description: "Capsicum, chopped",
      },
      {
        quantity: "1 cup",
        description: "Potatoes, chopped",
      },
      {
        quantity: "1/2 cup",
        description: "Beetroot, chopped",
      },
      {
        quantity: "1 tsp",
        description: "Salt",
      },
      {
        quantity: "2 tsp",
        description: "Chili powder",
      },
      {
        quantity: "3 tsp",
        description: "Pav Bhaji Masala",
      },
      {
        quantity: "1 tsp",
        description: "Red chili powder",
      },
      {
        quantity: "1/2 cup",
        description: "Tomato puree",
      },
      {
        quantity: "1 cube",
        description: "To taste Butter",
      },
      {
        quantity: "1",
        description: "bunch Coriander leavesr",
      },
    ],
    Preparation: [
      {
        title: "Step 1",
        subtitle: "Heat oil in a pan. Add cubes of butter along with onion",
      },
      {
        title: "Step 2",
        subtitle: "Saute till golden brown and then add ginger garlic paste. Mix well.",
      },
      {
        title: "Step 3",
        subtitle: "Now add chopped lauki along with coriander and mix well, followed by a cup of chopped potatoes. Mix and mash well together.",
      },
      {
        title: "Step 4",
        subtitle: "Add chopped beetroot, salt, chilli powder and pav bhaji masala to the mashed mixture. Mix well, and then add the tomato puree.",
      },
      {
        title: "Step 5",
        subtitle: "Mix thoroughly and then add butter followed by coriander leaves to the cooked bhaaji.  ",
      },
      {
        title: "Step 6",
        subtitle: "Spread some butter all over the pav.",
      },
      {
        title: "Step 7",
        subtitle: "Sprinkle pav bhaji masala over it",
      },
      {
        title: "Step 8",
        subtitle: "Toast it on the pan for a while till it becomes golden brown.",
      },
      {
        title: "Step 9",
        subtitle: "Serve hot along with a lemon wedge, chopped onion, and green chili.",
      },
    ],
  },
  1: {
    id: 1,
    title: "Tandoori Gobhi",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish22,
    duration: "30-45 min",
    isVeg: 1,
    uid: "recipe1",
    recipeDown: "",
    ingredients: [
      {
        quantity: "2 cups",
        description: "Paneer, cubed (or cottage cheese)",
      },
      {
        quantity: "1 inch",
        description: "Ginger",
      },
      {
        quantity: "3 cloves",
        description: "Garlic, minced",
      },
      {
        quantity: "2 tablespoons",
        description: "Cashews",
      },
      {
        quantity: "1",
        description: "White onion, diced",
      },
      {
        quantity: "5-6",
        description: "whole tomatoes, chopped or pureed",
      },
      {
        quantity: "1 tbsp",
        description: "BMC Garam Masala",
      },
      {
        quantity: "2 tbsp",
        description: "Coconut cream",
      },
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  2: {
    id: 2,
    r_types: ["Main Course"],
    title: "Tava Pulao",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 1,
    logoUrl: Dish4,
    duration: "45-60 min",
    isVeg: 1,
    uid: "recipe1",
    recipeDown: RecipeDown14,
    ingredients: [
      {
        quantity: "2 tsp",
        description: "Butter",
      },
      {
        quantity: "1 tsp",
        description: "Cumin / jeera",
      },
      {
        quantity: "3",
        description: "Onion sliced",
      },
      {
        quantity: "1 tsp",
        description: "Ginger garlic paste",
      },
      {
        quantity: "1",
        description: "Carrot chopped",
      },
      {
        quantity: "5-6",
        description: "Capsicum chopped",
      },
      {
        quantity: "2 tbsp",
        description: "Peas",
      },
      {
        quantity: "5",
        description: "Beans chopped",
      },
      {
        quantity: "1 tsp",
        description: "Salt",
      },
      {
        quantity: "2",
        description: "Tomato finely chopped",
      },
      {
        quantity: "2 tsp",
        description: "BMC Pav Bhaji Masala",
      },
      {
        quantity: "2 tsp",
        description: "kashmiri red chilli powder",
      },
      {
        quantity: "1",
        description: "Potato boiled cube",
      },
      {
        quantity: "2 tbsp",
        description: "Coriander finely chopped",
      },
      {
        quantity: "2 tbsp",
        description: "Lemon juice",
      },
    ],
    Preparation: [
      {
        title: "Step 1 ",
        subtitle: "In a kadai heat 2 tsp butter and saute 1 tsp cumin until it turns aromatic.",
      },
      {
        title: "Step 2 ",
        subtitle: "Now add ½ onion and 1 tsp ginger garlic paste. saute well.",
      },
      {
        title: "Step 3 ",
        subtitle: "Keeping the flame on medium add, 1 carrot, 2 tbsp capsicum, 2 tbsp peas, 5 beans and ½ tsp salt.",
      },
      {
        title: "Step 4 ",
        subtitle: "Stir-fry for 3 minutes or until vegetables is cooked slightly.",
      },
      {
        title: "Step 5 ",
        subtitle: "Now add 2 tomatoes and saute until the tomato turn soft and mushy.",
      },
      {
        title: "Step 6 ",
        subtitle: "Furthermore, add 2 tsp pav bhaji masala and ¼ tsp chili powder.",
      },
      {
        title: "Step 7 ",
        subtitle: "Saute until the oil is released from the masala paste.",
      },
      {
        title: "Step 8 ",
        subtitle: "Additionally, add 1 boiled and cubed potato and mix well.",
      },
      {
        title: "Step 9 ",
        subtitle: "Now add in cooked rice.",
      },
      {
        title: "Step 10",
        subtitle: "Mix gently without breaking the rice.",
      },
      {
        title: "Step 11 ",
        subtitle: "Add in 2 tbsp coriander and 1 tbsp lemon juice. mix well.",
      },
      {
        title: "Step 12",
        subtitle: "Finally, serve Mumbai Tawa pulao with raita.",
      },
    ],
  },
  3: {
    id: 3,
    title: "Masala Tea",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish28,
    duration: "30-45 min",
    isVeg: 1,
    uid: "recipe1",
    recipeDown: "",
    ingredients: [
      {
        quantity: "2 cups",
        description: "Paneer, cubed (or cottage cheese)",
      },
      {
        quantity: "1 inch",
        description: "Ginger",
      },
      {
        quantity: "3",
        description: "Cloves garlic, minced",
      },
      {
        quantity: "2 tablespoons ",
        description: "Cashews",
      },
      {
        quantity: "1 ",
        description: "White onion, diced",
      },
      {
        quantity: "5-6",
        description: "Whole tomatoes, chopped or pureed",
      },
      {
        quantity: "1 tbsp ",
        description: "BMC Garam Masala",
      },
      {
        quantity: "2 tbsp ",
        description: "coconut cream",
      },
      {
        quantity: "Salt",
        description: "to taste",
      },
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  4: {
    id: 4,
    r_types: ["Main Course"],
    title: "Chana Dal tadka",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 1,
    logoUrl: Dish1,
    duration: "30-45 min",
    isVeg: 1,
    uid: "recipe1",
    recipeDown: RecipeDown4,
    ingredients: [
      {
        quantity: "1/2 cup",
        description: "Split pigeon pea (toor dal) soaked",
      },
      {
        quantity: "1/2 cup",
        description: "Split Bengal gram (chana dal) soaked",
      },
      {
        quantity: "2 tbsp",
        description: "Ghee",
      },
      {
        quantity: "1 tsp ",
        description: "Cumin seeds",
      },
      {
        quantity: "1 pinch",
        description: "Asafoetida",
      },
      {
        quantity: "1 inch piece",
        description: "Ginger chopped ",
      },
      {
        quantity: "2 medium ",
        description: "BMC Garam Masala",
      },
      {
        quantity: "to taste ",
        description: "Salt ",
      },
      {
        quantity: "2 medium",
        description: "Tomatoes chopped",
      },
      {
        quantity: "1 tsp",
        description: "Red chilli powder",
      },
      {
        quantity: "1/4 tsp",
        description: "Turmeric powder",
      },
      {
        quantity: "1/4 tSP",
        description: "Cumin powder",
      },
      {
        quantity: "1/2 tSP",
        description: "Coriander powder",
      },
      {
        quantity: "1/2 tSP",
        description: "Garam masala powder ",
      },
      {
        quantity: "1 lemon",
        description: "Juice  ",
      },
      {
        quantity: "1 tbsp",
        description: "Fresh coriander leaves chopped  ",
      },
    ],
    Preparation: [
      {
        title: "Step 1 ",
        subtitle: "Heat ghee in a non-stick pan and add cumin seeds. Once they change color, add asafetida and mix.",
      },
      {
        title: "Step 2 ",
        subtitle: "Add garlic and ginger and sauté on medium heat for a minute. Add onions and a pinch of salt and sauté till the onions turn golden brown.",
      },
      {
        title: "Step 3 ",
        subtitle: "Add tomatoes and sauté till they turn pulpy.",
      },
      {
        title: "Step 4 ",
        subtitle:
          "Add red chili powder, turmeric powder, cumin powder, coriander powder, and gram masala powder and mix well. Cook for a minute and add the cooked grams and salt. Mix well.",
      },
      {
        title: "Step 5 ",
        subtitle: "Add water if required and bring to a boil.",
      },
      {
        title: "Step 6 ",
        subtitle: "Add lemon juice and remove from heat.",
      },
      {
        title: "Step 7 ",
        subtitle: "Transfer into a serving bowl, garnish with coriander leaves and serve hot.",
      },
    ],
  },
  5: {
    id: 5,
    r_types: ["Main Course"],
    title: "Butter Chicken",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 1,
    logoUrl: Dish3,
    duration: "45-50 min",
    isVeg: 0,
    uid: "recipe1",
    recipeDown: RecipeDown3,
    ingredients: [
      {
        quantity: "450g",
        description: "Boneless chicken",
      },
      {
        quantity: "1 tbsp",
        description: "Ginger-garlic paste",
      },
      {
        quantity: "1",
        description: "Onion, chopped",
      },
      {
        quantity: "4",
        description: "Puree of tomatoes",
      },
      {
        quantity: "1 tbsp",
        description: "Honey",
      },
      {
        quantity: "2",
        description: "Green chillies, finely chopped",
      },
      {
        quantity: "1 tbsp",
        description: "Curd",
      },
      {
        quantity: "2 tbsp",
        description: "Coriander leaves",
      },
      {
        quantity: "2 tbsp",
        description: "Mustard oil",
      },
      {
        quantity: "1 tbsp",
        description: "Lemon juice",
      },
      {
        quantity: "1 tbsp",
        description: "Red chilli powder",
      },
      {
        quantity: "2 tbsp",
        description: "coriander powder",
      },
      {
        quantity: "2 cup",
        description: " Low-fat fresh cream",
      },
      {
        quantity: "2",
        description: "Capsicum, cubes",
      },
      {
        quantity: "1/2 tbsp",
        description: "Kasoori methi",
      },
      {
        quantity: "1/2 tsp",
        description: "Butter",
      },
    ],
    Preparation: [
      {
        title: "Step 1 ",
        subtitle: "Marinate the chicken with red chili powder, lemon juice, 1 tsp ginger-garlic paste, curd, coriander powder and set aside for 1 to 2 hours.",
      },
      {
        title: "Step 2 ",
        subtitle: "Pre heat the oven to 200 degrees C and place the marinated chicken in the oven for 15 minutes.",
      },
      {
        title: "Step 3 ",
        subtitle: "To make makhani gravy, heat butter in nonstick pan.",
      },
      {
        title: "Step 4 ",
        subtitle: "Add remaining ginger garlic paste and sauté for two minutes.",
      },
      {
        title: "Step 5 ",
        subtitle: "Add the tomato puree and Knorr Chef’s Chicken Masala",
      },
      {
        title: "Step 6 ",
        subtitle: "Add 150 ml (1 cup) of water.",
      },
      {
        title: "Step 7 ",
        subtitle: "Bring the mixture to a boil, lower the flame and add honey.",
      },
      {
        title: "Step 8 ",
        subtitle: "Add the marinated cooked chicken pieces and kasoori methi powder.",
      },
      {
        title: "Step 9 ",
        subtitle: "Add low- fat fresh cream and simmer for 5 minutes.",
      },
      {
        title: "Step 10 ",
        subtitle: "Garnish with chopped coriander leaves.",
      },
      {
        title: "Step 11 ",
        subtitle: "Serve hot!",
      },
    ],
  },
  6: {
    id: 6,
    r_types: ["Appetizer", "Snack"],
    title: "Pav Bhaji Sandwich",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish26,
    duration: "30-35 min",
    isVeg: 1,
    uid: "recipe1",
    recipeDown: "",
    ingredients: [
      {
        quantity: "2 cups",
        description: "Onions",
      },
      {
        quantity: "1 cup ",
        description: "Carrot",
      },
      {
        quantity: "1/2 cup",
        description: " Capsicum",
      },
      {
        quantity: "1/4 cup",
        description: " Green peas",
      },
      {
        quantity: "2 tbsp ",
        description: "Oil",
      },
      {
        quantity: "2 tbsp ",
        description: "Pav bhaji masala",
      },
      {
        quantity: "Salt",
        description: "To taste",
      },
      {
        quantity: "20-22",
        description: "Slices of bread",
      },
      {
        quantity: "As required",
        description: "Butter/olive oil",
      },
    ],
    Preparation: [
      {
        title: "Step 1 ",
        subtitle: "Heat oil in a kadhai or non-stick pan.",
      },
      {
        title: "Step 2 ",
        subtitle: "Add onions and sauté for 1-2 minutes till they are translucent",
      },
      {
        title: "Step 3 ",
        subtitle: "Add capsicum and sauté for a minute",
      },
      {
        title: "Step 4 ",
        subtitle: "Add carrot and green peas and sauté for another minute.",
      },
      {
        title: "Step 5 ",
        subtitle: "Add pav bhaji masala and salt.",
      },
      {
        title: "Step 6 ",
        subtitle: "Mix well and cook for 2-3 minutes mixing in between.",
      },
      {
        title: "Step 7 ",
        subtitle: "Transfer the filling to a bowl and let it cool slightly.",
      },
      {
        title: "Step 8 ",
        subtitle: "Fill between two slices of bread and grill on tava or a sandwich maker using butter or olive oil.",
      },
      {
        title: "Step 9 ",
        subtitle: "You can add the cheese slice to the sandwich before grilling.",
      },
      {
        title: "Step 10 ",
        subtitle: "Serve hot with ketchup.",
      },
    ],
  },
  7: {
    id: 7,
    title: "Keema Aloo Muttar Curry",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish20,
    duration: "30-45 min",
    isVeg: 1,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  8: {
    id: 8,
    title: "Okra Fry",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish27,
    duration: "30-45 min",
    isVeg: 1,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  9: {
    id: 9,
    r_types: ["Main Course"],
    title: "Tandoori Murgh",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 1,
    logoUrl: Dish21,
    duration: "45-60 min",
    isVeg: 0,
    uid: "recipe1",
    recipeDown: RecipeDown13,
    ingredients: [
      {
        quantity: "1 kg",
        description: "Chicken",
      },
      {
        quantity: "4 tbsp  ",
        description: "Yoghurt/curd",
      },
      {
        quantity: "2 tbsp",
        description: "Vinegar or lemon juice",
      },
      {
        quantity: "2 tbsp",
        description: "Ginger-garlic paste",
      },
      {
        quantity: "4 tbsp ",
        description: "Vegetable oil",
      },
      {
        quantity: "1 tsp",
        description: "Ground pepper",
      },
      {
        quantity: "1 tsp",
        description: "Red chilli powder",
      },
      {
        quantity: "1 tbsp ",
        description: "Kasoori methi",
      },
      {
        quantity: "1 tbsp ",
        description: "Tandoori masala or garam masala",
      },
      {
        quantity: "1 tsp ",
        description: "Red food colour",
      },
    ],
    Preparation: [
      {
        title: "Step 1 ",
        subtitle: "Mix together all the ingredients (except chicken) and let it rest for some time.",
      },
      {
        title: "Step 2 ",
        subtitle: "Remove the skin & clean the chicken.",
      },
      {
        title: "Step 3 ",
        subtitle: "Make deep gashes in the chicken.",
      },
      {
        title: "Step 4 ",
        subtitle: "Now marinate the chicken well with the spice blend, rub evenly inside-out.",
      },
      {
        title: "Step 5 ",
        subtitle: "Let it rest in the refrigerator for at least 8 hours",
      },
      {
        title: "Step 6 ",
        subtitle: "Preheat oven to 180-190 degree",
      },
      {
        title: "Step 7 ",
        subtitle: "Grill the chicken for an hour or so (changing sides after 30mins).",
      },
      {
        title: "Step 8 ",
        subtitle: "Brush oil to the sides while turning.",
      },
      {
        title: "Step 9 ",
        subtitle: "Towards the end increase the temperature above 200 degrees to allow browning of the top surface.",
      },
      {
        title: "Step 10 ",
        subtitle: "Remove from oven when cooked, sprinkle some parsley & ground pepper.",
      },
      {
        title: "Step 11 ",
        subtitle: "Serve hot with salad, lemon wedges & mint chutney.",
      },
    ],
  },
  10: {
    id: 10,
    title: "Tandoori Tikka",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish30,
    duration: "1hr 15 mins",
    isVeg: 1,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  11: {
    id: 11,
    title: "Boiled Egg",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish2,
    duration: "30-45 min",
    isVeg: 1,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  12: {
    id: 12,
    title: "Chicken Biryani",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish9,
    duration: "30-45 min",
    isVeg: 0,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  13: {
    id: 13,
    title: "Cinnamon Garlic Chicken",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish13,
    duration: "30-45 min",
    isVeg: 0,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  14: {
    id: 14,
    title: "Cinnamon Chocolate Chip Cookies",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish12,
    duration: "30-45 min",
    isVeg: 1,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  15: {
    id: 15,
    title: "Curry Pakoda",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish16,
    duration: "30-45 min",
    isVeg: 1,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  16: {
    id: 16,
    title: "Spicy Masala Peas",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish24,
    duration: "30-45 min",
    isVeg: 1,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  17: {
    id: 17,
    title: "Hyderabadi Dum Mutton Biryani",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish18,
    duration: "30-45 min",
    isVeg: 0,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  18: {
    id: 18,
    title: "Gatte Ke Sabji",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish17,
    duration: "30-45 min",
    isVeg: 1,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  19: {
    id: 19,
    title: "Brinjal Curry",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish7,
    duration: "30-45 min",
    isVeg: 1,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  20: {
    id: 20,
    title: "Sprouted Moong",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish23,
    duration: "30-45 min",
    isVeg: 1,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  21: {
    id: 21,
    title: "Chicken Nuggets",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish11,
    duration: "30-45 min",
    isVeg: 0,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  22: {
    id: 22,
    title: "Aloo Paneer",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish5,
    duration: "30-45 min",
    isVeg: 1,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  23: {
    id: 23,
    title: "Kucho Nimki",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish29,
    duration: "30-45 min",
    isVeg: 1,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  24: {
    id: 24,
    title: "Crispy Nimki",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish15,
    duration: "30-45 min",
    isVeg: 1,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  25: {
    id: 25,
    title: "Kaushambir",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish19,
    duration: "30-45 min",
    isVeg: 1,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  26: {
    id: 26,
    title: "Amla Sabzi",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish6,
    duration: "30-45 min",
    isVeg: 1,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  27: {
    id: 27,
    title: "Samosa",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish25,
    duration: "30-45 min",
    isVeg: 1,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  28: {
    id: 28,
    title: "Chana Masala",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish8,
    duration: "30-45 min",
    isVeg: 1,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  29: {
    id: 29,
    title: "Chicken Ghee Roast",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish10,
    duration: "30-45 min",
    isVeg: 0,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  30: {
    id: 30,
    title: "coconut rice",
    desc:
      "White Salt, Dry Mango, Black Salt, Mint Leaves, Cumin Seeds, Citric Acid, Dry Ginger, Bishop's Weed, Asafoetida, Tamarind Seedless, Black Pepper, Sat-ammoniac, Yellow Chilli",
    recipeName: "Paneer Butter Masala",
    isActive: 0,
    logoUrl: Dish14,
    duration: "30-45 min",
    isVeg: 1,
    uid: "recipe1",
    ingredients: [
      "2 cups paneer, cubed (or cottage cheese)",
      "1 inch ginger",
      "3 cloves garlic, minced",
      "2 tablespoons cashews",
      "1 white onion, diced",
      "5-6  whole tomatoes, chopped or pureed",
      "1 tbsp BMC Garam Masala",
      "2 tbsp coconut cream",
      "Salt, to taste",
    ],
    Preparation:
      "<p>1. In a large skillet or wok (kadhai), heat a tablespoon of vegetable oil. Add the diced onion and saute, 5-6 minutes, until transparent and browned. Add BMC&rsquo;s garam masala, salt, cashews, garlic &amp; ginger and saute, just for a couple of minutes until the spices do their magic and are even more fragrant than before.</p><p>2. Add the chopped tomatoes and let brown, another 5-6 minute. Let cool and blend into a smooth paste.</p><p>3. In the same pan, add more oil and then the prepared curry paste with 1/2 cup water. Bring to a boil &amp; then simmer on low for 30 minutes. Add cubes of paneer, a dollop of cream and let simmer, another 10-15 minutes. Tip: Fried cubes of paneer also work well, if they are not consumed before the dish is complete!</p>",
  },
  31: {
    id: 31,
    r_types: ["Main Course"],
    title: "Turmeric Lemon Rice",
    desc:
      "Turmeric Lemon Rice Recipe. Golden Rice with turmeric, lemon and mustard seeds. Use cooked brown rice, quinoa, millet or couscous or cauliflower rice for variation. Easy side. Indian lemon turmeric rice. Vegan Gluten-free Soy-free Recipe",
    recipeName: "Turmeric Lemon Rice",
    isActive: 1,
    logoUrl: Dish34,
    duration: "10-15 min",
    prepTime: "5 min",
    cookTime: "10 min",
    serve: 2,
    isVeg: 1,
    uid: "recipe1",
    recipeDown: RecipeDown15,
    ingredients: [
      {
        quantity: "1.5 - 2 cups",
        description: "Cooked rice",
      },
      {
        quantity: "1 tsp",
        description: "Oil high smoke point oils like organic safflower or organic canola",
      },
      {
        quantity: "1/2 tsp",
        description: "Mustard seeds preferably black mustard seeds",
      },
      {
        quantity: "8 to 10 ",
        description: "Curry leaves fresh or frozen, whole or chopped",
      },
      {
        quantity: "2-3 tbsp ",
        description: "Toasted cashews or peanuts optional",
      },
      {
        quantity: "1/2 - 3/4 tsp",
        description: "BMC Turmeric Powder (Haldi)",
      },
      {
        quantity: "1/3 tsp",
        description: "Red pepper flakes",
      },
      {
        quantity: "2",
        description: "Broken red chilies",
      },
      {
        quantity: "2 tbsp",
        description: "Lemon juice",
      },
      {
        quantity: "1 tsp",
        description: "Cilantro for garnish",
      },
    ],
    Preparation: [
      {
        title: "Step 1",
        subtitle: "Cook the rice, fluff and keep aside or let the rice or other cooked",
      },
      {
        title: "Step 2 ",
        subtitle: "Grains you plan to use, come to room temp.",
      },
      {
        title: "Step 3 ",
        subtitle: "Heat oil in a skillet over medium heat. When the oil is hot, add mustard",
      },
      {
        title: "Step 4 ",
        subtitle: "Seeds and let them start to pop. I usually check the oil by adding 2-3 ",
      },
      {
        title: "Step 5 ",
        subtitle: "Seeds. If they start to sizzle immediately or pop, the oil is ready.",
      },
      {
        title: "Step 6 ",
        subtitle: "Add curry leaves and wait for a few seconds. Add BMC Turmeric Powder and",
      },
      {
        title: "Step 7 ",
        subtitle:
          "Red pepper flakes and mix in. Reduce heat to medium low. At this point, you can add roasted nuts (cashews or peanuts) or peas or both and mix in.",
      },
      {
        title: "Step 8 ",
        subtitle: "Add a splash of water to reduce the temperature of the pan, then add the lemon juice",
      },
      {
        title: "Step 9",
        subtitle: "Add a splash of water to reduce the temperature of the pan, then add",
      },
      {
        title: "Step 10",
        subtitle: "Add in the rice and mix in well. Add salt if the cooked rice was not salted.",
      },
      {
        title: "Step 11",
        subtitle: "Cook for 2 mins. Taste and adjust salt and lemon. Cover and take off heat. ",
      },
      {
        title: "Step 12",
        subtitle: "Let it sit for 2 mins before serving. Garnish with cilantro. ",
      },
    ],
  },
  32: {
    id: 32,
    r_types: ["Appetizer", "Snack"],
    title: "Dhokla",
    desc:
      "You don’t have to be from Gujarat to have tasted a khaman dhokla. A thick fermented gram flour and yogurt batter steamed till it’s like a soft fluffy pillow. Cooled, cut into squares tempered with mustard seeds and garnished with fresh coriander and scraped coconut – a dhokla is Gujarat’s pride. This very same dhokla can be crumbed and served with accompaniments like assorted chutneys, fried green chillies and a delicious raw papaya salad in a different avatar known as khaman. My mother-in-law adds a pinch of sugar to the batter to match every Gujarati’s love for a hint of sweetness in their food. Minus the time it takes for fermentation, it is a quick recipe which makes a delicious snack anytime of the day.",
    recipeName: "Dhokla",
    isActive: 1,
    logoUrl: Dish33,
    duration: "26-30 minutes",
    prepTime: "3.30 - 4 hour",
    cookTime: "25 -30 min",
    serve: 4,
    isVeg: 1,
    uid: "recipe1",
    recipeDown: RecipeDown6,
    ingredients: [
      {
        quantity: "2 cups",
        description: "Gram flour (Besan) sieved",
      },
      {
        quantity: "1 cup",
        description: "Yogurt beaten",
      },
      {
        quantity: "Salt",
        description: " To taste",
      },
      {
        quantity: "1/2 teaspoon",
        description: "BMC Turmeric Powder (Haldi) ",
      },
      {
        quantity: "1 teaspoon ",
        description: "Green chilli-ginger paste  ",
      },
      {
        quantity: "2 tablespoons",
        description: "Oil ",
      },
      {
        quantity: "1 tablespoon",
        description: "Lemon juice",
      },
      {
        quantity: "1 teaspoon",
        description: "Soda bicarbonate",
      },
      {
        quantity: "1 teaspoon",
        description: "Mustard seeds",
      },
      {
        quantity: "2 tablespoons ",
        description: "Fresh coriander leaves chopped",
      },
      {
        quantity: "1/2 cup",
        description: "Coconut scraped",
      },
      {
        quantity: "to taste",
        description: "BMC Asafoetida (Hing)",
      },
    ],
    Preparation: [
      {
        title: "Step 1 ",
        subtitle: "Take gram flour in a bowl. Add yogurt and approximately one cup of warm water and mix. Avoid lumps. Add salt and mix again.",
      },
      {
        title: "Step 2 ",
        subtitle:
          "Leave it aside to ferment for three to four hours. When gram flour mixture has fermented, add turmeric powder and green chili-ginger paste. Mix. Heat the steamer. Grease a thali.",
      },
      {
        title: "Step 3 ",
        subtitle:
          "In a small bowl take lemon juice, soda bicarbonate, one teaspoon of oil and mix. Add it to the batter and whisk briskly. Pour batter into the greased thali and place it in the steamer.",
      },
      {
        title: "Step 4 ",
        subtitle: "Cover with the lid and steam for ten minutes. When a little cool, cut into squares and keep in a serving bowl/plate.",
      },
      {
        title: "Step 5 ",
        subtitle: "Heat remaining oil in a small pan. Add mustard seeds. When the seeds begin to crackle, remove and pour over the dhoklas. ",
      },
      {
        title: "Step 6 ",
        subtitle: "Serve, garnished with chopped coriander leaves and scraped coconut.",
      },
    ],
  },
  33: {
    id: 33,
    r_types: ["Dessert"],
    title: "Khandvi ",
    desc:
      "This Gujarati snack is a treat to eat but can be a little tricky to make. Gram flour and yogurt flavoured with green chilli paste are cooked into a lump free mixture smeared on a greased surface, rolled into a pinwheel and then tempered with mustard seeds, fresh coriander and coconut. Getting your perfect khandvi can take a bit of practice, but you won’t be complaining because even the scraps from this fun activity taste just as delicious.",
    recipeName: "Khandvi",
    isActive: 1,
    logoUrl: Dish32,
    duration: "16-20 minutes",
    prepTime: "25 - 30 min",
    cookTime: "15 - 20 min",
    serve: 4,
    isVeg: 1,
    uid: "recipe1",
    recipeDown: RecipeDown8,
    ingredients: [
      {
        quantity: "1 1/4 cups",
        description: "Gram flour (Besan)",
      },
      {
        quantity: "1 cup",
        description: "Yogurt",
      },
      {
        quantity: "1 inch",
        description: "Ginger",
      },
      {
        quantity: "2",
        description: "Green chillies  ",
      },
      {
        quantity: "4 tablespoons",
        description: "Oil  ",
      },
      {
        quantity: "Salt ",
        description: "To taste ",
      },
      {
        quantity: "1/2 teaspoon",
        description: "BMC Turmeric Powder (Haldi) ",
      },
      {
        quantity: "1 tablespoon",
        description: "Lemon juice ",
      },
      {
        quantity: "A pinch",
        description: "BMC Asafoetida (Hing)",
      },
      {
        quantity: "1 teaspoon",
        description: "Mustard seeds ",
      },
      {
        quantity: "2 teaspoons",
        description: "Coconut scraped ",
      },
      {
        quantity: "Few sprigs chopped",
        description: "Fresh coriander leaves",
      },
    ],
    Preparation: [
      {
        title: "Step 1 ",
        subtitle:
          "Sieve besan and keep in a bowl. Grind ginger and green chillies. Grease the reverse side of a few thalis or marble table top with a little oil. Make buttermilk with yogurt and half a cup of water ",
      },
      {
        title: "Step 2 ",
        subtitle:
          "Mix the besan with ginger-green chilli paste, salt, BMC Turmeric Powder (Haldi), lemon juice and buttermilk, taking care that no lumps remain.",
      },
      {
        title: "Step 3 ",
        subtitle:
          "Cook this mixture, stirring continuously, in a thick bottomed pan till it becomes a smooth thick batter. It takes a little time to get ready.",
      },
      {
        title: "Step 4 ",
        subtitle:
          "Quickly spread portions of the mixture over the greased inverted thalis or marble table top as thinly as possible while the batter is still hot.",
      },
      {
        title: "Step 5 ",
        subtitle:
          "When cool, cut into strips two inches wide and roll them tightly. Heat two tablespoons of oil and add a pinch of BMC Asafoetida (Hing) and mustard seeds. ",
      },
      {
        title: "Step 6 ",
        subtitle: "When they splutter, pour over the pieces. Serve garnished with scraped coconut and chopped coriander leaves.",
      },
      {
        title: "Chef's Tip ",
        subtitle:
          "Cook this mixture, stirring continuously, in a thick bottomed pan till it becomes a smooth thick batter. It takes a little time to get ready.",
      },
      {
        title: "Step 8 ",
        subtitle: "Making Khandvi is an art. It takes some practice to get the correct consistency after cooking. Try out a small portion first.",
      },
    ],
  },
  34: {
    id: 34,
    r_types: ["Main Course"],
    title: "Jadoh",
    desc:
      "This Gujarati snack is a treat to eat but can be a little tricky to make. Gram flour and yogurt flavoured with green chilli paste are cooked into a lump free mixture smeared on a greased surface, rolled into a pinwheel and then tempered with mustard seeds, fresh coriander and coconut. Getting your perfect khandvi can take a bit of practice, but you won’t be complaining because even the scraps from this fun activity taste just as delicious.",
    recipeName: "Jadoh",
    isActive: 1,
    logoUrl: Dish40,
    duration: "50 - 60 minutes",
    prepTime: "10 min",
    cookTime: "50 - 60 min",
    serve: 2,
    isVeg: 1,
    uid: "recipe1",
    recipeDown: RecipeDown7,
    ingredients: [
      {
        quantity: "2 cups",
        description: "Hill rice or any short-grained rice (preferably red rice) ",
      },
      {
        quantity: "300 gm",
        description: "Fresh pork",
      },
      {
        quantity: "1",
        description: " Medium-sized onion (chopped)",
      },
      {
        quantity: "2 teaspoon",
        description: "Ginger paste",
      },
      {
        quantity: "½ tSP",
        description: "BMC Turmeric Powder (Haldi Powder)",
      },
      {
        quantity: "1 tsp ",
        description: " BMC Black Pepper Powder ",
      },
      {
        quantity: "¾th tsp",
        description: " BMC Coriander Powder (Dhania Powder) ",
      },
      {
        quantity: "2",
        description: "Bay leaves",
      },
      {
        quantity: "To taste",
        description: " Salt",
      },
    ],
    Preparation: [
      {
        title: "Step 1 ",
        subtitle: "Wash rice thoroughly and drain. Chop the pork into small (1-1.5-inch) cubes, to make them easier to cook.",
      },
      {
        title: "Step 2 ",
        subtitle: "Heat a flat pan without oil, and put the pork pieces in it, as the the pork fat would be enough to cook it",
      },
      {
        title: "Step 3 ",
        subtitle:
          "Once the fatty bits melt, add the chopped onion, ginger paste, BMC Turmeric Powder (Haldi Powder), BM Coriander Powder (Dhania Powder) and BMC Black Pepper Powder.Let the spices cook until they separate from the fat.",
      },
      {
        title: "Step 4 ",
        subtitle: "Burn the tips of the bay leaves and drop these in the pan (traditional way), or fry the bay leaves.",
      },
      {
        title: "Step 5 ",
        subtitle:
          "Fry the pork mixed with the spices well. Add rice and fry for a few minutes. Mix all the spices, meat, and rice well until the rice looks evenly yellow from the turmeric. Add salt and four cups of warm water. ",
      },
      {
        title: "Step 6 ",
        subtitle:
          "Cover and put on simmer. If the water evaporates before the the pork or rice is cooked, add some more warm water and let it simmer until the water evaporates.",
      },
      {
        title: "Step 7 ",
        subtitle: "Garnish with cilantro and serve with fermented soya paste (Tungrymbai) and Dohneiiong (pork with sesame seeds). Serve hot.",
      },
    ],
  },
  35: {
    id: 35,
    r_types: ["Appetizer"],
    title: "Aloo Paratha",
    desc:
      "This Gujarati snack is a treat to eat but can be a little tricky to make. Gram flour and yogurt flavoured with green chilli paste are cooked into a lump free mixture smeared on a greased surface, rolled into a pinwheel and then tempered with mustard seeds, fresh coriander and coconut. Getting your perfect khandvi can take a bit of practice, but you won’t be complaining because even the scraps from this fun activity taste just as delicious.",
    recipeName: "Aloo Paratha",
    isActive: 1,
    logoUrl: Dish35,
    duration: "30 - 40 minutes",
    prepTime: "15 min",
    cookTime: "15 min",
    serve: 2,
    isVeg: 1,
    uid: "recipe1",
    recipeDown: RecipeDown1,
    ingredients: [
      {
        quantity: "2 cups",
        description: "Whole wheat flour",
      },
      {
        quantity: "To taste",
        description: "Salt",
      },
      {
        quantity: "As required",
        description: " Water",
      },
      {
        quantity: "",
        description: "For the Stuffing",
      },
      {
        quantity: "2 cups",
        description: "Boiled and mashed Potatoes",
      },
      {
        quantity: "1/4 tsp",
        description: "BMC Pomegranate Powder ",
      },
      {
        quantity: "1/4 tsp",
        description: "Crushed Coriander Seeds",
      },
      {
        quantity: "1/4 tsp",
        description: "BMC Carom Seeds (Ajowain)	",
      },
      {
        quantity: "To taste",
        description: " Salt",
      },
      {
        quantity: "1 tbsp",
        description: "BMC Dry Mango Powder (Amchoor Powder)",
      },
      {
        quantity: "1 tsp",
        description: "BMC Chaat Masala",
      },
      {
        quantity: "1 tsp",
        description: "BMC Red Mirch Powder",
      },
      {
        quantity: "1 tbsp",
        description: "Finely Chopped Green Chilies",
      },
      {
        quantity: "1/2 tsp",
        description: "BMC Garam Masala",
      },
      {
        quantity: "1/4 cup",
        description: "Finely chopped Onion",
      },
      {
        quantity: "2 tbsp",
        description: "Finely chopped Cilantro/Coriander",
      },
      {
        quantity: "1/4 tsp",
        description: "BMC Carom Seeds (Ajowain)	",
      },
      {
        quantity: "",
        description: "Other Ingredients",
      },
      {
        quantity: "",
        description: "Ghee or oil for frying	",
      },
      {
        quantity: "",
        description: "Extra wheat flour for rolling",
      },
    ],
    Preparation: [
      {
        title: "Step 1 ",
        subtitle: "Mix the flour and salt, and add water to knead to a smooth, soft dough. Cover and let the dough rest for 15-20 minutes.",
      },
      {
        title: "Step 2 ",
        subtitle:
          "Take mashed potato in a big mixing bowl. Add the stuffing ingredients one by one and mix well. Add spices or salt as per taste. Divide the stuffing, as well as the dough into balls of approximately equal size",
      },
      {
        title: "Step 3 ",
        subtitle:
          "For each dough ball, add a little dry flour and roll  each into 4 inch diameter circle. Place one potato ball in the center, gather the edges and pinch it into the center to seal it properly.",
      },
      {
        title: "Step 4 ",
        subtitle: "Flatten, and again dip into dry flour and roll it into a normal size of roti/ chappati.",
      },
      {
        title: "Step 5 ",
        subtitle:
          "On the hot tava/ non-stick pan place the rolled paratha. The pan should be hot. Cook the base side for 2-3 minutes and flip. Ghee or oil can be added to make a crispy paratha. ",
      },
      {
        title: "Step 6 ",
        subtitle:
          "Flip again once or twice until both the sides are cooked properly. Press the edges with the spatula or spoon, so that it fries well. This process is to be repeated for each paratha.",
      },
      {
        title: "Step 7 ",
        subtitle: "Serve the parathas hot with generous dollops of butter, pickle and plain yogurt.",
      },
    ],
  },
  36: {
    id: 36,
    r_types: ["Main Course"],
    title: "Macher Jhol",
    desc:
      "This Gujarati snack is a treat to eat but can be a little tricky to make. Gram flour and yogurt flavoured with green chilli paste are cooked into a lump free mixture smeared on a greased surface, rolled into a pinwheel and then tempered with mustard seeds, fresh coriander and coconut. Getting your perfect khandvi can take a bit of practice, but you won’t be complaining because even the scraps from this fun activity taste just as delicious.",
    recipeName: "Macher Jhol",
    isActive: 1,
    logoUrl: Dish36,
    duration: "20 - 30 minutes",
    prepTime: "10 min",
    cookTime: "25 min",
    serve: 4,
    isVeg: 1,
    uid: "recipe1",
    recipeDown: RecipeDown9,
    ingredients: [
      {
        quantity: "4 pieces",
        description: "Boal fish (large pieces)",
      },
      {
        quantity: "1, large",
        description: "Onion",
      },
      {
        quantity: "1, medium",
        description: "Tomato",
      },
      {
        quantity: "1",
        description: "Ginger",
      },
      {
        quantity: "5-6 cloves",
        description: "Garlic",
      },
      {
        quantity: "4 tbsp",
        description: "Mustard Oil",
      },
      {
        quantity: "1 - 2",
        description: "Dry Red Chili",
      },
      {
        quantity: "1 tsp",
        description: "BMC Cumin Seeds (Zeera)",
      },
      {
        quantity: "1 tsp",
        description: "BMC Turmeric Powder (Haldi)",
      },
      {
        quantity: "2 tsp",
        description: "BMC Red Mirch Powder",
      },
      {
        quantity: "1 tsp",
        description: "BMC Coriander Powder (Dhania Powder)",
      },
      {
        quantity: "2 tsp",
        description: "BMC Cumin Seeds (Zeera)",
      },
      {
        quantity: "1.5 tsp",
        description: "Salt",
      },
      {
        quantity: "1 tsp",
        description: "Sugar",
      },
    ],
    Preparation: [
      {
        title: "Step 1 ",
        subtitle:
          "Wash and clean fish carefully, before adding them to a large bowl. Add ½ tsp BMC Turmeric Powder (Haldi), ½ tsp salt. Drizzle ¼ tsp mustard oil on fish pieces and set aside for 15-20 minutes",
      },
      {
        title: "Step 2 ",
        subtitle:
          "Puree onion, garlic and ginger to make a thick paste. Use  2-3 tsp of water if necessary. Roughly chop tomato and make puree, without adding water.",
      },
      {
        title: "Step 3 ",
        subtitle: "Heat the remaining mustard oil in a flat bottomed pan/wok.  Add fish pieces one by one and fry until turn golden brown.",
      },
      {
        title: "Step 4 ",
        subtitle:
          "Transfer the oil in which the fish was fried to a heavy bottomed pan/ wok. Add dried red chili and cumin seeds in hot oil and allow to splutter.",
      },
      {
        title: "Step 5 ",
        subtitle:
          "Add onion mixture along with sugar & salt and fry for 1-2 mins or until paste is translucent. Add tomato puree with half of the BMC Red Mirch Powder and stir for 1 min.",
      },
      {
        title: "Step 6 ",
        subtitle:
          "Add rest of BMC Red Mirch Powder along with other ground spices and continue stirring until moisture in masala evaporates and oil floats on top. Add little water at a time and keep stirring until spotting of oil appear on the side of the pan.",
      },
      {
        title: "Step 7 ",
        subtitle:
          "Once the mixture turns to a deep red colour, with oil covering the surface, add 2 cups of warm water and bring it to boil. Add fried fish pieces one by one very carefully to the jhol/curry and allow to boil.",
      },
      {
        title: "Step 8 ",
        subtitle:
          "Once the curry starts boiling, cover the pan and cook for 10 mins on simmer. Remove cover and check if fish is cooked thoroughly. Adjust seasoning.",
      },
      {
        title: "Step 9 ",
        subtitle:
          "Remove fish pieces very gently as cooked fish is soft and delicate Transfer fish pieces in serving bowls and cover it with curry. Serve with steaming hot rice. ",
      },
    ],
  },
  37: {
    id: 37,
    r_types: ["Main Course"],
    title: "Vada Pav",
    desc:
      "This Gujarati snack is a treat to eat but can be a little tricky to make. Gram flour and yogurt flavoured with green chilli paste are cooked into a lump free mixture smeared on a greased surface, rolled into a pinwheel and then tempered with mustard seeds, fresh coriander and coconut. Getting your perfect khandvi can take a bit of practice, but you won’t be complaining because even the scraps from this fun activity taste just as delicious.",
    recipeName: "Vada Pav",
    isActive: 1,
    logoUrl: Dish39,
    duration: "20 -  30 minutes",
    prepTime: "10 min",
    cookTime: "10 min",
    serve: 4,
    isVeg: 1,
    uid: "recipe1",
    recipeDown: RecipeDown17,
    ingredients: [
      {
        quantity: "8",
        description: "Ladi pavs (small squares of white bread)",
      },
      {
        quantity: "8 tbspn",
        description: "Dry garlic chutney",
      },
      {
        quantity: "",
        description: "For the Vada Filling",
      },
      {
        quantity: "1 1/2 cups",
        description: "Boiled and mashed potatoes",
      },
      {
        quantity: "2",
        description: "Green chillies , chopped",
      },
      {
        quantity: "1 1/2 tbsp",
        description: "Grated garlic",
      },
      {
        quantity: "2 tsp",
        description: "Roughly chopped ginger",
      },
      {
        quantity: "1 tsp",
        description: "Mustard seeds ( rai / sarson)",
      },
      {
        quantity: "1/4 tsp ",
        description: "BMC Asafoetida (hing)",
      },
      {
        quantity: "6 - 8",
        description: "curry leaves",
      },
      {
        quantity: "1/2 tsp ",
        description: "BMC Turmeric Powder (haldi)",
      },
      {
        quantity: "1 tbsp",
        description: "Oil",
      },
      {
        quantity: "",
        description: "For the Outer Covering",
      },
      {
        quantity: "3/4 cup",
        description: "Besan (bengal gram flour)",
      },
      {
        quantity: "1/4 tsp",
        description: "Turmeric powder (haldi)",
      },
      {
        quantity: "A pinch",
        description: "Baking soda",
      },
      {
        quantity: "1 tsp ",
        description: "Oil",
      },
      {
        quantity: "To taste",
        description: "Salt",
      },
      {
        quantity: "4 tbspn",
        description: "Oil For deep frying",
      },
    ],
    Preparation: [
      {
        title: "Step 1 ",
        subtitle:
          "For the vada filling, start by pounding the green chillies, ginger and garlic using a mortar and pestle. Heat the oil and add the mustard seeds. When they start to splutter, add the asafoetida and curry leaves and sauté for a few seconds.",
      },
      {
        title: "Step 2 ",
        subtitle:
          "Add the pounded mixture and sauté again for a few seconds, then add the potatoes, turmeric powder and salt and mix well. Remove from the fire and cool, then divide into 8 equal portions. Shape into rounds.",
      },
      {
        title: "Step 3 ",
        subtitle: "For the outer covering, combine all ingredients in a bowl and make a batter using approximately 1/3 cup of water.",
      },
      {
        title: "Step 4 ",
        subtitle:
          "Dip each round of the vada filling into the batter and allow it to coat the mixture well. Deep fry till golden brown. Drain on absorbent paper and keep aside.",
      },
      {
        title: "Step 5 ",
        subtitle: "After slicing each pav into half, pread some dry garlic chutney inside. Place one vada in each pav and serve hot.",
      },
    ],
  },
  38: {
    id: 38,
    r_types: ["Main Course"],
    title: "Andhra Murukku",
    desc:
      "This Gujarati snack is a treat to eat but can be a little tricky to make. Gram flour and yogurt flavoured with green chilli paste are cooked into a lump free mixture smeared on a greased surface, rolled into a pinwheel and then tempered with mustard seeds, fresh coriander and coconut. Getting your perfect khandvi can take a bit of practice, but you won’t be complaining because even the scraps from this fun activity taste just as delicious.",
    recipeName: "Andhra Murukku",
    isActive: 1,
    logoUrl: Dish38,
    duration: "35 - 40 minutes",
    prepTime: "30 min",
    cookTime: "20 min",
    serve: 2,
    isVeg: 1,
    uid: "recipe1",
    recipeDown: RecipeDown2,
    ingredients: [
      {
        quantity: "1 cup",
        description: "Rice Flour",
      },
      {
        quantity: "1 tsp",
        description: "Moong Dal",
      },
      {
        quantity: "1 tbsp",
        description: "Ghee",
      },
      {
        quantity: "1 cup",
        description: "Water",
      },
      {
        quantity: "To taste",
        description: "Salt",
      },
      {
        quantity: "1 tsp",
        description: "BMC Mirchi Powder",
      },
      {
        quantity: "1/2 tsp",
        description: "Cumin seed",
      },
      {
        quantity: "2 -3 tbsp",
        description: "Oil for frying",
      },
    ],
    Preparation: [
      {
        title: "Step 1 ",
        subtitle:
          "Soak the moong dal for 1/2 hr. Heat the water with moong dal, salt & ghee. When the water is about to come to a boil, add flour, switch off flame, and mix well.",
      },
      {
        title: "Step 2 ",
        subtitle: "Taking small portions of dough, roll into rope-like shape and then make small circles by joining the edges ",
      },
      {
        title: "Step 3 ",
        subtitle: "Make the same shapes with the remaining dough. Heat the oil, and fry until golden brown.",
      },
      {
        title: "Step 4 ",
        subtitle: "Crispy Murukku is ready to serve.",
      },
    ],
  },
  39: {
    id: 39,
    r_types: ["Main Course"],
    title: "Utthapam with Samber",
    desc:
      "This Gujarati snack is a treat to eat but can be a little tricky to make. Gram flour and yogurt flavoured with green chilli paste are cooked into a lump free mixture smeared on a greased surface, rolled into a pinwheel and then tempered with mustard seeds, fresh coriander and coconut. Getting your perfect khandvi can take a bit of practice, but you won’t be complaining because even the scraps from this fun activity taste just as delicious.",
    recipeName: "Utthapam with Samber",
    isActive: 1,
    logoUrl: Dish37,
    duration: "21 - 25 minutes",
    prepTime: "26 - 30 min",
    cookTime: "20 min",
    serve: 4,
    isVeg: 1,
    uid: "recipe1",
    recipeDown: RecipeDown16,
    ingredients: [
      {
        quantity: "1/2 cup",
        description: "Toor/ Arhar Dal ",
      },
      {
        quantity: "1/4 cup",
        description: "BMC Turmeric Powder (Haldi)",
      },
      {
        quantity: "4 tbsp",
        description: "Oil ",
      },
      {
        quantity: "1 lemon sized ball",
        description: "Tamarind",
      },
      {
        quantity: "1/2 tsp",
        description: "Mustard seeds ",
      },
      {
        quantity: "4",
        description: "Whole dry red chillies broken",
      },
      {
        quantity: "1/2 teaspoon",
        description: "Fenugreek seeds (methi dana)",
      },
      {
        quantity: "1/4 teaspoon",
        description: "BMC Asafoetida (Hing)",
      },
      {
        quantity: "4",
        description: "Green chillies slit",
      },
      {
        quantity: "10 - 12",
        description: "Curry leaves ",
      },
      {
        quantity: "2",
        description: "Drumsticks 2½ inch pieces",
      },
      {
        quantity: "1 1/2 tsp",
        description: "BMC Samber Powder ",
      },
      {
        quantity: "To taste",
        description: "Salt",
      },
    ],
    Preparation: [
      {
        title: "Step 1 ",
        subtitle:
          "Cook the dal in a pressure cooker with two and a half cups of water, BMC Turmeric Powder (Haldi) and one teaspoon oil for three whistles. Open lid once the pressure has reduced and mash the cooked dal lightly with a wooden spoon.",
      },
      {
        title: "Step 2 ",
        subtitle: "Soak tamarind in a cup of warm water. Extract the pulp and keep aside.",
      },
      {
        title: "Step 3 ",
        subtitle:
          "Heat the remaining oil in a thick-bottomed pan. Add mustard seeds and when they start spluttering, add dry red chillies, fenugreek seeds and BMC Asafoetida (Hing).",
      },
      {
        title: "Step 4 ",
        subtitle:
          "Stir and add green chillies, curry leaves and drumsticks and cook for one minute on medium heat. Add BMC Samber Powder, salt and one cup water.",
      },
      {
        title: "Step 5 ",
        subtitle: "Reduce heat and simmer for approx. 8 minutes or till drumsticks are cooked. Add tamarind pulp, boiled dal and simmer for 2-3 minutes.",
      },
      {
        title: "Step 6 ",
        subtitle: "Serve hot with steamed rice and papad.",
      },
    ],
  },
  40: {
    id: 40,
    r_types: ["Main Course"],
    title: "Rajgira Puri",
    desc: "",
    recipeName: "Rajgira Puri",
    isActive: 1,
    logoUrl: Dish41,
    duration: "30 - 35 minutes",
    prepTime: "26 - 30 min",
    cookTime: "10 - 15 min",
    serve: 4,
    isVeg: 1,
    uid: "recipe1",
    recipeDown: RecipeDown12,
    ingredients: [
      {
        quantity: "1 cup",
        description: "Amaranth (rajgira) flour",
      },
      {
        quantity: "2-3 medium",
        description: "Potatoes, boiled and peeled",
      },
      {
        quantity: "3 teaspoons",
        description: "Ginger-Green Chilli paste",
      },
      {
        quantity: "1 tablespoon",
        description: "Fresh Coriander leaves, chopped",
      },
      {
        quantity: "To taste",
        description: "BMC Rock Salt (sendha namak",
      },
      {
        quantity: "2 tablespoons",
        description: "Ghee",
      },
    ],
    Preparation: [
      {
        title: "Step 1 ",
        subtitle:
          "Grate potatoes into a bowl. Add ginger-green chilli paste, coriander leaves and BMC Rock Salt and mix well. Add the amaranth flour, a little at a time, mix well and knead into a stiff dough. Add ghee and knead again. Set aside for 10-15 minutes.",
      },
      {
        title: "Step 2 ",
        subtitle:
          "Heat sufficient ghee in a kadai. Divide the dough into small portions and roll into roughly equal sized balls. Place each ball on a greased surface and gently pat into a puri, or use a rolling pin for the traditional way to make small circles of dough. ",
      },
      {
        title: "Step 3 ",
        subtitle: "Deep-fry puris in hot oil, one by one, till puffed up and golden. Serve hot, with a delicious gravy dish like bedami aloo.",
      },
    ],
  },
  41: {
    id: 41,
    r_types: ["Snack"],
    title: "Dahi ke Angare",
    desc: "",
    recipeName: "Dahi ke Angare",
    isActive: 1,
    logoUrl: Dish42,
    duration: "30 - 35 minutes",
    prepTime: "26 - 30 min",
    cookTime: "10 - 15 min",
    serve: 4,
    isVeg: 1,
    uid: "recipe1",
    recipeDown: RecipeDown5,
    ingredients: [
      {
        quantity: "1 cup",
        description: "Hung yogurt",
      },
      {
        quantity: "1/2 cup",
        description: "Processed Cheese grated",
      },
      {
        quantity: "2",
        description: "Green Chillies chopped",
      },
      {
        quantity: "1 tablespoon",
        description: "Fresh Coriander leaves finely chopped",
      },
      {
        quantity: "2 tablespoons",
        description: "Green Peas crushed",
      },
      {
        quantity: "2 tablespoons",
        description: "Corn Kernels crushed",
      },
      {
        quantity: "1",
        description: "Medium Onion finely chopped",
      },
      {
        quantity: "1 teaspoon",
        description: "BMC Dried Mango (amchur) Powder",
      },
      {
        quantity: "1 teaspoon",
        description: "BMC Red Chilli Powder",
      },
      {
        quantity: "To taste",
        description: "Salt",
      },
      {
        quantity: "8-12 slices",
        description: "White bread",
      },
      {
        quantity: "",
        description: "Refined flour slurry for brushing",
      },
      {
        quantity: "",
        description: "Oil to deep fry",
      },
    ],
    Preparation: [
      {
        title: "Step 1 ",
        subtitle: "Add the yogurt, cheese, green chillies, coriander lead, peas, corn, onion, BMC Dried Mango Powder, BMC Chilli Powder and salt to a bowl. ",
      },
      {
        title: "Step 2 ",
        subtitle:
          "Cut the crust off the bread slices, and flatten them. Place a dollop of yogurt mixture in the middle of each slice, brush edges with slurry and roll into cylinders.",
      },
      {
        title: "Step 3 ",
        subtitle:
          "Heat oil in a deep bottomed pan for frying. Deep-fry the bread rolls till golden brown. Drain on absorbent paper. Serve hot with fresh green pudina chutney.",
      },
      {
        title: "Step 4 ",
        subtitle: "Deep-fry the rolls in hot oil, one by one, till puffed up and golden. Drain on absorbent paper.",
      },
      {
        title: "Step 5 ",
        subtitle: "Serve hot.",
      },
    ],
  },
  42: {
    id: 42,
    r_types: ["Main Course"],
    title: "Pooran Poli",
    desc: "",
    recipeName: "Pooran Poli",
    isActive: 1,
    logoUrl: Dish43,
    duration: "30 - 35 minutes",
    prepTime: "26 - 30 min",
    cookTime: "10 - 15 min",
    serve: 4,
    isVeg: 1,
    uid: "recipe1",
    recipeDown: RecipeDown11,
    ingredients: [
      {
        quantity: "1 cup",
        description: "Powdered Jaggery (gur)",
      },
      {
        quantity: "1 cup",
        description: "Spilt Bengal Gram (chana dal)",
      },
      {
        quantity: "3 cups",
        description: "Water",
      },
      {
        quantity: "4 teaspoons",
        description: "Ghee",
      },
      {
        quantity: "1 teaspoon",
        description: "BMC Fennel (Badian) Powder",
      },
      {
        quantity: "tsp ¾ to 1",
        description: "BMC Ginger Powder",
      },
      {
        quantity: "4-5",
        description: "Cardamom powdered",
      },
      {
        quantity: "¼ teaspoon",
        description: "Nutmeg Powder",
      },
      {
        quantity: "1.5 cups",
        description: "Whole Wheat Flour",
      },
      {
        quantity: "To Taste",
        description: "Salt",
      },
      {
        quantity: " ¼ teaspoon",
        description: "BMC Turmeric (Haldi) Powder",
      },
    ],
    Preparation: [
      {
        title: "Step 1 ",
        subtitle:
          "For the ‘puran’, start by washing the chana dal in water. Add to the pressure cooker and cook for 6-7 whistles. After this, drain out the excess water.",
      },
      {
        title: "Step 2 ",
        subtitle:
          "Add ghee to a non-stick pan. Once hot, add BMC Ginger Powder, nutmeg powder, cardamom powder and BMC Fennel Powder. Stir until the spices are roasted. Add jaggery and chana dal.",
      },
      {
        title: "Step 3 ",
        subtitle:
          "Cook the mixture on low flame until all the water has evaporated and the mixture is completely dry. Stir continuously.  Once the mixture is thick, turn off the heat, cool the mixture and blend for smoothness.",
      },
      {
        title: "Step 4 ",
        subtitle:
          "Move onto the poli dough. Add the wheat flour and salt to a bowl, and mix welll. Add water, ghee and knead to a smooth dough. Keep the dough aside and let it sit for 15-20 minutes.",
      },
      {
        title: "Step 5 ",
        subtitle: "Divide the dough into medium sized, roughly equal balls. Roll each to 2-3 inches in circumference, with a dusted rolling pin.",
      },
      {
        title: "Step 6 ",
        subtitle: "Place the puran mixture in the centre of the rolled dough, and bring the edges to the centre to join and close.",
      },
      {
        title: "Step 7 ",
        subtitle:
          "Add ghee to a hot tawa. Place the rolled up poli on the tawa. Cook evenly on each side, until brown. Serve hot, with an extra dollop of ghee.",
      },
    ],
  },
  43: {
    id: 43,
    r_types: ["Main Course"],
    title: "Christmas Mulled Wine",
    desc: "",
    recipeName: "Christmas Mulled Wine",
    isActive: 1,
    logoUrl: Dish44,
    duration: "6 - 10 minutes",
    prepTime: "6 - 10 min",
    cookTime: "10 - 15 min",
    serve: 4,
    isVeg: 1,
    uid: "recipe1",
    recipeDown: RecipeDown5,
    ingredients: [
      {
        quantity: "500 millilitres",
        description: "Red Wine",
      },
      {
        quantity: "1",
        description: "Spices cut into small pieces",
      },
      {
        quantity: "1",
        description: "Apple chopped",
      },
      {
        quantity: "2 Tablespoons",
        description: "Brown sugar",
      },
      {
        quantity: "2 Tablespoons",
        description: "BMC Cinnamon Powder",
      },
      {
        quantity: "4-5",
        description: "Bawa Brand Cloves",
      },
      {
        quantity: "2",
        description: "Star anise",
      },
    ],
    Preparation: [
      {
        title: "Step 1 ",
        subtitle: "Heat red wine in a deep non-stick pan.",
      },
      {
        title: "Step 2 ",
        subtitle:
          "Heat orange peel pieces and add in the pan alongwith apple pieces, brown sugar, BMC Cinnamon Powder, Bawa Brand Cloves and star anise. Stir well and simmer for 2-3 minutes.",
      },
      {
        title: "Step 3 ",
        subtitle: "Pour the drink into individual glasses alongwith the apple pieces.",
      },
      {
        title: "Step 4 ",
        subtitle: "Serve warm",
      },
    ],
  },
  44: {
    id: 44,
    r_types: ["Main Course"],
    title: "Coconut Burfi",
    desc: "",
    recipeName: "Coconut Burfi",
    isActive: 1,
    logoUrl: Dish45,
    duration: "31 - 40 minutes",
    prepTime: "11 - 15 min",
    cookTime: "10 - 15 min",
    serve: 4,
    isVeg: 1,
    uid: "recipe1",
    recipeDown: RecipeDown5,
    ingredients: [
      {
        quantity: "2 Cups",
        description: "Coconut scraped",
      },
      {
        quantity: "1 Cup",
        description: "Sugar",
      },
      {
        quantity: "1/2 Cup",
        description: "Fresh cream",
      },
      {
        quantity: "A pinch",
        description: "Bawa Brand Green cardamom powder",
      },
      {
        quantity: "2 Tablespoons",
        description: "Powdered sugar",
      },
      {
        quantity: "1/2 Tablespoon",
        description: "Ghee",
      },
    ],
    Preparation: [
      {
        title: "Step 1 ",
        subtitle:
          "Heat a non stick pan on medium heat. Add the coconut, sugar, fresh cream and Bawa Brand Green Cardamom powder and cook, stirring continuously, for fifteen minutes or till the mixtures turns a golden brown.",
      },
      {
        title: "Step 2 ",
        subtitle: "Remove from the heat and add the powdered sugar and mix. Grease a thali with ghee and pour in the coconut mixture and spread evenly.",
      },
      {
        title: "Step 3 ",
        subtitle: "When it cools cut into diamonds or squares and serve. You can store in an airtight container in the refrigerator for about a week.",
      },
    ],
  },
  45: {
    id: 45,
    r_types: ["Main Course"],
    title: "Plum Cake",
    desc: "",
    recipeName: "Plum Cake",
    isActive: 1,
    logoUrl: Dish46,
    duration: "31 - 40 minutes",
    prepTime: "11 - 15 min",
    cookTime: "10 - 15 min",
    serve: 4,
    isVeg: 1,
    uid: "recipe1",
    recipeDown: RecipeDown5,
    ingredients: [
      {
        quantity: "1 Cup",
        description: "Refined flour",
      },
      {
        quantity: "3 Tablespoons",
        description: "Brown sugar chopped",
      },
      {
        quantity: "1/2 Teaspoon",
        description: "Baking powder",
      },
      {
        quantity: "2 Tablespoons",
        description: "Walnuts chopped",
      },
      {
        quantity: "1/2 Cup",
        description: "Butter softened",
      },
      {
        quantity: "1 Cup",
        description: "Brown sugar",
      },
      {
        quantity: "A few drops",
        description: "Vanilla essence",
      },
      {
        quantity: "3",
        description: "Eggs",
      },
      {
        quantity: "1 Teaspoon",
        description: "Lemon zest",
      },
    ],
    Preparation: [
      {
        title: "Step 1 ",
        subtitle:
          "Preheat the oven to 160° C. Grease a Wonderchef Pop Round Cake Pan. Sieve the flour along with baking powder into a bowl. Add the walnuts and raisins and mix.",
      },
      {
        title: "Step 2 ",
        subtitle:
          "Cream the butter and brown sugar with the vanilla essence in another bowl. Add the eggs and lemon zest, mixing continuously. Fold in sieved flour and mix.",
      },
      {
        title: "Step 3 ",
        subtitle:
          "Pour the cake batter into the greased Wonderchef Pop Round Cake Pan and bake in the preheated oven for fifteen to twenty minutes. Remove from oven and turn onto a rack to cool.",
      },
      {
        title: "Step 4 ",
        subtitle: "Slice and serve.",
      },
    ],
  },
};
export { DhoopDetails, SpiceDetails, Misc, recipes, ListContent };



// WEBPACK FOOTER //
// ./src/Constants/productListConstant.js